/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: string; output: string; }
  /** Represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Account = Node & {
  __typename?: 'Account';
  alias?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BrokerAccount` that is related to this `Account`. */
  brokerAccountByIdSs58?: Maybe<BrokerAccount>;
  /** Reads and enables pagination through a set of `BrokerAccount`. */
  brokerAccountsByIdSs58: BrokerAccountsConnection;
  /** Reads and enables pagination through a set of `Delegation`. */
  delegationsByDelegatorIdSs58: DelegationsConnection;
  idHex: Scalars['String']['output'];
  idSs58: Scalars['String']['output'];
  /** Reads a single `LpAccount` that is related to this `Account`. */
  lpAccountByIdSs58?: Maybe<LpAccount>;
  /** Reads and enables pagination through a set of `LpAccount`. */
  lpAccountsByIdSs58: LpAccountsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `Account`. */
  operatorByIdSs58?: Maybe<Operator>;
  /** Reads and enables pagination through a set of `Operator`. */
  operatorsByIdSs58: OperatorsConnection;
  /** Reads a single `Unregistered` that is related to this `Account`. */
  unregisteredByIdSs58?: Maybe<Unregistered>;
  /** Reads and enables pagination through a set of `Unregistered`. */
  unregisteredsByIdSs58: UnregisteredsConnection;
  /** Reads a single `Validator` that is related to this `Account`. */
  validatorByIdSs58?: Maybe<Validator>;
  /** Reads and enables pagination through a set of `Validator`. */
  validatorsByIdSs58: ValidatorsConnection;
};


export type AccountBrokerAccountsByIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountCondition>;
  filter?: InputMaybe<BrokerAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountsOrderBy>>;
};


export type AccountDelegationsByDelegatorIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationCondition>;
  filter?: InputMaybe<DelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationsOrderBy>>;
};


export type AccountLpAccountsByIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpAccountCondition>;
  filter?: InputMaybe<LpAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpAccountsOrderBy>>;
};


export type AccountOperatorsByIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorCondition>;
  filter?: InputMaybe<OperatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorsOrderBy>>;
};


export type AccountUnregisteredsByIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnregisteredCondition>;
  filter?: InputMaybe<UnregisteredFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnregisteredsOrderBy>>;
};


export type AccountValidatorsByIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};

export type AccountAggregates = {
  __typename?: 'AccountAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idHex` field. */
  idHex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
};

export type AccountDistinctCountAggregates = {
  __typename?: 'AccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idHex across the matching connection */
  idHex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `brokerAccountByIdSs58` relation. */
  brokerAccountByIdSs58?: InputMaybe<BrokerAccountFilter>;
  /** A related `brokerAccountByIdSs58` exists. */
  brokerAccountByIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `delegationsByDelegatorIdSs58` relation. */
  delegationsByDelegatorIdSs58?: InputMaybe<AccountToManyDelegationFilter>;
  /** Some related `delegationsByDelegatorIdSs58` exist. */
  delegationsByDelegatorIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `idHex` field. */
  idHex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpAccountByIdSs58` relation. */
  lpAccountByIdSs58?: InputMaybe<LpAccountFilter>;
  /** A related `lpAccountByIdSs58` exists. */
  lpAccountByIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `operatorByIdSs58` relation. */
  operatorByIdSs58?: InputMaybe<OperatorFilter>;
  /** A related `operatorByIdSs58` exists. */
  operatorByIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `unregisteredByIdSs58` relation. */
  unregisteredByIdSs58?: InputMaybe<UnregisteredFilter>;
  /** A related `unregisteredByIdSs58` exists. */
  unregisteredByIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `validatorByIdSs58` relation. */
  validatorByIdSs58?: InputMaybe<ValidatorFilter>;
  /** A related `validatorByIdSs58` exists. */
  validatorByIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Account` for usage during aggregation. */
export type AccountGroupBy =
  | 'ALIAS';

/** Conditions for `Account` aggregates. */
export type AccountHavingInput = {
  AND?: InputMaybe<Array<AccountHavingInput>>;
  OR?: InputMaybe<Array<AccountHavingInput>>;
};

export type AccountLink = Node & {
  __typename?: 'AccountLink';
  accountIdSs58: Scalars['String']['output'];
  ethereumAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type AccountLinkAggregates = {
  __typename?: 'AccountLinkAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountLinkAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountLinkDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountLinkMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountLinkMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountLinkStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountLinkStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountLinkSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountLinkVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountLinkVarianceSampleAggregates>;
};

export type AccountLinkAverageAggregates = {
  __typename?: 'AccountLinkAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountLink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AccountLinkCondition = {
  /** Checks for equality with the object’s `accountIdSs58` field. */
  accountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ethereumAddress` field. */
  ethereumAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountLinkDistinctCountAggregates = {
  __typename?: 'AccountLinkDistinctCountAggregates';
  /** Distinct count of accountIdSs58 across the matching connection */
  accountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ethereumAddress across the matching connection */
  ethereumAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AccountLink` object types. All fields are combined with a logical ‘and.’ */
export type AccountLinkFilter = {
  /** Filter by the object’s `accountIdSs58` field. */
  accountIdSs58?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountLinkFilter>>;
  /** Filter by the object’s `ethereumAddress` field. */
  ethereumAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountLinkFilter>>;
};

/** Grouping methods for `AccountLink` for usage during aggregation. */
export type AccountLinkGroupBy =
  | 'ACCOUNT_ID_SS58'
  | 'ETHEREUM_ADDRESS';

export type AccountLinkHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountLink` aggregates. */
export type AccountLinkHavingInput = {
  AND?: InputMaybe<Array<AccountLinkHavingInput>>;
  OR?: InputMaybe<Array<AccountLinkHavingInput>>;
  average?: InputMaybe<AccountLinkHavingAverageInput>;
  distinctCount?: InputMaybe<AccountLinkHavingDistinctCountInput>;
  max?: InputMaybe<AccountLinkHavingMaxInput>;
  min?: InputMaybe<AccountLinkHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountLinkHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountLinkHavingStddevSampleInput>;
  sum?: InputMaybe<AccountLinkHavingSumInput>;
  variancePopulation?: InputMaybe<AccountLinkHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountLinkHavingVarianceSampleInput>;
};

export type AccountLinkHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkMaxAggregates = {
  __typename?: 'AccountLinkMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountLinkMinAggregates = {
  __typename?: 'AccountLinkMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountLinkStddevPopulationAggregates = {
  __typename?: 'AccountLinkStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkStddevSampleAggregates = {
  __typename?: 'AccountLinkStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkSumAggregates = {
  __typename?: 'AccountLinkSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type AccountLinkVariancePopulationAggregates = {
  __typename?: 'AccountLinkVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkVarianceSampleAggregates = {
  __typename?: 'AccountLinkVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AccountLink` values. */
export type AccountLinksConnection = {
  __typename?: 'AccountLinksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountLinkAggregates>;
  /** A list of edges which contains the `AccountLink` and cursor to aid in pagination. */
  edges: Array<AccountLinksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountLinkAggregates>>;
  /** A list of `AccountLink` objects. */
  nodes: Array<AccountLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountLink` values. */
export type AccountLinksConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountLinkGroupBy>;
  having?: InputMaybe<AccountLinkHavingInput>;
};

/** A `AccountLink` edge in the connection. */
export type AccountLinksEdge = {
  __typename?: 'AccountLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountLink` at the end of the edge. */
  node: AccountLink;
};

/** Methods to use when ordering `AccountLink`. */
export type AccountLinksOrderBy =
  | 'ACCOUNT_ID_SS58_ASC'
  | 'ACCOUNT_ID_SS58_DESC'
  | 'ETHEREUM_ADDRESS_ASC'
  | 'ETHEREUM_ADDRESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type AccountRole =
  | 'LIQUIDITY_PROVIDER'
  | 'UNREGISTERED'
  | 'VALIDATOR';

/** A filter to be used against AccountRole fields. All fields are combined with a logical ‘and.’ */
export type AccountRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccountRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccountRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccountRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccountRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccountRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccountRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccountRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccountRole>>;
};

/** A filter to be used against many `Delegation` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyDelegationFilter = {
  /** Aggregates across related `Delegation` match the filter criteria. */
  aggregates?: InputMaybe<DelegationAggregatesFilter>;
  /** Every related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DelegationFilter>;
  /** No related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DelegationFilter>;
  /** Some related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DelegationFilter>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountAggregates>;
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountAggregates>>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Account` values. */
export type AccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountGroupBy>;
  having?: InputMaybe<AccountHavingInput>;
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export type AccountsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_COUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_COUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_DELEGATOR_ID_SS58_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_DELEGATOR_ID_SS58_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MAX_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MAX_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MAX_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MAX_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MIN_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MIN_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MIN_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_MIN_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_SUM_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_SUM_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_SUM_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_SUM_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_DELEGATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'ID_HEX_ASC'
  | 'ID_HEX_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type App =
  | 'ALL'
  | 'EXPLORER'
  | 'LP'
  | 'STAKE'
  | 'SWAP';

/** A filter to be used against App fields. All fields are combined with a logical ‘and.’ */
export type AppFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<App>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<App>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<App>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<App>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<App>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<App>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<App>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<App>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<App>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<App>>;
};

export type Auction = Node & {
  __typename?: 'Auction';
  activeBond: Scalars['BigFloat']['output'];
  authorityRotationEnabled: Scalars['Boolean']['output'];
  blockReward: Scalars['BigFloat']['output'];
  currentHeight: Scalars['Int']['output'];
  endBlockNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  minBid: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  redemptionPeriodAsPercentage: Scalars['Int']['output'];
  startBlockNumber: Scalars['Int']['output'];
  targetSetSize: Scalars['Int']['output'];
};

export type AuctionAggregates = {
  __typename?: 'AuctionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuctionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuctionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuctionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuctionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuctionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuctionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuctionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuctionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuctionVarianceSampleAggregates>;
};

export type AuctionAverageAggregates = {
  __typename?: 'AuctionAverageAggregates';
  /** Mean average of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Auction` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AuctionCondition = {
  /** Checks for equality with the object’s `activeBond` field. */
  activeBond?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `authorityRotationEnabled` field. */
  authorityRotationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `blockReward` field. */
  blockReward?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `currentHeight` field. */
  currentHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `endBlockNumber` field. */
  endBlockNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minActiveBid` field. */
  minActiveBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minBid` field. */
  minBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `redemptionPeriodAsPercentage` field. */
  redemptionPeriodAsPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockNumber` field. */
  startBlockNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetSetSize` field. */
  targetSetSize?: InputMaybe<Scalars['Int']['input']>;
};

export type AuctionDistinctCountAggregates = {
  __typename?: 'AuctionDistinctCountAggregates';
  /** Distinct count of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of authorityRotationEnabled across the matching connection */
  authorityRotationEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Auction` object types. All fields are combined with a logical ‘and.’ */
export type AuctionFilter = {
  /** Filter by the object’s `activeBond` field. */
  activeBond?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionFilter>>;
  /** Filter by the object’s `authorityRotationEnabled` field. */
  authorityRotationEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `blockReward` field. */
  blockReward?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `currentHeight` field. */
  currentHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endBlockNumber` field. */
  endBlockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minActiveBid` field. */
  minActiveBid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minBid` field. */
  minBid?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuctionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionFilter>>;
  /** Filter by the object’s `redemptionPeriodAsPercentage` field. */
  redemptionPeriodAsPercentage?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startBlockNumber` field. */
  startBlockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetSetSize` field. */
  targetSetSize?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Auction` for usage during aggregation. */
export type AuctionGroupBy =
  | 'ACTIVE_BOND'
  | 'AUTHORITY_ROTATION_ENABLED'
  | 'BLOCK_REWARD'
  | 'CURRENT_HEIGHT'
  | 'END_BLOCK_NUMBER'
  | 'MIN_ACTIVE_BID'
  | 'MIN_BID'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE'
  | 'START_BLOCK_NUMBER'
  | 'TARGET_SET_SIZE';

export type AuctionHavingAverageInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingDistinctCountInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Auction` aggregates. */
export type AuctionHavingInput = {
  AND?: InputMaybe<Array<AuctionHavingInput>>;
  OR?: InputMaybe<Array<AuctionHavingInput>>;
  average?: InputMaybe<AuctionHavingAverageInput>;
  distinctCount?: InputMaybe<AuctionHavingDistinctCountInput>;
  max?: InputMaybe<AuctionHavingMaxInput>;
  min?: InputMaybe<AuctionHavingMinInput>;
  stddevPopulation?: InputMaybe<AuctionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuctionHavingStddevSampleInput>;
  sum?: InputMaybe<AuctionHavingSumInput>;
  variancePopulation?: InputMaybe<AuctionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuctionHavingVarianceSampleInput>;
};

export type AuctionHavingMaxInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingMinInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevPopulationInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevSampleInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingSumInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVariancePopulationInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVarianceSampleInput = {
  activeBond?: InputMaybe<HavingBigfloatFilter>;
  blockReward?: InputMaybe<HavingBigfloatFilter>;
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  minBid?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionMaxAggregates = {
  __typename?: 'AuctionMaxAggregates';
  /** Maximum of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Maximum of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['Int']['output']>;
};

export type AuctionMinAggregates = {
  __typename?: 'AuctionMinAggregates';
  /** Minimum of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Minimum of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['Int']['output']>;
};

export type AuctionStddevPopulationAggregates = {
  __typename?: 'AuctionStddevPopulationAggregates';
  /** Population standard deviation of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionStddevSampleAggregates = {
  __typename?: 'AuctionStddevSampleAggregates';
  /** Sample standard deviation of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionSumAggregates = {
  __typename?: 'AuctionSumAggregates';
  /** Sum of activeBond across the matching connection */
  activeBond: Scalars['BigFloat']['output'];
  /** Sum of blockReward across the matching connection */
  blockReward: Scalars['BigFloat']['output'];
  /** Sum of currentHeight across the matching connection */
  currentHeight: Scalars['BigInt']['output'];
  /** Sum of endBlockNumber across the matching connection */
  endBlockNumber: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of minActiveBid across the matching connection */
  minActiveBid: Scalars['BigFloat']['output'];
  /** Sum of minBid across the matching connection */
  minBid: Scalars['BigFloat']['output'];
  /** Sum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage: Scalars['BigInt']['output'];
  /** Sum of startBlockNumber across the matching connection */
  startBlockNumber: Scalars['BigInt']['output'];
  /** Sum of targetSetSize across the matching connection */
  targetSetSize: Scalars['BigInt']['output'];
};

export type AuctionVariancePopulationAggregates = {
  __typename?: 'AuctionVariancePopulationAggregates';
  /** Population variance of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionVarianceSampleAggregates = {
  __typename?: 'AuctionVarianceSampleAggregates';
  /** Sample variance of activeBond across the matching connection */
  activeBond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockReward across the matching connection */
  blockReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minBid across the matching connection */
  minBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Auction` values. */
export type AuctionsConnection = {
  __typename?: 'AuctionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuctionAggregates>;
  /** A list of edges which contains the `Auction` and cursor to aid in pagination. */
  edges: Array<AuctionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuctionAggregates>>;
  /** A list of `Auction` objects. */
  nodes: Array<Auction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Auction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Auction` values. */
export type AuctionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AuctionGroupBy>;
  having?: InputMaybe<AuctionHavingInput>;
};

/** A `Auction` edge in the connection. */
export type AuctionsEdge = {
  __typename?: 'AuctionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Auction` at the end of the edge. */
  node: Auction;
};

/** Methods to use when ordering `Auction`. */
export type AuctionsOrderBy =
  | 'ACTIVE_BOND_ASC'
  | 'ACTIVE_BOND_DESC'
  | 'AUTHORITY_ROTATION_ENABLED_ASC'
  | 'AUTHORITY_ROTATION_ENABLED_DESC'
  | 'BLOCK_REWARD_ASC'
  | 'BLOCK_REWARD_DESC'
  | 'CURRENT_HEIGHT_ASC'
  | 'CURRENT_HEIGHT_DESC'
  | 'END_BLOCK_NUMBER_ASC'
  | 'END_BLOCK_NUMBER_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MIN_ACTIVE_BID_ASC'
  | 'MIN_ACTIVE_BID_DESC'
  | 'MIN_BID_ASC'
  | 'MIN_BID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE_ASC'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE_DESC'
  | 'START_BLOCK_NUMBER_ASC'
  | 'START_BLOCK_NUMBER_DESC'
  | 'TARGET_SET_SIZE_ASC'
  | 'TARGET_SET_SIZE_DESC';

export type Banner = Node & {
  __typename?: 'Banner';
  app: App;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: BannerType;
};

export type BannerAggregates = {
  __typename?: 'BannerAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BannerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/** A condition to be used against `Banner` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BannerCondition = {
  /** Checks for equality with the object’s `app` field. */
  app?: InputMaybe<App>;
  /** Checks for equality with the object’s `linkText` field. */
  linkText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `linkUrl` field. */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<BannerType>;
};

export type BannerDistinctCountAggregates = {
  __typename?: 'BannerDistinctCountAggregates';
  /** Distinct count of app across the matching connection */
  app?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of linkText across the matching connection */
  linkText?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of linkUrl across the matching connection */
  linkUrl?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of message across the matching connection */
  message?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Banner` object types. All fields are combined with a logical ‘and.’ */
export type BannerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BannerFilter>>;
  /** Filter by the object’s `app` field. */
  app?: InputMaybe<AppFilter>;
  /** Filter by the object’s `linkText` field. */
  linkText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkUrl` field. */
  linkUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BannerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BannerFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<BannerTypeFilter>;
};

/** Grouping methods for `Banner` for usage during aggregation. */
export type BannerGroupBy =
  | 'LINK_TEXT'
  | 'LINK_URL'
  | 'MESSAGE'
  | 'TYPE';

/** Conditions for `Banner` aggregates. */
export type BannerHavingInput = {
  AND?: InputMaybe<Array<BannerHavingInput>>;
  OR?: InputMaybe<Array<BannerHavingInput>>;
};

export type BannerType =
  | 'INFO'
  | 'SUCCESS'
  | 'WARNING';

/** A filter to be used against BannerType fields. All fields are combined with a logical ‘and.’ */
export type BannerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BannerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BannerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BannerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BannerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BannerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BannerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BannerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BannerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BannerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BannerType>>;
};

/** A connection to a list of `Banner` values. */
export type BannersConnection = {
  __typename?: 'BannersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BannerAggregates>;
  /** A list of edges which contains the `Banner` and cursor to aid in pagination. */
  edges: Array<BannersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BannerAggregates>>;
  /** A list of `Banner` objects. */
  nodes: Array<Banner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Banner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Banner` values. */
export type BannersConnectionGroupedAggregatesArgs = {
  groupBy: Array<BannerGroupBy>;
  having?: InputMaybe<BannerHavingInput>;
};

/** A `Banner` edge in the connection. */
export type BannersEdge = {
  __typename?: 'BannersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Banner` at the end of the edge. */
  node: Banner;
};

/** Methods to use when ordering `Banner`. */
export type BannersOrderBy =
  | 'APP_ASC'
  | 'APP_DESC'
  | 'LINK_TEXT_ASC'
  | 'LINK_TEXT_DESC'
  | 'LINK_URL_ASC'
  | 'LINK_URL_DESC'
  | 'MESSAGE_ASC'
  | 'MESSAGE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BoostBalance = {
  __typename?: 'BoostBalance';
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostBalance`. */
  boostPoolByPoolId: BoostPool;
  /** Reads a single `LpAccount` that is related to this `BoostBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  poolId: Scalars['Int']['output'];
  poolShare: Scalars['Float']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostBalanceAggregates = {
  __typename?: 'BoostBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostBalance` object types. */
export type BoostBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `BoostBalance` objects. */
  average?: InputMaybe<BoostBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostBalance` objects. */
  distinctCount?: InputMaybe<BoostBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostBalance` object to be included within the aggregate. */
  filter?: InputMaybe<BoostBalanceFilter>;
  /** Maximum aggregate over matching `BoostBalance` objects. */
  max?: InputMaybe<BoostBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostBalance` objects. */
  min?: InputMaybe<BoostBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostBalance` objects. */
  stddevPopulation?: InputMaybe<BoostBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostBalance` objects. */
  stddevSample?: InputMaybe<BoostBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostBalance` objects. */
  sum?: InputMaybe<BoostBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostBalance` objects. */
  variancePopulation?: InputMaybe<BoostBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostBalance` objects. */
  varianceSample?: InputMaybe<BoostBalanceVarianceSampleAggregateFilter>;
};

export type BoostBalanceAverageAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceAverageAggregates = {
  __typename?: 'BoostBalanceAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostBalanceCondition = {
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  boostPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  lpAccountByLpIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `poolShare` field. */
  poolShare?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostBalanceDistinctCountAggregateFilter = {
  availableAmount?: InputMaybe<BigIntFilter>;
  availableAmountValueUsd?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  poolShare?: InputMaybe<BigIntFilter>;
  unavailableAmount?: InputMaybe<BigIntFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigIntFilter>;
};

export type BoostBalanceDistinctCountAggregates = {
  __typename?: 'BoostBalanceDistinctCountAggregates';
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type BoostBalanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostBalanceFilter>>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boostPoolByPoolId` relation. */
  boostPoolByPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostBalanceFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `poolShare` field. */
  poolShare?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostBalance` for usage during aggregation. */
export type BoostBalanceGroupBy =
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'LP_ID_SS58'
  | 'POOL_ID'
  | 'POOL_SHARE'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD';

export type BoostBalanceHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostBalance` aggregates. */
export type BoostBalanceHavingInput = {
  AND?: InputMaybe<Array<BoostBalanceHavingInput>>;
  OR?: InputMaybe<Array<BoostBalanceHavingInput>>;
  average?: InputMaybe<BoostBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<BoostBalanceHavingDistinctCountInput>;
  max?: InputMaybe<BoostBalanceHavingMaxInput>;
  min?: InputMaybe<BoostBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<BoostBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<BoostBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostBalanceHavingVarianceSampleInput>;
};

export type BoostBalanceHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceMaxAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceMaxAggregates = {
  __typename?: 'BoostBalanceMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceMinAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceMinAggregates = {
  __typename?: 'BoostBalanceMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceStddevPopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceStddevPopulationAggregates = {
  __typename?: 'BoostBalanceStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceStddevSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceStddevSampleAggregates = {
  __typename?: 'BoostBalanceStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceSumAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceSumAggregates = {
  __typename?: 'BoostBalanceSumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of poolShare across the matching connection */
  poolShare: Scalars['Float']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostBalanceVariancePopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceVariancePopulationAggregates = {
  __typename?: 'BoostBalanceVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceVarianceSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceVarianceSampleAggregates = {
  __typename?: 'BoostBalanceVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostBalance` values. */
export type BoostBalancesConnection = {
  __typename?: 'BoostBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostBalanceAggregates>;
  /** A list of edges which contains the `BoostBalance` and cursor to aid in pagination. */
  edges: Array<BoostBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostBalanceAggregates>>;
  /** A list of `BoostBalance` objects. */
  nodes: Array<BoostBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostBalance` values. */
export type BoostBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostBalanceGroupBy>;
  having?: InputMaybe<BoostBalanceHavingInput>;
};

/** A `BoostBalance` edge in the connection. */
export type BoostBalancesEdge = {
  __typename?: 'BoostBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostBalance` at the end of the edge. */
  node: BoostBalance;
};

/** Methods to use when ordering `BoostBalance`. */
export type BoostBalancesOrderBy =
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'POOL_SHARE_ASC'
  | 'POOL_SHARE_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC';

export type BoostDelayChainflipBlock = Node & {
  __typename?: 'BoostDelayChainflipBlock';
  chain: ChainflipChain;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numBlocks: Scalars['Int']['output'];
};

export type BoostDelayChainflipBlockAggregates = {
  __typename?: 'BoostDelayChainflipBlockAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostDelayChainflipBlockAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostDelayChainflipBlockDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostDelayChainflipBlockMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostDelayChainflipBlockMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostDelayChainflipBlockStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostDelayChainflipBlockStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostDelayChainflipBlockSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostDelayChainflipBlockVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostDelayChainflipBlockVarianceSampleAggregates>;
};

export type BoostDelayChainflipBlockAverageAggregates = {
  __typename?: 'BoostDelayChainflipBlockAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostDelayChainflipBlock` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BoostDelayChainflipBlockCondition = {
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `numBlocks` field. */
  numBlocks?: InputMaybe<Scalars['Int']['input']>;
};

export type BoostDelayChainflipBlockDistinctCountAggregates = {
  __typename?: 'BoostDelayChainflipBlockDistinctCountAggregates';
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostDelayChainflipBlock` object types. All fields are combined with a logical ‘and.’ */
export type BoostDelayChainflipBlockFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostDelayChainflipBlockFilter>>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostDelayChainflipBlockFilter>;
  /** Filter by the object’s `numBlocks` field. */
  numBlocks?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostDelayChainflipBlockFilter>>;
};

/** Grouping methods for `BoostDelayChainflipBlock` for usage during aggregation. */
export type BoostDelayChainflipBlockGroupBy =
  | 'NUM_BLOCKS';

export type BoostDelayChainflipBlockHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostDelayChainflipBlock` aggregates. */
export type BoostDelayChainflipBlockHavingInput = {
  AND?: InputMaybe<Array<BoostDelayChainflipBlockHavingInput>>;
  OR?: InputMaybe<Array<BoostDelayChainflipBlockHavingInput>>;
  average?: InputMaybe<BoostDelayChainflipBlockHavingAverageInput>;
  distinctCount?: InputMaybe<BoostDelayChainflipBlockHavingDistinctCountInput>;
  max?: InputMaybe<BoostDelayChainflipBlockHavingMaxInput>;
  min?: InputMaybe<BoostDelayChainflipBlockHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostDelayChainflipBlockHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostDelayChainflipBlockHavingStddevSampleInput>;
  sum?: InputMaybe<BoostDelayChainflipBlockHavingSumInput>;
  variancePopulation?: InputMaybe<BoostDelayChainflipBlockHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostDelayChainflipBlockHavingVarianceSampleInput>;
};

export type BoostDelayChainflipBlockHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  numBlocks?: InputMaybe<HavingIntFilter>;
};

export type BoostDelayChainflipBlockMaxAggregates = {
  __typename?: 'BoostDelayChainflipBlockMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['Int']['output']>;
};

export type BoostDelayChainflipBlockMinAggregates = {
  __typename?: 'BoostDelayChainflipBlockMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['Int']['output']>;
};

export type BoostDelayChainflipBlockStddevPopulationAggregates = {
  __typename?: 'BoostDelayChainflipBlockStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostDelayChainflipBlockStddevSampleAggregates = {
  __typename?: 'BoostDelayChainflipBlockStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostDelayChainflipBlockSumAggregates = {
  __typename?: 'BoostDelayChainflipBlockSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of numBlocks across the matching connection */
  numBlocks: Scalars['BigInt']['output'];
};

export type BoostDelayChainflipBlockVariancePopulationAggregates = {
  __typename?: 'BoostDelayChainflipBlockVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostDelayChainflipBlockVarianceSampleAggregates = {
  __typename?: 'BoostDelayChainflipBlockVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of numBlocks across the matching connection */
  numBlocks?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostDelayChainflipBlock` values. */
export type BoostDelayChainflipBlocksConnection = {
  __typename?: 'BoostDelayChainflipBlocksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostDelayChainflipBlockAggregates>;
  /** A list of edges which contains the `BoostDelayChainflipBlock` and cursor to aid in pagination. */
  edges: Array<BoostDelayChainflipBlocksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostDelayChainflipBlockAggregates>>;
  /** A list of `BoostDelayChainflipBlock` objects. */
  nodes: Array<BoostDelayChainflipBlock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostDelayChainflipBlock` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostDelayChainflipBlock` values. */
export type BoostDelayChainflipBlocksConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostDelayChainflipBlockGroupBy>;
  having?: InputMaybe<BoostDelayChainflipBlockHavingInput>;
};

/** A `BoostDelayChainflipBlock` edge in the connection. */
export type BoostDelayChainflipBlocksEdge = {
  __typename?: 'BoostDelayChainflipBlocksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostDelayChainflipBlock` at the end of the edge. */
  node: BoostDelayChainflipBlock;
};

/** Methods to use when ordering `BoostDelayChainflipBlock`. */
export type BoostDelayChainflipBlocksOrderBy =
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NUM_BLOCKS_ASC'
  | 'NUM_BLOCKS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BoostPool = Node & {
  __typename?: 'BoostPool';
  asset: ChainflipAsset;
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BoostBalance`. */
  boostBalancesByPoolId: BoostBalancesConnection;
  chain: ChainflipChain;
  feeTierPips: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};


export type BoostPoolBoostBalancesByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};

export type BoostPoolAggregates = {
  __typename?: 'BoostPoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolVarianceSampleAggregates>;
};

export type BoostPoolAverageAggregates = {
  __typename?: 'BoostPoolAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostPool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BoostPoolCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostPoolDistinctCountAggregates = {
  __typename?: 'BoostPoolDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPool` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boostBalancesByPoolId` relation. */
  boostBalancesByPoolId?: InputMaybe<BoostPoolToManyBoostBalanceFilter>;
  /** Some related `boostBalancesByPoolId` exist. */
  boostBalancesByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolFilter>>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostPool` for usage during aggregation. */
export type BoostPoolGroupBy =
  | 'ASSET'
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'CHAIN'
  | 'FEE_TIER_PIPS'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD';

export type BoostPoolHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostPool` aggregates. */
export type BoostPoolHavingInput = {
  AND?: InputMaybe<Array<BoostPoolHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolHavingInput>>;
  average?: InputMaybe<BoostPoolHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolHavingMaxInput>;
  min?: InputMaybe<BoostPoolHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolHavingVarianceSampleInput>;
};

export type BoostPoolHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolMaxAggregates = {
  __typename?: 'BoostPoolMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolMinAggregates = {
  __typename?: 'BoostPoolMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolStddevPopulationAggregates = {
  __typename?: 'BoostPoolStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolStddevSampleAggregates = {
  __typename?: 'BoostPoolStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolSumAggregates = {
  __typename?: 'BoostPoolSumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of feeTierPips across the matching connection */
  feeTierPips: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostBalanceFilter = {
  /** Aggregates across related `BoostBalance` match the filter criteria. */
  aggregates?: InputMaybe<BoostBalanceAggregatesFilter>;
  /** Every related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostBalanceFilter>;
  /** No related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostBalanceFilter>;
  /** Some related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostBalanceFilter>;
};

export type BoostPoolVariancePopulationAggregates = {
  __typename?: 'BoostPoolVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolVarianceSampleAggregates = {
  __typename?: 'BoostPoolVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnection = {
  __typename?: 'BoostPoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolAggregates>;
  /** A list of edges which contains the `BoostPool` and cursor to aid in pagination. */
  edges: Array<BoostPoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolAggregates>>;
  /** A list of `BoostPool` objects. */
  nodes: Array<BoostPool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolGroupBy>;
  having?: InputMaybe<BoostPoolHavingInput>;
};

/** A `BoostPool` edge in the connection. */
export type BoostPoolsEdge = {
  __typename?: 'BoostPoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPool` at the end of the edge. */
  node: BoostPool;
};

/** Methods to use when ordering `BoostPool`. */
export type BoostPoolsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_COUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_COUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'FEE_TIER_PIPS_ASC'
  | 'FEE_TIER_PIPS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC';

export type BoostSafeMode = Node & {
  __typename?: 'BoostSafeMode';
  addBoostFundsEnabled: Scalars['Boolean']['output'];
  boostDepositsEnabled: Scalars['Boolean']['output'];
  chain: ChainflipChain;
  depositsEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stopBoostingEnabled: Scalars['Boolean']['output'];
};

export type BoostSafeModeAggregates = {
  __typename?: 'BoostSafeModeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostSafeModeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostSafeModeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostSafeModeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostSafeModeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostSafeModeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostSafeModeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostSafeModeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostSafeModeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostSafeModeVarianceSampleAggregates>;
};

export type BoostSafeModeAverageAggregates = {
  __typename?: 'BoostSafeModeAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostSafeMode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostSafeModeCondition = {
  /** Checks for equality with the object’s `addBoostFundsEnabled` field. */
  addBoostFundsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `boostDepositsEnabled` field. */
  boostDepositsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `depositsEnabled` field. */
  depositsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stopBoostingEnabled` field. */
  stopBoostingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoostSafeModeDistinctCountAggregates = {
  __typename?: 'BoostSafeModeDistinctCountAggregates';
  /** Distinct count of addBoostFundsEnabled across the matching connection */
  addBoostFundsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostDepositsEnabled across the matching connection */
  boostDepositsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositsEnabled across the matching connection */
  depositsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stopBoostingEnabled across the matching connection */
  stopBoostingEnabled?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostSafeMode` object types. All fields are combined with a logical ‘and.’ */
export type BoostSafeModeFilter = {
  /** Filter by the object’s `addBoostFundsEnabled` field. */
  addBoostFundsEnabled?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostSafeModeFilter>>;
  /** Filter by the object’s `boostDepositsEnabled` field. */
  boostDepositsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `depositsEnabled` field. */
  depositsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostSafeModeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostSafeModeFilter>>;
  /** Filter by the object’s `stopBoostingEnabled` field. */
  stopBoostingEnabled?: InputMaybe<BooleanFilter>;
};

/** Grouping methods for `BoostSafeMode` for usage during aggregation. */
export type BoostSafeModeGroupBy =
  | 'ADD_BOOST_FUNDS_ENABLED'
  | 'BOOST_DEPOSITS_ENABLED'
  | 'DEPOSITS_ENABLED'
  | 'STOP_BOOSTING_ENABLED';

export type BoostSafeModeHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostSafeMode` aggregates. */
export type BoostSafeModeHavingInput = {
  AND?: InputMaybe<Array<BoostSafeModeHavingInput>>;
  OR?: InputMaybe<Array<BoostSafeModeHavingInput>>;
  average?: InputMaybe<BoostSafeModeHavingAverageInput>;
  distinctCount?: InputMaybe<BoostSafeModeHavingDistinctCountInput>;
  max?: InputMaybe<BoostSafeModeHavingMaxInput>;
  min?: InputMaybe<BoostSafeModeHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostSafeModeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostSafeModeHavingStddevSampleInput>;
  sum?: InputMaybe<BoostSafeModeHavingSumInput>;
  variancePopulation?: InputMaybe<BoostSafeModeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostSafeModeHavingVarianceSampleInput>;
};

export type BoostSafeModeHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeMaxAggregates = {
  __typename?: 'BoostSafeModeMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostSafeModeMinAggregates = {
  __typename?: 'BoostSafeModeMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostSafeModeStddevPopulationAggregates = {
  __typename?: 'BoostSafeModeStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeStddevSampleAggregates = {
  __typename?: 'BoostSafeModeStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeSumAggregates = {
  __typename?: 'BoostSafeModeSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type BoostSafeModeVariancePopulationAggregates = {
  __typename?: 'BoostSafeModeVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeVarianceSampleAggregates = {
  __typename?: 'BoostSafeModeVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostSafeMode` values. */
export type BoostSafeModesConnection = {
  __typename?: 'BoostSafeModesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostSafeModeAggregates>;
  /** A list of edges which contains the `BoostSafeMode` and cursor to aid in pagination. */
  edges: Array<BoostSafeModesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostSafeModeAggregates>>;
  /** A list of `BoostSafeMode` objects. */
  nodes: Array<BoostSafeMode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostSafeMode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostSafeMode` values. */
export type BoostSafeModesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostSafeModeGroupBy>;
  having?: InputMaybe<BoostSafeModeHavingInput>;
};

/** A `BoostSafeMode` edge in the connection. */
export type BoostSafeModesEdge = {
  __typename?: 'BoostSafeModesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostSafeMode` at the end of the edge. */
  node: BoostSafeMode;
};

/** Methods to use when ordering `BoostSafeMode`. */
export type BoostSafeModesOrderBy =
  | 'ADD_BOOST_FUNDS_ENABLED_ASC'
  | 'ADD_BOOST_FUNDS_ENABLED_DESC'
  | 'BOOST_DEPOSITS_ENABLED_ASC'
  | 'BOOST_DEPOSITS_ENABLED_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'DEPOSITS_ENABLED_ASC'
  | 'DEPOSITS_ENABLED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STOP_BOOSTING_ENABLED_ASC'
  | 'STOP_BOOSTING_ENABLED_DESC';

export type BrokerAccount = Node & {
  __typename?: 'BrokerAccount';
  /** Reads a single `Account` that is related to this `BrokerAccount`. */
  accountByIdSs58: Account;
  alias?: Maybe<Scalars['String']['output']>;
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `BrokerAccount` that is related to this `BrokerAccount`. */
  brokerAccountByDelegateBrokerId?: Maybe<BrokerAccount>;
  /** Reads and enables pagination through a set of `BrokerAccount`. */
  brokerAccountsByDelegateBrokerId: BrokerAccountsConnection;
  brokerVaultDepositAddress?: Maybe<Scalars['String']['output']>;
  delegateBrokerId?: Maybe<Scalars['String']['output']>;
  earnedFeesUsdc: Scalars['BigFloat']['output'];
  flipBalance: Scalars['BigFloat']['output'];
  idSs58: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
  withdrawalAddress?: Maybe<Scalars['String']['output']>;
};


export type BrokerAccountBrokerAccountsByDelegateBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountCondition>;
  filter?: InputMaybe<BrokerAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountsOrderBy>>;
};

export type BrokerAccountAggregates = {
  __typename?: 'BrokerAccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerAccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerAccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerAccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerAccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerAccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerAccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerAccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerAccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerAccountVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerAccount` object types. */
export type BrokerAccountAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerAccount` objects. */
  average?: InputMaybe<BrokerAccountAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerAccount` objects. */
  distinctCount?: InputMaybe<BrokerAccountDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerAccount` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerAccountFilter>;
  /** Maximum aggregate over matching `BrokerAccount` objects. */
  max?: InputMaybe<BrokerAccountMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerAccount` objects. */
  min?: InputMaybe<BrokerAccountMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerAccount` objects. */
  stddevPopulation?: InputMaybe<BrokerAccountStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerAccount` objects. */
  stddevSample?: InputMaybe<BrokerAccountStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerAccount` objects. */
  sum?: InputMaybe<BrokerAccountSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerAccount` objects. */
  variancePopulation?: InputMaybe<BrokerAccountVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerAccount` objects. */
  varianceSample?: InputMaybe<BrokerAccountVarianceSampleAggregateFilter>;
};

export type BrokerAccountAverageAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountAverageAggregates = {
  __typename?: 'BrokerAccountAverageAggregates';
  /** Mean average of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerAccountCondition = {
  accountByIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bondedFlipBalance` field. */
  bondedFlipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  brokerAccountByDelegateBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerVaultDepositAddress` field. */
  brokerVaultDepositAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `earnedFeesUsdc` field. */
  earnedFeesUsdc?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `registrationId` field. */
  registrationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

export type BrokerAccountDistinctCountAggregateFilter = {
  alias?: InputMaybe<BigIntFilter>;
  bondedFlipBalance?: InputMaybe<BigIntFilter>;
  brokerVaultDepositAddress?: InputMaybe<BigIntFilter>;
  delegateBrokerId?: InputMaybe<BigIntFilter>;
  earnedFeesUsdc?: InputMaybe<BigIntFilter>;
  flipBalance?: InputMaybe<BigIntFilter>;
  idSs58?: InputMaybe<BigIntFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
  withdrawalAddress?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountDistinctCountAggregates = {
  __typename?: 'BrokerAccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerVaultDepositAddress across the matching connection */
  brokerVaultDepositAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawalAddress across the matching connection */
  withdrawalAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerAccount` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountFilter = {
  /** Filter by the object’s `accountByIdSs58` relation. */
  accountByIdSs58?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerAccountFilter>>;
  /** Filter by the object’s `bondedFlipBalance` field. */
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `brokerAccountByDelegateBrokerId` relation. */
  brokerAccountByDelegateBrokerId?: InputMaybe<BrokerAccountFilter>;
  /** A related `brokerAccountByDelegateBrokerId` exists. */
  brokerAccountByDelegateBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerAccountsByDelegateBrokerId` relation. */
  brokerAccountsByDelegateBrokerId?: InputMaybe<BrokerAccountToManyBrokerAccountFilter>;
  /** Some related `brokerAccountsByDelegateBrokerId` exist. */
  brokerAccountsByDelegateBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerVaultDepositAddress` field. */
  brokerVaultDepositAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `earnedFeesUsdc` field. */
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerAccountFilter>>;
  /** Filter by the object’s `registrationId` field. */
  registrationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `BrokerAccount` for usage during aggregation. */
export type BrokerAccountGroupBy =
  | 'ALIAS'
  | 'BONDED_FLIP_BALANCE'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS'
  | 'DELEGATE_BROKER_ID'
  | 'EARNED_FEES_USDC'
  | 'FLIP_BALANCE'
  | 'REGISTRATION_ID'
  | 'WITHDRAWAL_ADDRESS';

export type BrokerAccountHavingAverageInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingDistinctCountInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BrokerAccount` aggregates. */
export type BrokerAccountHavingInput = {
  AND?: InputMaybe<Array<BrokerAccountHavingInput>>;
  OR?: InputMaybe<Array<BrokerAccountHavingInput>>;
  average?: InputMaybe<BrokerAccountHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerAccountHavingDistinctCountInput>;
  max?: InputMaybe<BrokerAccountHavingMaxInput>;
  min?: InputMaybe<BrokerAccountHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerAccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerAccountHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerAccountHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerAccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerAccountHavingVarianceSampleInput>;
};

export type BrokerAccountHavingMaxInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingMinInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingStddevPopulationInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingStddevSampleInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingSumInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingVariancePopulationInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingVarianceSampleInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  earnedFeesUsdc?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountMaxAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<IntFilter>;
};

export type BrokerAccountMaxAggregates = {
  __typename?: 'BrokerAccountMaxAggregates';
  /** Maximum of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountMinAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<IntFilter>;
};

export type BrokerAccountMinAggregates = {
  __typename?: 'BrokerAccountMinAggregates';
  /** Minimum of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountStddevPopulationAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountStddevPopulationAggregates = {
  __typename?: 'BrokerAccountStddevPopulationAggregates';
  /** Population standard deviation of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountStddevSampleAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountStddevSampleAggregates = {
  __typename?: 'BrokerAccountStddevSampleAggregates';
  /** Sample standard deviation of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountSumAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountSumAggregates = {
  __typename?: 'BrokerAccountSumAggregates';
  /** Sum of bondedFlipBalance across the matching connection */
  bondedFlipBalance: Scalars['BigFloat']['output'];
  /** Sum of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc: Scalars['BigFloat']['output'];
  /** Sum of flipBalance across the matching connection */
  flipBalance: Scalars['BigFloat']['output'];
  /** Sum of registrationId across the matching connection */
  registrationId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `BrokerAccount` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountToManyBrokerAccountFilter = {
  /** Aggregates across related `BrokerAccount` match the filter criteria. */
  aggregates?: InputMaybe<BrokerAccountAggregatesFilter>;
  /** Every related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerAccountFilter>;
  /** No related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerAccountFilter>;
  /** Some related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerAccountFilter>;
};

export type BrokerAccountVariancePopulationAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountVariancePopulationAggregates = {
  __typename?: 'BrokerAccountVariancePopulationAggregates';
  /** Population variance of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountVarianceSampleAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  earnedFeesUsdc?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountVarianceSampleAggregates = {
  __typename?: 'BrokerAccountVarianceSampleAggregates';
  /** Sample variance of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of earnedFeesUsdc across the matching connection */
  earnedFeesUsdc?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerAccount` values. */
export type BrokerAccountsConnection = {
  __typename?: 'BrokerAccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerAccountAggregates>;
  /** A list of edges which contains the `BrokerAccount` and cursor to aid in pagination. */
  edges: Array<BrokerAccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerAccountAggregates>>;
  /** A list of `BrokerAccount` objects. */
  nodes: Array<BrokerAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerAccount` values. */
export type BrokerAccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerAccountGroupBy>;
  having?: InputMaybe<BrokerAccountHavingInput>;
};

/** A `BrokerAccount` edge in the connection. */
export type BrokerAccountsEdge = {
  __typename?: 'BrokerAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerAccount` at the end of the edge. */
  node: BrokerAccount;
};

/** Methods to use when ordering `BrokerAccount`. */
export type BrokerAccountsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'BONDED_FLIP_BALANCE_ASC'
  | 'BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_COUNT_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_COUNT_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_EARNED_FEES_USDC_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_EARNED_FEES_USDC_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'DELEGATE_BROKER_ID_ASC'
  | 'DELEGATE_BROKER_ID_DESC'
  | 'EARNED_FEES_USDC_ASC'
  | 'EARNED_FEES_USDC_DESC'
  | 'FLIP_BALANCE_ASC'
  | 'FLIP_BALANCE_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REGISTRATION_ID_ASC'
  | 'REGISTRATION_ID_DESC'
  | 'WITHDRAWAL_ADDRESS_ASC'
  | 'WITHDRAWAL_ADDRESS_DESC';

export type ChainflipAsset =
  | 'ArbEth'
  | 'ArbUsdc'
  | 'ArbUsdt'
  | 'Bnb'
  | 'BscUsdt'
  | 'Btc'
  | 'Cbbtc'
  | 'Eth'
  | 'Flip'
  | 'HubDot'
  | 'HubUsdc'
  | 'HubUsdt'
  | 'Sol'
  | 'SolUsdc'
  | 'SolUsdt'
  | 'Trx'
  | 'TrxUsdt'
  | 'Usdc'
  | 'Usdt'
  | 'Wbtc';

/** A filter to be used against ChainflipAsset fields. All fields are combined with a logical ‘and.’ */
export type ChainflipAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipAsset>>;
};

export type ChainflipChain =
  | 'Arbitrum'
  | 'Assethub'
  | 'Bitcoin'
  | 'Bsc'
  | 'Ethereum'
  | 'Solana'
  | 'Tron';

/** A filter to be used against ChainflipChain fields. All fields are combined with a logical ‘and.’ */
export type ChainflipChainFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipChain>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipChain>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipChain>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipChain>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipChain>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipChain>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipChain>>;
};

export type Circulation = Node & {
  __typename?: 'Circulation';
  circulatingSupply: Scalars['BigFloat']['output'];
  circulatingSupplyNotStaked: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  totalLocked: Scalars['BigFloat']['output'];
  totalStaked: Scalars['BigFloat']['output'];
  totalSupply: Scalars['BigFloat']['output'];
};

export type CirculationAggregates = {
  __typename?: 'CirculationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CirculationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CirculationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CirculationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CirculationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CirculationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CirculationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CirculationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CirculationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CirculationVarianceSampleAggregates>;
};

export type CirculationAverageAggregates = {
  __typename?: 'CirculationAverageAggregates';
  /** Mean average of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Circulation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CirculationCondition = {
  /** Checks for equality with the object’s `circulatingSupply` field. */
  circulatingSupply?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `circulatingSupplyNotStaked` field. */
  circulatingSupplyNotStaked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalLocked` field. */
  totalLocked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalStaked` field. */
  totalStaked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalSupply` field. */
  totalSupply?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type CirculationDistinctCountAggregates = {
  __typename?: 'CirculationDistinctCountAggregates';
  /** Distinct count of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Circulation` object types. All fields are combined with a logical ‘and.’ */
export type CirculationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CirculationFilter>>;
  /** Filter by the object’s `circulatingSupply` field. */
  circulatingSupply?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `circulatingSupplyNotStaked` field. */
  circulatingSupplyNotStaked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CirculationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CirculationFilter>>;
  /** Filter by the object’s `totalLocked` field. */
  totalLocked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalStaked` field. */
  totalStaked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalSupply` field. */
  totalSupply?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Circulation` for usage during aggregation. */
export type CirculationGroupBy =
  | 'CIRCULATING_SUPPLY'
  | 'CIRCULATING_SUPPLY_NOT_STAKED'
  | 'TOTAL_LOCKED'
  | 'TOTAL_STAKED'
  | 'TOTAL_SUPPLY';

export type CirculationHavingAverageInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingDistinctCountInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Circulation` aggregates. */
export type CirculationHavingInput = {
  AND?: InputMaybe<Array<CirculationHavingInput>>;
  OR?: InputMaybe<Array<CirculationHavingInput>>;
  average?: InputMaybe<CirculationHavingAverageInput>;
  distinctCount?: InputMaybe<CirculationHavingDistinctCountInput>;
  max?: InputMaybe<CirculationHavingMaxInput>;
  min?: InputMaybe<CirculationHavingMinInput>;
  stddevPopulation?: InputMaybe<CirculationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CirculationHavingStddevSampleInput>;
  sum?: InputMaybe<CirculationHavingSumInput>;
  variancePopulation?: InputMaybe<CirculationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CirculationHavingVarianceSampleInput>;
};

export type CirculationHavingMaxInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingMinInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingStddevPopulationInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingStddevSampleInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingSumInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingVariancePopulationInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingVarianceSampleInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationMaxAggregates = {
  __typename?: 'CirculationMaxAggregates';
  /** Maximum of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationMinAggregates = {
  __typename?: 'CirculationMinAggregates';
  /** Minimum of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationStddevPopulationAggregates = {
  __typename?: 'CirculationStddevPopulationAggregates';
  /** Population standard deviation of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationStddevSampleAggregates = {
  __typename?: 'CirculationStddevSampleAggregates';
  /** Sample standard deviation of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationSumAggregates = {
  __typename?: 'CirculationSumAggregates';
  /** Sum of circulatingSupply across the matching connection */
  circulatingSupply: Scalars['BigFloat']['output'];
  /** Sum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of totalLocked across the matching connection */
  totalLocked: Scalars['BigFloat']['output'];
  /** Sum of totalStaked across the matching connection */
  totalStaked: Scalars['BigFloat']['output'];
  /** Sum of totalSupply across the matching connection */
  totalSupply: Scalars['BigFloat']['output'];
};

export type CirculationVariancePopulationAggregates = {
  __typename?: 'CirculationVariancePopulationAggregates';
  /** Population variance of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationVarianceSampleAggregates = {
  __typename?: 'CirculationVarianceSampleAggregates';
  /** Sample variance of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Circulation` values. */
export type CirculationsConnection = {
  __typename?: 'CirculationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CirculationAggregates>;
  /** A list of edges which contains the `Circulation` and cursor to aid in pagination. */
  edges: Array<CirculationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CirculationAggregates>>;
  /** A list of `Circulation` objects. */
  nodes: Array<Circulation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Circulation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Circulation` values. */
export type CirculationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<CirculationGroupBy>;
  having?: InputMaybe<CirculationHavingInput>;
};

/** A `Circulation` edge in the connection. */
export type CirculationsEdge = {
  __typename?: 'CirculationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Circulation` at the end of the edge. */
  node: Circulation;
};

/** Methods to use when ordering `Circulation`. */
export type CirculationsOrderBy =
  | 'CIRCULATING_SUPPLY_ASC'
  | 'CIRCULATING_SUPPLY_DESC'
  | 'CIRCULATING_SUPPLY_NOT_STAKED_ASC'
  | 'CIRCULATING_SUPPLY_NOT_STAKED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TOTAL_LOCKED_ASC'
  | 'TOTAL_LOCKED_DESC'
  | 'TOTAL_STAKED_ASC'
  | 'TOTAL_STAKED_DESC'
  | 'TOTAL_SUPPLY_ASC'
  | 'TOTAL_SUPPLY_DESC';

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type Delegation = {
  __typename?: 'Delegation';
  /** Reads a single `Account` that is related to this `Delegation`. */
  accountByDelegatorIdSs58: Account;
  activeAmount: Scalars['BigFloat']['output'];
  delegatorIdSs58: Scalars['String']['output'];
  /** Reads a single `Operator` that is related to this `Delegation`. */
  operatorByOperatorIdSs58: Operator;
  operatorIdSs58: Scalars['String']['output'];
  upcomingAmount: Scalars['BigFloat']['output'];
};

export type DelegationAggregates = {
  __typename?: 'DelegationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DelegationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DelegationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DelegationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DelegationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DelegationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DelegationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DelegationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DelegationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DelegationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Delegation` object types. */
export type DelegationAggregatesFilter = {
  /** Mean average aggregate over matching `Delegation` objects. */
  average?: InputMaybe<DelegationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Delegation` objects. */
  distinctCount?: InputMaybe<DelegationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Delegation` object to be included within the aggregate. */
  filter?: InputMaybe<DelegationFilter>;
  /** Maximum aggregate over matching `Delegation` objects. */
  max?: InputMaybe<DelegationMaxAggregateFilter>;
  /** Minimum aggregate over matching `Delegation` objects. */
  min?: InputMaybe<DelegationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Delegation` objects. */
  stddevPopulation?: InputMaybe<DelegationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Delegation` objects. */
  stddevSample?: InputMaybe<DelegationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Delegation` objects. */
  sum?: InputMaybe<DelegationSumAggregateFilter>;
  /** Population variance aggregate over matching `Delegation` objects. */
  variancePopulation?: InputMaybe<DelegationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Delegation` objects. */
  varianceSample?: InputMaybe<DelegationVarianceSampleAggregateFilter>;
};

export type DelegationAverageAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationAverageAggregates = {
  __typename?: 'DelegationAverageAggregates';
  /** Mean average of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Delegation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DelegationCondition = {
  accountByDelegatorIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `activeAmount` field. */
  activeAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `delegatorIdSs58` field. */
  delegatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  operatorByOperatorIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorIdSs58` field. */
  operatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `upcomingAmount` field. */
  upcomingAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type DelegationDistinctCountAggregateFilter = {
  activeAmount?: InputMaybe<BigIntFilter>;
  delegatorIdSs58?: InputMaybe<BigIntFilter>;
  operatorIdSs58?: InputMaybe<BigIntFilter>;
  upcomingAmount?: InputMaybe<BigIntFilter>;
};

export type DelegationDistinctCountAggregates = {
  __typename?: 'DelegationDistinctCountAggregates';
  /** Distinct count of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatorIdSs58 across the matching connection */
  delegatorIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorIdSs58 across the matching connection */
  operatorIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Delegation` object types. All fields are combined with a logical ‘and.’ */
export type DelegationFilter = {
  /** Filter by the object’s `accountByDelegatorIdSs58` relation. */
  accountByDelegatorIdSs58?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `activeAmount` field. */
  activeAmount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DelegationFilter>>;
  /** Filter by the object’s `delegatorIdSs58` field. */
  delegatorIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DelegationFilter>;
  /** Filter by the object’s `operatorByOperatorIdSs58` relation. */
  operatorByOperatorIdSs58?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorIdSs58` field. */
  operatorIdSs58?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DelegationFilter>>;
  /** Filter by the object’s `upcomingAmount` field. */
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Delegation` for usage during aggregation. */
export type DelegationGroupBy =
  | 'ACTIVE_AMOUNT'
  | 'DELEGATOR_ID_SS58'
  | 'OPERATOR_ID_SS58'
  | 'UPCOMING_AMOUNT';

export type DelegationHavingAverageInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingDistinctCountInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Delegation` aggregates. */
export type DelegationHavingInput = {
  AND?: InputMaybe<Array<DelegationHavingInput>>;
  OR?: InputMaybe<Array<DelegationHavingInput>>;
  average?: InputMaybe<DelegationHavingAverageInput>;
  distinctCount?: InputMaybe<DelegationHavingDistinctCountInput>;
  max?: InputMaybe<DelegationHavingMaxInput>;
  min?: InputMaybe<DelegationHavingMinInput>;
  stddevPopulation?: InputMaybe<DelegationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DelegationHavingStddevSampleInput>;
  sum?: InputMaybe<DelegationHavingSumInput>;
  variancePopulation?: InputMaybe<DelegationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DelegationHavingVarianceSampleInput>;
};

export type DelegationHavingMaxInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingMinInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingStddevPopulationInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingStddevSampleInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingSumInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingVariancePopulationInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationHavingVarianceSampleInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationMaxAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationMaxAggregates = {
  __typename?: 'DelegationMaxAggregates';
  /** Maximum of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationMinAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationMinAggregates = {
  __typename?: 'DelegationMinAggregates';
  /** Minimum of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationStddevPopulationAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationStddevPopulationAggregates = {
  __typename?: 'DelegationStddevPopulationAggregates';
  /** Population standard deviation of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationStddevSampleAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationStddevSampleAggregates = {
  __typename?: 'DelegationStddevSampleAggregates';
  /** Sample standard deviation of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationSumAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationSumAggregates = {
  __typename?: 'DelegationSumAggregates';
  /** Sum of activeAmount across the matching connection */
  activeAmount: Scalars['BigFloat']['output'];
  /** Sum of upcomingAmount across the matching connection */
  upcomingAmount: Scalars['BigFloat']['output'];
};

export type DelegationVariancePopulationAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationVariancePopulationAggregates = {
  __typename?: 'DelegationVariancePopulationAggregates';
  /** Population variance of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationVarianceSampleAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type DelegationVarianceSampleAggregates = {
  __typename?: 'DelegationVarianceSampleAggregates';
  /** Sample variance of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Delegation` values. */
export type DelegationsConnection = {
  __typename?: 'DelegationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DelegationAggregates>;
  /** A list of edges which contains the `Delegation` and cursor to aid in pagination. */
  edges: Array<DelegationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DelegationAggregates>>;
  /** A list of `Delegation` objects. */
  nodes: Array<Delegation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Delegation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Delegation` values. */
export type DelegationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<DelegationGroupBy>;
  having?: InputMaybe<DelegationHavingInput>;
};

/** A `Delegation` edge in the connection. */
export type DelegationsEdge = {
  __typename?: 'DelegationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Delegation` at the end of the edge. */
  node: Delegation;
};

/** Methods to use when ordering `Delegation`. */
export type DelegationsOrderBy =
  | 'ACTIVE_AMOUNT_ASC'
  | 'ACTIVE_AMOUNT_DESC'
  | 'DELEGATOR_ID_SS58_ASC'
  | 'DELEGATOR_ID_SS58_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_SS58_ASC'
  | 'OPERATOR_ID_SS58_DESC'
  | 'UPCOMING_AMOUNT_ASC'
  | 'UPCOMING_AMOUNT_DESC';

export type DepositBalance = {
  __typename?: 'DepositBalance';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  boostBalance: Scalars['BigFloat']['output'];
  boostBalanceValueUsd: Scalars['BigFloat']['output'];
  chain: ChainflipChain;
  lendingSupplyBalance: Scalars['BigFloat']['output'];
  lendingSupplyBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `LpAccount` that is related to this `DepositBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  ordersAmount: Scalars['BigFloat']['output'];
  ordersValueUsd: Scalars['BigFloat']['output'];
  strategyBalance: Scalars['BigFloat']['output'];
  strategyBalanceValueUsd: Scalars['BigFloat']['output'];
  totalBalance: Scalars['BigFloat']['output'];
  totalBalanceValueUsd: Scalars['BigFloat']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type DepositBalanceAggregates = {
  __typename?: 'DepositBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DepositBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DepositBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DepositBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DepositBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DepositBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DepositBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DepositBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DepositBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DepositBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `DepositBalance` object types. */
export type DepositBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `DepositBalance` objects. */
  average?: InputMaybe<DepositBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `DepositBalance` objects. */
  distinctCount?: InputMaybe<DepositBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DepositBalance` object to be included within the aggregate. */
  filter?: InputMaybe<DepositBalanceFilter>;
  /** Maximum aggregate over matching `DepositBalance` objects. */
  max?: InputMaybe<DepositBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `DepositBalance` objects. */
  min?: InputMaybe<DepositBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `DepositBalance` objects. */
  stddevPopulation?: InputMaybe<DepositBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `DepositBalance` objects. */
  stddevSample?: InputMaybe<DepositBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `DepositBalance` objects. */
  sum?: InputMaybe<DepositBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `DepositBalance` objects. */
  variancePopulation?: InputMaybe<DepositBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `DepositBalance` objects. */
  varianceSample?: InputMaybe<DepositBalanceVarianceSampleAggregateFilter>;
};

export type DepositBalanceAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceAverageAggregates = {
  __typename?: 'DepositBalanceAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `DepositBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DepositBalanceCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `boostBalance` field. */
  boostBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `boostBalanceValueUsd` field. */
  boostBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `lendingSupplyBalance` field. */
  lendingSupplyBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lendingSupplyBalanceValueUsd` field. */
  lendingSupplyBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  lpAccountByLpIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ordersAmount` field. */
  ordersAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ordersValueUsd` field. */
  ordersValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `strategyBalance` field. */
  strategyBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `strategyBalanceValueUsd` field. */
  strategyBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBalanceValueUsd` field. */
  totalBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type DepositBalanceDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  boostBalance?: InputMaybe<BigIntFilter>;
  boostBalanceValueUsd?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  lendingSupplyBalance?: InputMaybe<BigIntFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  ordersAmount?: InputMaybe<BigIntFilter>;
  ordersValueUsd?: InputMaybe<BigIntFilter>;
  strategyBalance?: InputMaybe<BigIntFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigIntFilter>;
  totalBalance?: InputMaybe<BigIntFilter>;
  totalBalanceValueUsd?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type DepositBalanceDistinctCountAggregates = {
  __typename?: 'DepositBalanceDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `DepositBalance` object types. All fields are combined with a logical ‘and.’ */
export type DepositBalanceFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepositBalanceFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `boostBalance` field. */
  boostBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boostBalanceValueUsd` field. */
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `lendingSupplyBalance` field. */
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lendingSupplyBalanceValueUsd` field. */
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepositBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepositBalanceFilter>>;
  /** Filter by the object’s `ordersAmount` field. */
  ordersAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ordersValueUsd` field. */
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `strategyBalance` field. */
  strategyBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `strategyBalanceValueUsd` field. */
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBalanceValueUsd` field. */
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `DepositBalance` for usage during aggregation. */
export type DepositBalanceGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BOOST_BALANCE'
  | 'BOOST_BALANCE_VALUE_USD'
  | 'CHAIN'
  | 'LENDING_SUPPLY_BALANCE'
  | 'LENDING_SUPPLY_BALANCE_VALUE_USD'
  | 'LP_ID_SS58'
  | 'ORDERS_AMOUNT'
  | 'ORDERS_VALUE_USD'
  | 'STRATEGY_BALANCE'
  | 'STRATEGY_BALANCE_VALUE_USD'
  | 'TOTAL_BALANCE'
  | 'TOTAL_BALANCE_VALUE_USD'
  | 'VALUE_USD';

export type DepositBalanceHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `DepositBalance` aggregates. */
export type DepositBalanceHavingInput = {
  AND?: InputMaybe<Array<DepositBalanceHavingInput>>;
  OR?: InputMaybe<Array<DepositBalanceHavingInput>>;
  average?: InputMaybe<DepositBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<DepositBalanceHavingDistinctCountInput>;
  max?: InputMaybe<DepositBalanceHavingMaxInput>;
  min?: InputMaybe<DepositBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<DepositBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DepositBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<DepositBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<DepositBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DepositBalanceHavingVarianceSampleInput>;
};

export type DepositBalanceHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  boostBalance?: InputMaybe<HavingBigfloatFilter>;
  boostBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalance?: InputMaybe<HavingBigfloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  ordersAmount?: InputMaybe<HavingBigfloatFilter>;
  ordersValueUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyBalance?: InputMaybe<HavingBigfloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceMaxAggregates = {
  __typename?: 'DepositBalanceMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceMinAggregates = {
  __typename?: 'DepositBalanceMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceStddevPopulationAggregates = {
  __typename?: 'DepositBalanceStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceStddevSampleAggregates = {
  __typename?: 'DepositBalanceStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceSumAggregates = {
  __typename?: 'DepositBalanceSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of boostBalance across the matching connection */
  boostBalance: Scalars['BigFloat']['output'];
  /** Sum of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance: Scalars['BigFloat']['output'];
  /** Sum of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of ordersAmount across the matching connection */
  ordersAmount: Scalars['BigFloat']['output'];
  /** Sum of ordersValueUsd across the matching connection */
  ordersValueUsd: Scalars['BigFloat']['output'];
  /** Sum of strategyBalance across the matching connection */
  strategyBalance: Scalars['BigFloat']['output'];
  /** Sum of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of totalBalance across the matching connection */
  totalBalance: Scalars['BigFloat']['output'];
  /** Sum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type DepositBalanceVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceVariancePopulationAggregates = {
  __typename?: 'DepositBalanceVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  boostBalance?: InputMaybe<BigFloatFilter>;
  boostBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalance?: InputMaybe<BigFloatFilter>;
  lendingSupplyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  ordersAmount?: InputMaybe<BigFloatFilter>;
  ordersValueUsd?: InputMaybe<BigFloatFilter>;
  strategyBalance?: InputMaybe<BigFloatFilter>;
  strategyBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceVarianceSampleAggregates = {
  __typename?: 'DepositBalanceVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostBalance across the matching connection */
  boostBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostBalanceValueUsd across the matching connection */
  boostBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingSupplyBalance across the matching connection */
  lendingSupplyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingSupplyBalanceValueUsd across the matching connection */
  lendingSupplyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ordersAmount across the matching connection */
  ordersAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ordersValueUsd across the matching connection */
  ordersValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of strategyBalance across the matching connection */
  strategyBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of strategyBalanceValueUsd across the matching connection */
  strategyBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `DepositBalance` values. */
export type DepositBalancesConnection = {
  __typename?: 'DepositBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DepositBalanceAggregates>;
  /** A list of edges which contains the `DepositBalance` and cursor to aid in pagination. */
  edges: Array<DepositBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DepositBalanceAggregates>>;
  /** A list of `DepositBalance` objects. */
  nodes: Array<DepositBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DepositBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `DepositBalance` values. */
export type DepositBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<DepositBalanceGroupBy>;
  having?: InputMaybe<DepositBalanceHavingInput>;
};

/** A `DepositBalance` edge in the connection. */
export type DepositBalancesEdge = {
  __typename?: 'DepositBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DepositBalance` at the end of the edge. */
  node: DepositBalance;
};

/** Methods to use when ordering `DepositBalance`. */
export type DepositBalancesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BOOST_BALANCE_ASC'
  | 'BOOST_BALANCE_DESC'
  | 'BOOST_BALANCE_VALUE_USD_ASC'
  | 'BOOST_BALANCE_VALUE_USD_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'LENDING_SUPPLY_BALANCE_ASC'
  | 'LENDING_SUPPLY_BALANCE_DESC'
  | 'LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'ORDERS_AMOUNT_ASC'
  | 'ORDERS_AMOUNT_DESC'
  | 'ORDERS_VALUE_USD_ASC'
  | 'ORDERS_VALUE_USD_DESC'
  | 'STRATEGY_BALANCE_ASC'
  | 'STRATEGY_BALANCE_DESC'
  | 'STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'TOTAL_BALANCE_ASC'
  | 'TOTAL_BALANCE_DESC'
  | 'TOTAL_BALANCE_VALUE_USD_ASC'
  | 'TOTAL_BALANCE_VALUE_USD_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type EnvironmentAddress = Node & {
  __typename?: 'EnvironmentAddress';
  id: Scalars['Int']['output'];
  keyManagerAddress: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  redemptionTax: Scalars['BigFloat']['output'];
  runtimeVersion: Scalars['Int']['output'];
  stateChainGatewayAddress: Scalars['String']['output'];
};

export type EnvironmentAddressAggregates = {
  __typename?: 'EnvironmentAddressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EnvironmentAddressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EnvironmentAddressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EnvironmentAddressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EnvironmentAddressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EnvironmentAddressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EnvironmentAddressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EnvironmentAddressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EnvironmentAddressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EnvironmentAddressVarianceSampleAggregates>;
};

export type EnvironmentAddressAverageAggregates = {
  __typename?: 'EnvironmentAddressAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `EnvironmentAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentAddressCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `keyManagerAddress` field. */
  keyManagerAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `redemptionTax` field. */
  redemptionTax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `runtimeVersion` field. */
  runtimeVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stateChainGatewayAddress` field. */
  stateChainGatewayAddress?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentAddressDistinctCountAggregates = {
  __typename?: 'EnvironmentAddressDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of keyManagerAddress across the matching connection */
  keyManagerAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainGatewayAddress across the matching connection */
  stateChainGatewayAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `EnvironmentAddress` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentAddressFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `keyManagerAddress` field. */
  keyManagerAddress?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentAddressFilter>>;
  /** Filter by the object’s `redemptionTax` field. */
  redemptionTax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `runtimeVersion` field. */
  runtimeVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stateChainGatewayAddress` field. */
  stateChainGatewayAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `EnvironmentAddress` for usage during aggregation. */
export type EnvironmentAddressGroupBy =
  | 'KEY_MANAGER_ADDRESS'
  | 'REDEMPTION_TAX'
  | 'RUNTIME_VERSION'
  | 'STATE_CHAIN_GATEWAY_ADDRESS';

export type EnvironmentAddressHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EnvironmentAddress` aggregates. */
export type EnvironmentAddressHavingInput = {
  AND?: InputMaybe<Array<EnvironmentAddressHavingInput>>;
  OR?: InputMaybe<Array<EnvironmentAddressHavingInput>>;
  average?: InputMaybe<EnvironmentAddressHavingAverageInput>;
  distinctCount?: InputMaybe<EnvironmentAddressHavingDistinctCountInput>;
  max?: InputMaybe<EnvironmentAddressHavingMaxInput>;
  min?: InputMaybe<EnvironmentAddressHavingMinInput>;
  stddevPopulation?: InputMaybe<EnvironmentAddressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EnvironmentAddressHavingStddevSampleInput>;
  sum?: InputMaybe<EnvironmentAddressHavingSumInput>;
  variancePopulation?: InputMaybe<EnvironmentAddressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EnvironmentAddressHavingVarianceSampleInput>;
};

export type EnvironmentAddressHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressMaxAggregates = {
  __typename?: 'EnvironmentAddressMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['Int']['output']>;
};

export type EnvironmentAddressMinAggregates = {
  __typename?: 'EnvironmentAddressMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['Int']['output']>;
};

export type EnvironmentAddressStddevPopulationAggregates = {
  __typename?: 'EnvironmentAddressStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressStddevSampleAggregates = {
  __typename?: 'EnvironmentAddressStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressSumAggregates = {
  __typename?: 'EnvironmentAddressSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of redemptionTax across the matching connection */
  redemptionTax: Scalars['BigFloat']['output'];
  /** Sum of runtimeVersion across the matching connection */
  runtimeVersion: Scalars['BigInt']['output'];
};

export type EnvironmentAddressVariancePopulationAggregates = {
  __typename?: 'EnvironmentAddressVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressVarianceSampleAggregates = {
  __typename?: 'EnvironmentAddressVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `EnvironmentAddress` values. */
export type EnvironmentAddressesConnection = {
  __typename?: 'EnvironmentAddressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EnvironmentAddressAggregates>;
  /** A list of edges which contains the `EnvironmentAddress` and cursor to aid in pagination. */
  edges: Array<EnvironmentAddressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EnvironmentAddressAggregates>>;
  /** A list of `EnvironmentAddress` objects. */
  nodes: Array<EnvironmentAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `EnvironmentAddress` values. */
export type EnvironmentAddressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<EnvironmentAddressGroupBy>;
  having?: InputMaybe<EnvironmentAddressHavingInput>;
};

/** A `EnvironmentAddress` edge in the connection. */
export type EnvironmentAddressesEdge = {
  __typename?: 'EnvironmentAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentAddress` at the end of the edge. */
  node: EnvironmentAddress;
};

/** Methods to use when ordering `EnvironmentAddress`. */
export type EnvironmentAddressesOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEY_MANAGER_ADDRESS_ASC'
  | 'KEY_MANAGER_ADDRESS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REDEMPTION_TAX_ASC'
  | 'REDEMPTION_TAX_DESC'
  | 'RUNTIME_VERSION_ASC'
  | 'RUNTIME_VERSION_DESC'
  | 'STATE_CHAIN_GATEWAY_ADDRESS_ASC'
  | 'STATE_CHAIN_GATEWAY_ADDRESS_DESC';

/** A connection to a list of `FlipSupply` values. */
export type FlipSuppliesConnection = {
  __typename?: 'FlipSuppliesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FlipSupplyAggregates>;
  /** A list of edges which contains the `FlipSupply` and cursor to aid in pagination. */
  edges: Array<FlipSuppliesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FlipSupplyAggregates>>;
  /** A list of `FlipSupply` objects. */
  nodes: Array<FlipSupply>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlipSupply` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `FlipSupply` values. */
export type FlipSuppliesConnectionGroupedAggregatesArgs = {
  groupBy: Array<FlipSupplyGroupBy>;
  having?: InputMaybe<FlipSupplyHavingInput>;
};

/** A `FlipSupply` edge in the connection. */
export type FlipSuppliesEdge = {
  __typename?: 'FlipSuppliesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FlipSupply` at the end of the edge. */
  node: FlipSupply;
};

/** Methods to use when ordering `FlipSupply`. */
export type FlipSuppliesOrderBy =
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS_ASC'
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS_DESC'
  | 'AUTHORITY_EMISSION_PER_BLOCK_ASC'
  | 'AUTHORITY_EMISSION_PER_BLOCK_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OFFCHAIN_FUNDS_ASC'
  | 'OFFCHAIN_FUNDS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_BLOCK_HEIGHT_ASC'
  | 'START_BLOCK_HEIGHT_DESC'
  | 'START_BLOCK_TIMESTAMP_ASC'
  | 'START_BLOCK_TIMESTAMP_DESC'
  | 'TOTAL_ANNUAL_EMISSION_ASC'
  | 'TOTAL_ANNUAL_EMISSION_DESC'
  | 'TOTAL_ISSUANCE_ASC'
  | 'TOTAL_ISSUANCE_DESC';

export type FlipSupply = Node & {
  __typename?: 'FlipSupply';
  annualSystemCompoundedRewards: Scalars['String']['output'];
  authorityEmissionPerBlock: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  offchainFunds: Scalars['String']['output'];
  startBlockHeight: Scalars['Int']['output'];
  startBlockTimestamp: Scalars['BigInt']['output'];
  totalAnnualEmission: Scalars['BigFloat']['output'];
  totalIssuance: Scalars['String']['output'];
};

export type FlipSupplyAggregates = {
  __typename?: 'FlipSupplyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<FlipSupplyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FlipSupplyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<FlipSupplyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<FlipSupplyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<FlipSupplyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<FlipSupplyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<FlipSupplySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<FlipSupplyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<FlipSupplyVarianceSampleAggregates>;
};

export type FlipSupplyAverageAggregates = {
  __typename?: 'FlipSupplyAverageAggregates';
  /** Mean average of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `FlipSupply` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FlipSupplyCondition = {
  /** Checks for equality with the object’s `annualSystemCompoundedRewards` field. */
  annualSystemCompoundedRewards?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `authorityEmissionPerBlock` field. */
  authorityEmissionPerBlock?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `offchainFunds` field. */
  offchainFunds?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockTimestamp` field. */
  startBlockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalAnnualEmission` field. */
  totalAnnualEmission?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalIssuance` field. */
  totalIssuance?: InputMaybe<Scalars['String']['input']>;
};

export type FlipSupplyDistinctCountAggregates = {
  __typename?: 'FlipSupplyDistinctCountAggregates';
  /** Distinct count of annualSystemCompoundedRewards across the matching connection */
  annualSystemCompoundedRewards?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of offchainFunds across the matching connection */
  offchainFunds?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalIssuance across the matching connection */
  totalIssuance?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `FlipSupply` object types. All fields are combined with a logical ‘and.’ */
export type FlipSupplyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlipSupplyFilter>>;
  /** Filter by the object’s `annualSystemCompoundedRewards` field. */
  annualSystemCompoundedRewards?: InputMaybe<StringFilter>;
  /** Filter by the object’s `authorityEmissionPerBlock` field. */
  authorityEmissionPerBlock?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlipSupplyFilter>;
  /** Filter by the object’s `offchainFunds` field. */
  offchainFunds?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlipSupplyFilter>>;
  /** Filter by the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startBlockTimestamp` field. */
  startBlockTimestamp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalAnnualEmission` field. */
  totalAnnualEmission?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalIssuance` field. */
  totalIssuance?: InputMaybe<StringFilter>;
};

/** Grouping methods for `FlipSupply` for usage during aggregation. */
export type FlipSupplyGroupBy =
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS'
  | 'AUTHORITY_EMISSION_PER_BLOCK'
  | 'OFFCHAIN_FUNDS'
  | 'START_BLOCK_HEIGHT'
  | 'START_BLOCK_TIMESTAMP'
  | 'TOTAL_ANNUAL_EMISSION'
  | 'TOTAL_ISSUANCE';

export type FlipSupplyHavingAverageInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingDistinctCountInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `FlipSupply` aggregates. */
export type FlipSupplyHavingInput = {
  AND?: InputMaybe<Array<FlipSupplyHavingInput>>;
  OR?: InputMaybe<Array<FlipSupplyHavingInput>>;
  average?: InputMaybe<FlipSupplyHavingAverageInput>;
  distinctCount?: InputMaybe<FlipSupplyHavingDistinctCountInput>;
  max?: InputMaybe<FlipSupplyHavingMaxInput>;
  min?: InputMaybe<FlipSupplyHavingMinInput>;
  stddevPopulation?: InputMaybe<FlipSupplyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FlipSupplyHavingStddevSampleInput>;
  sum?: InputMaybe<FlipSupplyHavingSumInput>;
  variancePopulation?: InputMaybe<FlipSupplyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FlipSupplyHavingVarianceSampleInput>;
};

export type FlipSupplyHavingMaxInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingMinInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingStddevPopulationInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingStddevSampleInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingSumInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingVariancePopulationInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingVarianceSampleInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyMaxAggregates = {
  __typename?: 'FlipSupplyMaxAggregates';
  /** Maximum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyMinAggregates = {
  __typename?: 'FlipSupplyMinAggregates';
  /** Minimum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyStddevPopulationAggregates = {
  __typename?: 'FlipSupplyStddevPopulationAggregates';
  /** Population standard deviation of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyStddevSampleAggregates = {
  __typename?: 'FlipSupplyStddevSampleAggregates';
  /** Sample standard deviation of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplySumAggregates = {
  __typename?: 'FlipSupplySumAggregates';
  /** Sum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of startBlockHeight across the matching connection */
  startBlockHeight: Scalars['BigInt']['output'];
  /** Sum of startBlockTimestamp across the matching connection */
  startBlockTimestamp: Scalars['BigFloat']['output'];
  /** Sum of totalAnnualEmission across the matching connection */
  totalAnnualEmission: Scalars['BigFloat']['output'];
};

export type FlipSupplyVariancePopulationAggregates = {
  __typename?: 'FlipSupplyVariancePopulationAggregates';
  /** Population variance of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyVarianceSampleAggregates = {
  __typename?: 'FlipSupplyVarianceSampleAggregates';
  /** Sample variance of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type LendingGlobalConfig = Node & {
  __typename?: 'LendingGlobalConfig';
  hardLiquidationLtvAbortAtBps: Scalars['Int']['output'];
  hardLiquidationLtvThresholdBps: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  interestFeeNetworkShareBps: Scalars['Int']['output'];
  liquidationFeeNetworkShareBps: Scalars['Int']['output'];
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['Int']['output']>;
  lowLtvPenaltyBpsAtMinLtv: Scalars['Int']['output'];
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['Int']['output']>;
  lowLtvPenaltyMinLtvBps: Scalars['Int']['output'];
  minLoanRequestAmountUsd: Scalars['BigFloat']['output'];
  minLoanUpdateAmountUsd: Scalars['BigFloat']['output'];
  minSupplyAmountUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  originationFeeNetworkShareBps: Scalars['Int']['output'];
  softLiquidationLtvAbortAtBps: Scalars['Int']['output'];
  softLiquidationLtvThresholdBps: Scalars['Int']['output'];
  targetLtvThresholdBps: Scalars['Int']['output'];
};

export type LendingGlobalConfigAggregates = {
  __typename?: 'LendingGlobalConfigAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingGlobalConfigAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingGlobalConfigDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingGlobalConfigMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingGlobalConfigMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingGlobalConfigStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingGlobalConfigStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingGlobalConfigSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingGlobalConfigVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingGlobalConfigVarianceSampleAggregates>;
};

export type LendingGlobalConfigAverageAggregates = {
  __typename?: 'LendingGlobalConfigAverageAggregates';
  /** Mean average of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingGlobalConfig` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LendingGlobalConfigCondition = {
  /** Checks for equality with the object’s `hardLiquidationLtvAbortAtBps` field. */
  hardLiquidationLtvAbortAtBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `hardLiquidationLtvThresholdBps` field. */
  hardLiquidationLtvThresholdBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interestFeeNetworkShareBps` field. */
  interestFeeNetworkShareBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidationFeeNetworkShareBps` field. */
  liquidationFeeNetworkShareBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lowLtvPenaltyBpsAtMaxLtv` field. */
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lowLtvPenaltyBpsAtMinLtv` field. */
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lowLtvPenaltyMaxLtvBps` field. */
  lowLtvPenaltyMaxLtvBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lowLtvPenaltyMinLtvBps` field. */
  lowLtvPenaltyMinLtvBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minLoanRequestAmountUsd` field. */
  minLoanRequestAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minLoanUpdateAmountUsd` field. */
  minLoanUpdateAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minSupplyAmountUsd` field. */
  minSupplyAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `originationFeeNetworkShareBps` field. */
  originationFeeNetworkShareBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softLiquidationLtvAbortAtBps` field. */
  softLiquidationLtvAbortAtBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softLiquidationLtvThresholdBps` field. */
  softLiquidationLtvThresholdBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetLtvThresholdBps` field. */
  targetLtvThresholdBps?: InputMaybe<Scalars['Int']['input']>;
};

export type LendingGlobalConfigDistinctCountAggregates = {
  __typename?: 'LendingGlobalConfigDistinctCountAggregates';
  /** Distinct count of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingGlobalConfig` object types. All fields are combined with a logical ‘and.’ */
export type LendingGlobalConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingGlobalConfigFilter>>;
  /** Filter by the object’s `hardLiquidationLtvAbortAtBps` field. */
  hardLiquidationLtvAbortAtBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hardLiquidationLtvThresholdBps` field. */
  hardLiquidationLtvThresholdBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interestFeeNetworkShareBps` field. */
  interestFeeNetworkShareBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidationFeeNetworkShareBps` field. */
  liquidationFeeNetworkShareBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowLtvPenaltyBpsAtMaxLtv` field. */
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowLtvPenaltyBpsAtMinLtv` field. */
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowLtvPenaltyMaxLtvBps` field. */
  lowLtvPenaltyMaxLtvBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowLtvPenaltyMinLtvBps` field. */
  lowLtvPenaltyMinLtvBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minLoanRequestAmountUsd` field. */
  minLoanRequestAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minLoanUpdateAmountUsd` field. */
  minLoanUpdateAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minSupplyAmountUsd` field. */
  minSupplyAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingGlobalConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingGlobalConfigFilter>>;
  /** Filter by the object’s `originationFeeNetworkShareBps` field. */
  originationFeeNetworkShareBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softLiquidationLtvAbortAtBps` field. */
  softLiquidationLtvAbortAtBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softLiquidationLtvThresholdBps` field. */
  softLiquidationLtvThresholdBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetLtvThresholdBps` field. */
  targetLtvThresholdBps?: InputMaybe<IntFilter>;
};

/** Grouping methods for `LendingGlobalConfig` for usage during aggregation. */
export type LendingGlobalConfigGroupBy =
  | 'HARD_LIQUIDATION_LTV_ABORT_AT_BPS'
  | 'HARD_LIQUIDATION_LTV_THRESHOLD_BPS'
  | 'INTEREST_FEE_NETWORK_SHARE_BPS'
  | 'LIQUIDATION_FEE_NETWORK_SHARE_BPS'
  | 'LOW_LTV_PENALTY_BPS_AT_MAX_LTV'
  | 'LOW_LTV_PENALTY_BPS_AT_MIN_LTV'
  | 'LOW_LTV_PENALTY_MAX_LTV_BPS'
  | 'LOW_LTV_PENALTY_MIN_LTV_BPS'
  | 'MIN_LOAN_REQUEST_AMOUNT_USD'
  | 'MIN_LOAN_UPDATE_AMOUNT_USD'
  | 'MIN_SUPPLY_AMOUNT_USD'
  | 'ORIGINATION_FEE_NETWORK_SHARE_BPS'
  | 'SOFT_LIQUIDATION_LTV_ABORT_AT_BPS'
  | 'SOFT_LIQUIDATION_LTV_THRESHOLD_BPS'
  | 'TARGET_LTV_THRESHOLD_BPS';

export type LendingGlobalConfigHavingAverageInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingDistinctCountInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LendingGlobalConfig` aggregates. */
export type LendingGlobalConfigHavingInput = {
  AND?: InputMaybe<Array<LendingGlobalConfigHavingInput>>;
  OR?: InputMaybe<Array<LendingGlobalConfigHavingInput>>;
  average?: InputMaybe<LendingGlobalConfigHavingAverageInput>;
  distinctCount?: InputMaybe<LendingGlobalConfigHavingDistinctCountInput>;
  max?: InputMaybe<LendingGlobalConfigHavingMaxInput>;
  min?: InputMaybe<LendingGlobalConfigHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingGlobalConfigHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingGlobalConfigHavingStddevSampleInput>;
  sum?: InputMaybe<LendingGlobalConfigHavingSumInput>;
  variancePopulation?: InputMaybe<LendingGlobalConfigHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingGlobalConfigHavingVarianceSampleInput>;
};

export type LendingGlobalConfigHavingMaxInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingMinInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingStddevPopulationInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingStddevSampleInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingSumInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingVariancePopulationInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigHavingVarianceSampleInput = {
  hardLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  hardLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMaxLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyBpsAtMinLtv?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMaxLtvBps?: InputMaybe<HavingIntFilter>;
  lowLtvPenaltyMinLtvBps?: InputMaybe<HavingIntFilter>;
  minLoanRequestAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLoanUpdateAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minSupplyAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  originationFeeNetworkShareBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvAbortAtBps?: InputMaybe<HavingIntFilter>;
  softLiquidationLtvThresholdBps?: InputMaybe<HavingIntFilter>;
  targetLtvThresholdBps?: InputMaybe<HavingIntFilter>;
};

export type LendingGlobalConfigMaxAggregates = {
  __typename?: 'LendingGlobalConfigMaxAggregates';
  /** Maximum of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingGlobalConfigMinAggregates = {
  __typename?: 'LendingGlobalConfigMinAggregates';
  /** Minimum of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingGlobalConfigStddevPopulationAggregates = {
  __typename?: 'LendingGlobalConfigStddevPopulationAggregates';
  /** Population standard deviation of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingGlobalConfigStddevSampleAggregates = {
  __typename?: 'LendingGlobalConfigStddevSampleAggregates';
  /** Sample standard deviation of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingGlobalConfigSumAggregates = {
  __typename?: 'LendingGlobalConfigSumAggregates';
  /** Sum of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps: Scalars['BigInt']['output'];
  /** Sum of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps: Scalars['BigInt']['output'];
  /** Sum of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps: Scalars['BigInt']['output'];
  /** Sum of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv: Scalars['BigInt']['output'];
  /** Sum of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv: Scalars['BigInt']['output'];
  /** Sum of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps: Scalars['BigInt']['output'];
  /** Sum of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps: Scalars['BigInt']['output'];
  /** Sum of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps: Scalars['BigInt']['output'];
  /** Sum of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps: Scalars['BigInt']['output'];
  /** Sum of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps: Scalars['BigInt']['output'];
  /** Sum of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps: Scalars['BigInt']['output'];
};

export type LendingGlobalConfigVariancePopulationAggregates = {
  __typename?: 'LendingGlobalConfigVariancePopulationAggregates';
  /** Population variance of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingGlobalConfigVarianceSampleAggregates = {
  __typename?: 'LendingGlobalConfigVarianceSampleAggregates';
  /** Sample variance of hardLiquidationLtvAbortAtBps across the matching connection */
  hardLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of hardLiquidationLtvThresholdBps across the matching connection */
  hardLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestFeeNetworkShareBps across the matching connection */
  interestFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidationFeeNetworkShareBps across the matching connection */
  liquidationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lowLtvPenaltyBpsAtMaxLtv across the matching connection */
  lowLtvPenaltyBpsAtMaxLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lowLtvPenaltyBpsAtMinLtv across the matching connection */
  lowLtvPenaltyBpsAtMinLtv?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lowLtvPenaltyMaxLtvBps across the matching connection */
  lowLtvPenaltyMaxLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lowLtvPenaltyMinLtvBps across the matching connection */
  lowLtvPenaltyMinLtvBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minLoanRequestAmountUsd across the matching connection */
  minLoanRequestAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minLoanUpdateAmountUsd across the matching connection */
  minLoanUpdateAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minSupplyAmountUsd across the matching connection */
  minSupplyAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originationFeeNetworkShareBps across the matching connection */
  originationFeeNetworkShareBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of softLiquidationLtvAbortAtBps across the matching connection */
  softLiquidationLtvAbortAtBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of softLiquidationLtvThresholdBps across the matching connection */
  softLiquidationLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of targetLtvThresholdBps across the matching connection */
  targetLtvThresholdBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingGlobalConfig` values. */
export type LendingGlobalConfigsConnection = {
  __typename?: 'LendingGlobalConfigsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingGlobalConfigAggregates>;
  /** A list of edges which contains the `LendingGlobalConfig` and cursor to aid in pagination. */
  edges: Array<LendingGlobalConfigsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingGlobalConfigAggregates>>;
  /** A list of `LendingGlobalConfig` objects. */
  nodes: Array<LendingGlobalConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingGlobalConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingGlobalConfig` values. */
export type LendingGlobalConfigsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingGlobalConfigGroupBy>;
  having?: InputMaybe<LendingGlobalConfigHavingInput>;
};

/** A `LendingGlobalConfig` edge in the connection. */
export type LendingGlobalConfigsEdge = {
  __typename?: 'LendingGlobalConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingGlobalConfig` at the end of the edge. */
  node: LendingGlobalConfig;
};

/** Methods to use when ordering `LendingGlobalConfig`. */
export type LendingGlobalConfigsOrderBy =
  | 'HARD_LIQUIDATION_LTV_ABORT_AT_BPS_ASC'
  | 'HARD_LIQUIDATION_LTV_ABORT_AT_BPS_DESC'
  | 'HARD_LIQUIDATION_LTV_THRESHOLD_BPS_ASC'
  | 'HARD_LIQUIDATION_LTV_THRESHOLD_BPS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEREST_FEE_NETWORK_SHARE_BPS_ASC'
  | 'INTEREST_FEE_NETWORK_SHARE_BPS_DESC'
  | 'LIQUIDATION_FEE_NETWORK_SHARE_BPS_ASC'
  | 'LIQUIDATION_FEE_NETWORK_SHARE_BPS_DESC'
  | 'LOW_LTV_PENALTY_BPS_AT_MAX_LTV_ASC'
  | 'LOW_LTV_PENALTY_BPS_AT_MAX_LTV_DESC'
  | 'LOW_LTV_PENALTY_BPS_AT_MIN_LTV_ASC'
  | 'LOW_LTV_PENALTY_BPS_AT_MIN_LTV_DESC'
  | 'LOW_LTV_PENALTY_MAX_LTV_BPS_ASC'
  | 'LOW_LTV_PENALTY_MAX_LTV_BPS_DESC'
  | 'LOW_LTV_PENALTY_MIN_LTV_BPS_ASC'
  | 'LOW_LTV_PENALTY_MIN_LTV_BPS_DESC'
  | 'MIN_LOAN_REQUEST_AMOUNT_USD_ASC'
  | 'MIN_LOAN_REQUEST_AMOUNT_USD_DESC'
  | 'MIN_LOAN_UPDATE_AMOUNT_USD_ASC'
  | 'MIN_LOAN_UPDATE_AMOUNT_USD_DESC'
  | 'MIN_SUPPLY_AMOUNT_USD_ASC'
  | 'MIN_SUPPLY_AMOUNT_USD_DESC'
  | 'NATURAL'
  | 'ORIGINATION_FEE_NETWORK_SHARE_BPS_ASC'
  | 'ORIGINATION_FEE_NETWORK_SHARE_BPS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SOFT_LIQUIDATION_LTV_ABORT_AT_BPS_ASC'
  | 'SOFT_LIQUIDATION_LTV_ABORT_AT_BPS_DESC'
  | 'SOFT_LIQUIDATION_LTV_THRESHOLD_BPS_ASC'
  | 'SOFT_LIQUIDATION_LTV_THRESHOLD_BPS_DESC'
  | 'TARGET_LTV_THRESHOLD_BPS_ASC'
  | 'TARGET_LTV_THRESHOLD_BPS_DESC';

export type LendingPool = {
  __typename?: 'LendingPool';
  addingLenderFundsEnabled: Scalars['Boolean']['output'];
  asset: ChainflipAsset;
  borrowingEnabled: Scalars['Boolean']['output'];
  interestAtJunctionBps: Scalars['Int']['output'];
  interestAtMaxUtilisationBps: Scalars['Int']['output'];
  interestAtZeroUtilisationBps: Scalars['Int']['output'];
  interestRateBps: Scalars['Int']['output'];
  junctionUtilisationBps: Scalars['Int']['output'];
  liquidationFeeBps: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Loan`. */
  loansByAsset: LoansConnection;
  /** Reads and enables pagination through a set of `LpLendingBalance`. */
  lpLendingBalancesByAsset: LpLendingBalancesConnection;
  /** Reads a single `OraclePrice` that is related to this `LendingPool`. */
  oraclePriceByOraclePriceId: OraclePrice;
  oraclePriceId: Scalars['Int']['output'];
  originationFeeBps: Scalars['Int']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  totalAmountUsd: Scalars['BigFloat']['output'];
  totalAvailableAmount: Scalars['BigFloat']['output'];
  totalAvailableAmountUsd: Scalars['BigFloat']['output'];
  totalBorrowedAmount: Scalars['BigFloat']['output'];
  totalBorrowedAmountUsd: Scalars['BigFloat']['output'];
  utilisationCapBps: Scalars['Int']['output'];
  utilisationRateBps: Scalars['Int']['output'];
  withdrawingLenderFundsEnabled: Scalars['Boolean']['output'];
};


export type LendingPoolLoansByAssetArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type LendingPoolLpLendingBalancesByAssetArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingBalanceCondition>;
  filter?: InputMaybe<LpLendingBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingBalancesOrderBy>>;
};

export type LendingPoolAggregates = {
  __typename?: 'LendingPoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingPoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingPoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingPoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingPoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingPoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingPoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingPoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingPoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingPoolVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LendingPool` object types. */
export type LendingPoolAggregatesFilter = {
  /** Mean average aggregate over matching `LendingPool` objects. */
  average?: InputMaybe<LendingPoolAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LendingPool` objects. */
  distinctCount?: InputMaybe<LendingPoolDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LendingPool` object to be included within the aggregate. */
  filter?: InputMaybe<LendingPoolFilter>;
  /** Maximum aggregate over matching `LendingPool` objects. */
  max?: InputMaybe<LendingPoolMaxAggregateFilter>;
  /** Minimum aggregate over matching `LendingPool` objects. */
  min?: InputMaybe<LendingPoolMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LendingPool` objects. */
  stddevPopulation?: InputMaybe<LendingPoolStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LendingPool` objects. */
  stddevSample?: InputMaybe<LendingPoolStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LendingPool` objects. */
  sum?: InputMaybe<LendingPoolSumAggregateFilter>;
  /** Population variance aggregate over matching `LendingPool` objects. */
  variancePopulation?: InputMaybe<LendingPoolVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LendingPool` objects. */
  varianceSample?: InputMaybe<LendingPoolVarianceSampleAggregateFilter>;
};

export type LendingPoolAverageAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigFloatFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  junctionUtilisationBps?: InputMaybe<BigFloatFilter>;
  liquidationFeeBps?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  originationFeeBps?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolAverageAggregates = {
  __typename?: 'LendingPoolAverageAggregates';
  /** Mean average of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingPool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LendingPoolCondition = {
  /** Checks for equality with the object’s `addingLenderFundsEnabled` field. */
  addingLenderFundsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `borrowingEnabled` field. */
  borrowingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `interestAtJunctionBps` field. */
  interestAtJunctionBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interestAtMaxUtilisationBps` field. */
  interestAtMaxUtilisationBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interestAtZeroUtilisationBps` field. */
  interestAtZeroUtilisationBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interestRateBps` field. */
  interestRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `junctionUtilisationBps` field. */
  junctionUtilisationBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidationFeeBps` field. */
  liquidationFeeBps?: InputMaybe<Scalars['Int']['input']>;
  oraclePriceByOraclePriceId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `originationFeeBps` field. */
  originationFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAmountUsd` field. */
  totalAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAvailableAmount` field. */
  totalAvailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAvailableAmountUsd` field. */
  totalAvailableAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBorrowedAmount` field. */
  totalBorrowedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBorrowedAmountUsd` field. */
  totalBorrowedAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `utilisationCapBps` field. */
  utilisationCapBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilisationRateBps` field. */
  utilisationRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `withdrawingLenderFundsEnabled` field. */
  withdrawingLenderFundsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LendingPoolDistinctCountAggregateFilter = {
  addingLenderFundsEnabled?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  borrowingEnabled?: InputMaybe<BigIntFilter>;
  interestAtJunctionBps?: InputMaybe<BigIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigIntFilter>;
  interestRateBps?: InputMaybe<BigIntFilter>;
  junctionUtilisationBps?: InputMaybe<BigIntFilter>;
  liquidationFeeBps?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
  originationFeeBps?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  totalAmountUsd?: InputMaybe<BigIntFilter>;
  totalAvailableAmount?: InputMaybe<BigIntFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigIntFilter>;
  totalBorrowedAmount?: InputMaybe<BigIntFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigIntFilter>;
  utilisationCapBps?: InputMaybe<BigIntFilter>;
  utilisationRateBps?: InputMaybe<BigIntFilter>;
  withdrawingLenderFundsEnabled?: InputMaybe<BigIntFilter>;
};

export type LendingPoolDistinctCountAggregates = {
  __typename?: 'LendingPoolDistinctCountAggregates';
  /** Distinct count of addingLenderFundsEnabled across the matching connection */
  addingLenderFundsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of borrowingEnabled across the matching connection */
  borrowingEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawingLenderFundsEnabled across the matching connection */
  withdrawingLenderFundsEnabled?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingPool` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolFilter = {
  /** Filter by the object’s `addingLenderFundsEnabled` field. */
  addingLenderFundsEnabled?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingPoolFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `borrowingEnabled` field. */
  borrowingEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `interestAtJunctionBps` field. */
  interestAtJunctionBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interestAtMaxUtilisationBps` field. */
  interestAtMaxUtilisationBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interestAtZeroUtilisationBps` field. */
  interestAtZeroUtilisationBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interestRateBps` field. */
  interestRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `junctionUtilisationBps` field. */
  junctionUtilisationBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidationFeeBps` field. */
  liquidationFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loansByAsset` relation. */
  loansByAsset?: InputMaybe<LendingPoolToManyLoanFilter>;
  /** Some related `loansByAsset` exist. */
  loansByAssetExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpLendingBalancesByAsset` relation. */
  lpLendingBalancesByAsset?: InputMaybe<LendingPoolToManyLpLendingBalanceFilter>;
  /** Some related `lpLendingBalancesByAsset` exist. */
  lpLendingBalancesByAssetExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LendingPoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingPoolFilter>>;
  /** Filter by the object’s `oraclePriceByOraclePriceId` relation. */
  oraclePriceByOraclePriceId?: InputMaybe<OraclePriceFilter>;
  /** Filter by the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `originationFeeBps` field. */
  originationFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAmountUsd` field. */
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAvailableAmount` field. */
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAvailableAmountUsd` field. */
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBorrowedAmount` field. */
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBorrowedAmountUsd` field. */
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `utilisationCapBps` field. */
  utilisationCapBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilisationRateBps` field. */
  utilisationRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `withdrawingLenderFundsEnabled` field. */
  withdrawingLenderFundsEnabled?: InputMaybe<BooleanFilter>;
};

/** Grouping methods for `LendingPool` for usage during aggregation. */
export type LendingPoolGroupBy =
  | 'ADDING_LENDER_FUNDS_ENABLED'
  | 'BORROWING_ENABLED'
  | 'INTEREST_AT_JUNCTION_BPS'
  | 'INTEREST_AT_MAX_UTILISATION_BPS'
  | 'INTEREST_AT_ZERO_UTILISATION_BPS'
  | 'INTEREST_RATE_BPS'
  | 'JUNCTION_UTILISATION_BPS'
  | 'LIQUIDATION_FEE_BPS'
  | 'ORACLE_PRICE_ID'
  | 'ORIGINATION_FEE_BPS'
  | 'TOTAL_AMOUNT'
  | 'TOTAL_AMOUNT_USD'
  | 'TOTAL_AVAILABLE_AMOUNT'
  | 'TOTAL_AVAILABLE_AMOUNT_USD'
  | 'TOTAL_BORROWED_AMOUNT'
  | 'TOTAL_BORROWED_AMOUNT_USD'
  | 'UTILISATION_CAP_BPS'
  | 'UTILISATION_RATE_BPS'
  | 'WITHDRAWING_LENDER_FUNDS_ENABLED';

export type LendingPoolHavingAverageInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingDistinctCountInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LendingPool` aggregates. */
export type LendingPoolHavingInput = {
  AND?: InputMaybe<Array<LendingPoolHavingInput>>;
  OR?: InputMaybe<Array<LendingPoolHavingInput>>;
  average?: InputMaybe<LendingPoolHavingAverageInput>;
  distinctCount?: InputMaybe<LendingPoolHavingDistinctCountInput>;
  max?: InputMaybe<LendingPoolHavingMaxInput>;
  min?: InputMaybe<LendingPoolHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingPoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingPoolHavingStddevSampleInput>;
  sum?: InputMaybe<LendingPoolHavingSumInput>;
  variancePopulation?: InputMaybe<LendingPoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingPoolHavingVarianceSampleInput>;
};

export type LendingPoolHavingMaxInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingMinInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingStddevPopulationInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingStddevSampleInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingSumInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingVariancePopulationInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolHavingVarianceSampleInput = {
  interestAtJunctionBps?: InputMaybe<HavingIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<HavingIntFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  junctionUtilisationBps?: InputMaybe<HavingIntFilter>;
  liquidationFeeBps?: InputMaybe<HavingIntFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  originationFeeBps?: InputMaybe<HavingIntFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmount?: InputMaybe<HavingBigfloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationCapBps?: InputMaybe<HavingIntFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolMaxAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<IntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<IntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<IntFilter>;
  interestRateBps?: InputMaybe<IntFilter>;
  junctionUtilisationBps?: InputMaybe<IntFilter>;
  liquidationFeeBps?: InputMaybe<IntFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  originationFeeBps?: InputMaybe<IntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<IntFilter>;
  utilisationRateBps?: InputMaybe<IntFilter>;
};

export type LendingPoolMaxAggregates = {
  __typename?: 'LendingPoolMaxAggregates';
  /** Maximum of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolMinAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<IntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<IntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<IntFilter>;
  interestRateBps?: InputMaybe<IntFilter>;
  junctionUtilisationBps?: InputMaybe<IntFilter>;
  liquidationFeeBps?: InputMaybe<IntFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  originationFeeBps?: InputMaybe<IntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<IntFilter>;
  utilisationRateBps?: InputMaybe<IntFilter>;
};

export type LendingPoolMinAggregates = {
  __typename?: 'LendingPoolMinAggregates';
  /** Minimum of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolStddevPopulationAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigFloatFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  junctionUtilisationBps?: InputMaybe<BigFloatFilter>;
  liquidationFeeBps?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  originationFeeBps?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStddevPopulationAggregates = {
  __typename?: 'LendingPoolStddevPopulationAggregates';
  /** Population standard deviation of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolStddevSampleAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigFloatFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  junctionUtilisationBps?: InputMaybe<BigFloatFilter>;
  liquidationFeeBps?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  originationFeeBps?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStddevSampleAggregates = {
  __typename?: 'LendingPoolStddevSampleAggregates';
  /** Sample standard deviation of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolSumAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigIntFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigIntFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigIntFilter>;
  interestRateBps?: InputMaybe<BigIntFilter>;
  junctionUtilisationBps?: InputMaybe<BigIntFilter>;
  liquidationFeeBps?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
  originationFeeBps?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigIntFilter>;
  utilisationRateBps?: InputMaybe<BigIntFilter>;
};

export type LendingPoolSumAggregates = {
  __typename?: 'LendingPoolSumAggregates';
  /** Sum of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps: Scalars['BigInt']['output'];
  /** Sum of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps: Scalars['BigInt']['output'];
  /** Sum of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps: Scalars['BigInt']['output'];
  /** Sum of interestRateBps across the matching connection */
  interestRateBps: Scalars['BigInt']['output'];
  /** Sum of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps: Scalars['BigInt']['output'];
  /** Sum of liquidationFeeBps across the matching connection */
  liquidationFeeBps: Scalars['BigInt']['output'];
  /** Sum of oraclePriceId across the matching connection */
  oraclePriceId: Scalars['BigInt']['output'];
  /** Sum of originationFeeBps across the matching connection */
  originationFeeBps: Scalars['BigInt']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAmountUsd across the matching connection */
  totalAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of totalAvailableAmount across the matching connection */
  totalAvailableAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount: Scalars['BigFloat']['output'];
  /** Sum of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of utilisationCapBps across the matching connection */
  utilisationCapBps: Scalars['BigInt']['output'];
  /** Sum of utilisationRateBps across the matching connection */
  utilisationRateBps: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `LpLendingBalance` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLpLendingBalanceFilter = {
  /** Aggregates across related `LpLendingBalance` match the filter criteria. */
  aggregates?: InputMaybe<LpLendingBalanceAggregatesFilter>;
  /** Every related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpLendingBalanceFilter>;
  /** No related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpLendingBalanceFilter>;
  /** Some related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpLendingBalanceFilter>;
};

export type LendingPoolVariancePopulationAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigFloatFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  junctionUtilisationBps?: InputMaybe<BigFloatFilter>;
  liquidationFeeBps?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  originationFeeBps?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolVariancePopulationAggregates = {
  __typename?: 'LendingPoolVariancePopulationAggregates';
  /** Population variance of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolVarianceSampleAggregateFilter = {
  interestAtJunctionBps?: InputMaybe<BigFloatFilter>;
  interestAtMaxUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestAtZeroUtilisationBps?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  junctionUtilisationBps?: InputMaybe<BigFloatFilter>;
  liquidationFeeBps?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  originationFeeBps?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmount?: InputMaybe<BigFloatFilter>;
  totalBorrowedAmountUsd?: InputMaybe<BigFloatFilter>;
  utilisationCapBps?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolVarianceSampleAggregates = {
  __typename?: 'LendingPoolVarianceSampleAggregates';
  /** Sample variance of interestAtJunctionBps across the matching connection */
  interestAtJunctionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestAtMaxUtilisationBps across the matching connection */
  interestAtMaxUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestAtZeroUtilisationBps across the matching connection */
  interestAtZeroUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of junctionUtilisationBps across the matching connection */
  junctionUtilisationBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidationFeeBps across the matching connection */
  liquidationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originationFeeBps across the matching connection */
  originationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBorrowedAmount across the matching connection */
  totalBorrowedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBorrowedAmountUsd across the matching connection */
  totalBorrowedAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of utilisationCapBps across the matching connection */
  utilisationCapBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingPool` values. */
export type LendingPoolsConnection = {
  __typename?: 'LendingPoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingPoolAggregates>;
  /** A list of edges which contains the `LendingPool` and cursor to aid in pagination. */
  edges: Array<LendingPoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingPoolAggregates>>;
  /** A list of `LendingPool` objects. */
  nodes: Array<LendingPool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingPool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingPool` values. */
export type LendingPoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingPoolGroupBy>;
  having?: InputMaybe<LendingPoolHavingInput>;
};

/** A `LendingPool` edge in the connection. */
export type LendingPoolsEdge = {
  __typename?: 'LendingPoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingPool` at the end of the edge. */
  node: LendingPool;
};

/** Methods to use when ordering `LendingPool`. */
export type LendingPoolsOrderBy =
  | 'ADDING_LENDER_FUNDS_ENABLED_ASC'
  | 'ADDING_LENDER_FUNDS_ENABLED_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BORROWING_ENABLED_ASC'
  | 'BORROWING_ENABLED_DESC'
  | 'INTEREST_AT_JUNCTION_BPS_ASC'
  | 'INTEREST_AT_JUNCTION_BPS_DESC'
  | 'INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'INTEREST_RATE_BPS_ASC'
  | 'INTEREST_RATE_BPS_DESC'
  | 'JUNCTION_UTILISATION_BPS_ASC'
  | 'JUNCTION_UTILISATION_BPS_DESC'
  | 'LIQUIDATION_FEE_BPS_ASC'
  | 'LIQUIDATION_FEE_BPS_DESC'
  | 'LOANS_BY_ASSET_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_AVERAGE_ID_ASC'
  | 'LOANS_BY_ASSET_AVERAGE_ID_DESC'
  | 'LOANS_BY_ASSET_AVERAGE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_AVERAGE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_AVERAGE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_AVERAGE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_COUNT_ASC'
  | 'LOANS_BY_ASSET_COUNT_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_STATUS_ASC'
  | 'LOANS_BY_ASSET_DISTINCT_COUNT_STATUS_DESC'
  | 'LOANS_BY_ASSET_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_MAX_ID_ASC'
  | 'LOANS_BY_ASSET_MAX_ID_DESC'
  | 'LOANS_BY_ASSET_MAX_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_MAX_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_MAX_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_MAX_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_MIN_ID_ASC'
  | 'LOANS_BY_ASSET_MIN_ID_DESC'
  | 'LOANS_BY_ASSET_MIN_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_MIN_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_MIN_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_MIN_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_STDDEV_POPULATION_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_SUM_ID_ASC'
  | 'LOANS_BY_ASSET_SUM_ID_DESC'
  | 'LOANS_BY_ASSET_SUM_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_SUM_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_SUM_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_SUM_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_ASSET_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_COUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_COUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MAX_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_MIN_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_SUM_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_ASSET_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'NATURAL'
  | 'ORACLE_PRICE_ID_ASC'
  | 'ORACLE_PRICE_ID_DESC'
  | 'ORIGINATION_FEE_BPS_ASC'
  | 'ORIGINATION_FEE_BPS_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'TOTAL_AMOUNT_USD_ASC'
  | 'TOTAL_AMOUNT_USD_DESC'
  | 'TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'TOTAL_BORROWED_AMOUNT_ASC'
  | 'TOTAL_BORROWED_AMOUNT_DESC'
  | 'TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'UTILISATION_CAP_BPS_ASC'
  | 'UTILISATION_CAP_BPS_DESC'
  | 'UTILISATION_RATE_BPS_ASC'
  | 'UTILISATION_RATE_BPS_DESC'
  | 'WITHDRAWING_LENDER_FUNDS_ENABLED_ASC'
  | 'WITHDRAWING_LENDER_FUNDS_ENABLED_DESC';

export type Loan = Node & {
  __typename?: 'Loan';
  asset: ChainflipAsset;
  borrowerType: LoanBorrowerType;
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  brokerIdSs58?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  /** Reads a single `LendingPool` that is related to this `Loan`. */
  lendingPoolByAsset: LendingPool;
  loanAccountLpIdSs58?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LpLoanAccount` that is related to this `Loan`. */
  lpLoanAccountByLoanAccountLpIdSs58?: Maybe<LpLoanAccount>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  principalAmount: Scalars['BigFloat']['output'];
  principalAmountUsd: Scalars['BigFloat']['output'];
  status: LoanStatus;
};

export type LoanAggregates = {
  __typename?: 'LoanAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LoanAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LoanDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LoanMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LoanMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LoanStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LoanStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LoanSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LoanVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LoanVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Loan` object types. */
export type LoanAggregatesFilter = {
  /** Mean average aggregate over matching `Loan` objects. */
  average?: InputMaybe<LoanAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Loan` objects. */
  distinctCount?: InputMaybe<LoanDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Loan` object to be included within the aggregate. */
  filter?: InputMaybe<LoanFilter>;
  /** Maximum aggregate over matching `Loan` objects. */
  max?: InputMaybe<LoanMaxAggregateFilter>;
  /** Minimum aggregate over matching `Loan` objects. */
  min?: InputMaybe<LoanMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Loan` objects. */
  stddevPopulation?: InputMaybe<LoanStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Loan` objects. */
  stddevSample?: InputMaybe<LoanStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Loan` objects. */
  sum?: InputMaybe<LoanSumAggregateFilter>;
  /** Population variance aggregate over matching `Loan` objects. */
  variancePopulation?: InputMaybe<LoanVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Loan` objects. */
  varianceSample?: InputMaybe<LoanVarianceSampleAggregateFilter>;
};

export type LoanAverageAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanAverageAggregates = {
  __typename?: 'LoanAverageAggregates';
  /** Mean average of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanBorrowerType =
  | 'SYSTEM_BOOST'
  | 'USER';

/** A filter to be used against LoanBorrowerType fields. All fields are combined with a logical ‘and.’ */
export type LoanBorrowerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoanBorrowerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoanBorrowerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoanBorrowerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoanBorrowerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoanBorrowerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoanBorrowerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoanBorrowerType>>;
};

/** A condition to be used against `Loan` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LoanCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `borrowerType` field. */
  borrowerType?: InputMaybe<LoanBorrowerType>;
  /** Checks for equality with the object’s `brokerCommissionBps` field. */
  brokerCommissionBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerIdSs58` field. */
  brokerIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loanAccountLpIdSs58` field. */
  loanAccountLpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `principalAmount` field. */
  principalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `principalAmountUsd` field. */
  principalAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LoanStatus>;
};

export type LoanDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  borrowerType?: InputMaybe<BigIntFilter>;
  brokerCommissionBps?: InputMaybe<BigIntFilter>;
  brokerIdSs58?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanAccountLpIdSs58?: InputMaybe<BigIntFilter>;
  principalAmount?: InputMaybe<BigIntFilter>;
  principalAmountUsd?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
};

export type LoanDistinctCountAggregates = {
  __typename?: 'LoanDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of borrowerType across the matching connection */
  borrowerType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerIdSs58 across the matching connection */
  brokerIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanAccountLpIdSs58 across the matching connection */
  loanAccountLpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Loan` object types. All fields are combined with a logical ‘and.’ */
export type LoanFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoanFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `borrowerType` field. */
  borrowerType?: InputMaybe<LoanBorrowerTypeFilter>;
  /** Filter by the object’s `brokerCommissionBps` field. */
  brokerCommissionBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerIdSs58` field. */
  brokerIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lendingPoolByAsset` relation. */
  lendingPoolByAsset?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `loanAccountLpIdSs58` field. */
  loanAccountLpIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpLoanAccountByLoanAccountLpIdSs58` relation. */
  lpLoanAccountByLoanAccountLpIdSs58?: InputMaybe<LpLoanAccountFilter>;
  /** A related `lpLoanAccountByLoanAccountLpIdSs58` exists. */
  lpLoanAccountByLoanAccountLpIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LoanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoanFilter>>;
  /** Filter by the object’s `principalAmount` field. */
  principalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `principalAmountUsd` field. */
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LoanStatusFilter>;
};

/** Grouping methods for `Loan` for usage during aggregation. */
export type LoanGroupBy =
  | 'ASSET'
  | 'BORROWER_TYPE'
  | 'BROKER_COMMISSION_BPS'
  | 'BROKER_ID_SS58'
  | 'LOAN_ACCOUNT_LP_ID_SS58'
  | 'PRINCIPAL_AMOUNT'
  | 'PRINCIPAL_AMOUNT_USD'
  | 'STATUS';

export type LoanHavingAverageInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingDistinctCountInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Loan` aggregates. */
export type LoanHavingInput = {
  AND?: InputMaybe<Array<LoanHavingInput>>;
  OR?: InputMaybe<Array<LoanHavingInput>>;
  average?: InputMaybe<LoanHavingAverageInput>;
  distinctCount?: InputMaybe<LoanHavingDistinctCountInput>;
  max?: InputMaybe<LoanHavingMaxInput>;
  min?: InputMaybe<LoanHavingMinInput>;
  stddevPopulation?: InputMaybe<LoanHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LoanHavingStddevSampleInput>;
  sum?: InputMaybe<LoanHavingSumInput>;
  variancePopulation?: InputMaybe<LoanHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LoanHavingVarianceSampleInput>;
};

export type LoanHavingMaxInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingMinInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingStddevPopulationInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingStddevSampleInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingSumInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingVariancePopulationInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanHavingVarianceSampleInput = {
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  principalAmount?: InputMaybe<HavingBigfloatFilter>;
  principalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanMaxAggregateFilter = {
  brokerCommissionBps?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanMaxAggregates = {
  __typename?: 'LoanMaxAggregates';
  /** Maximum of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanMinAggregateFilter = {
  brokerCommissionBps?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanMinAggregates = {
  __typename?: 'LoanMinAggregates';
  /** Minimum of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanStatus =
  | 'Active'
  | 'HardLiquidation'
  | 'SoftLiquidation'
  | 'SoftVoluntaryLiquidation';

/** A filter to be used against LoanStatus fields. All fields are combined with a logical ‘and.’ */
export type LoanStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoanStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoanStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoanStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoanStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoanStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoanStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoanStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoanStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoanStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoanStatus>>;
};

export type LoanStddevPopulationAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanStddevPopulationAggregates = {
  __typename?: 'LoanStddevPopulationAggregates';
  /** Population standard deviation of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanStddevSampleAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanStddevSampleAggregates = {
  __typename?: 'LoanStddevSampleAggregates';
  /** Sample standard deviation of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanSumAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanSumAggregates = {
  __typename?: 'LoanSumAggregates';
  /** Sum of brokerCommissionBps across the matching connection */
  brokerCommissionBps: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of principalAmount across the matching connection */
  principalAmount: Scalars['BigFloat']['output'];
  /** Sum of principalAmountUsd across the matching connection */
  principalAmountUsd: Scalars['BigFloat']['output'];
};

export type LoanVariancePopulationAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanVariancePopulationAggregates = {
  __typename?: 'LoanVariancePopulationAggregates';
  /** Population variance of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanVarianceSampleAggregateFilter = {
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  principalAmount?: InputMaybe<BigFloatFilter>;
  principalAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanVarianceSampleAggregates = {
  __typename?: 'LoanVarianceSampleAggregates';
  /** Sample variance of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of principalAmount across the matching connection */
  principalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of principalAmountUsd across the matching connection */
  principalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Loan` values. */
export type LoansConnection = {
  __typename?: 'LoansConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LoanAggregates>;
  /** A list of edges which contains the `Loan` and cursor to aid in pagination. */
  edges: Array<LoansEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LoanAggregates>>;
  /** A list of `Loan` objects. */
  nodes: Array<Loan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Loan` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Loan` values. */
export type LoansConnectionGroupedAggregatesArgs = {
  groupBy: Array<LoanGroupBy>;
  having?: InputMaybe<LoanHavingInput>;
};

/** A `Loan` edge in the connection. */
export type LoansEdge = {
  __typename?: 'LoansEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Loan` at the end of the edge. */
  node: Loan;
};

/** Methods to use when ordering `Loan`. */
export type LoansOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BORROWER_TYPE_ASC'
  | 'BORROWER_TYPE_DESC'
  | 'BROKER_COMMISSION_BPS_ASC'
  | 'BROKER_COMMISSION_BPS_DESC'
  | 'BROKER_ID_SS58_ASC'
  | 'BROKER_ID_SS58_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOAN_ACCOUNT_LP_ID_SS58_ASC'
  | 'LOAN_ACCOUNT_LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRINCIPAL_AMOUNT_ASC'
  | 'PRINCIPAL_AMOUNT_DESC'
  | 'PRINCIPAL_AMOUNT_USD_ASC'
  | 'PRINCIPAL_AMOUNT_USD_DESC'
  | 'STATUS_ASC'
  | 'STATUS_DESC';

export type LpAccount = Node & {
  __typename?: 'LpAccount';
  /** Reads a single `Account` that is related to this `LpAccount`. */
  accountByIdSs58: Account;
  alias?: Maybe<Scalars['String']['output']>;
  arbitrumRefundAddress?: Maybe<Scalars['String']['output']>;
  assethubRefundAddress?: Maybe<Scalars['String']['output']>;
  bitcoinRefundAddress?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `BoostBalance`. */
  boostBalancesByLpIdSs58: BoostBalancesConnection;
  bscRefundAddress?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `DepositBalance`. */
  depositBalancesByLpIdSs58: DepositBalancesConnection;
  earnedFeesValueUsd: Scalars['BigFloat']['output'];
  ethereumRefundAddress?: Maybe<Scalars['String']['output']>;
  flipBalance: Scalars['BigFloat']['output'];
  idSs58: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LpLendingBalance`. */
  lpLendingBalancesByLpIdSs58: LpLendingBalancesConnection;
  /** Reads a single `LpLoanAccount` that is related to this `LpAccount`. */
  lpLoanAccountByLpIdSs58?: Maybe<LpLoanAccount>;
  /** Reads and enables pagination through a set of `LpLoanAccount`. */
  lpLoanAccountsByLpIdSs58: LpLoanAccountsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openOrders: Scalars['JSON']['output'];
  solanaRefundAddress?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  tradingStrategiesByOwnerAccountIdSs58: TradingStrategiesConnection;
  tronRefundAddress?: Maybe<Scalars['String']['output']>;
};


export type LpAccountBoostBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};


export type LpAccountDepositBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositBalanceCondition>;
  filter?: InputMaybe<DepositBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositBalancesOrderBy>>;
};


export type LpAccountLpLendingBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingBalanceCondition>;
  filter?: InputMaybe<LpLendingBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingBalancesOrderBy>>;
};


export type LpAccountLpLoanAccountsByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLoanAccountCondition>;
  filter?: InputMaybe<LpLoanAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLoanAccountsOrderBy>>;
};


export type LpAccountTradingStrategiesByOwnerAccountIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};

export type LpAccountAggregates = {
  __typename?: 'LpAccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpAccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpAccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpAccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpAccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpAccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpAccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpAccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpAccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpAccountVarianceSampleAggregates>;
};

export type LpAccountAverageAggregates = {
  __typename?: 'LpAccountAverageAggregates';
  /** Mean average of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpAccount` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LpAccountCondition = {
  accountByIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `arbitrumRefundAddress` field. */
  arbitrumRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `assethubRefundAddress` field. */
  assethubRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bitcoinRefundAddress` field. */
  bitcoinRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bscRefundAddress` field. */
  bscRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `earnedFeesValueUsd` field. */
  earnedFeesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ethereumRefundAddress` field. */
  ethereumRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `openOrders` field. */
  openOrders?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `solanaRefundAddress` field. */
  solanaRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tronRefundAddress` field. */
  tronRefundAddress?: InputMaybe<Scalars['String']['input']>;
};

export type LpAccountDistinctCountAggregates = {
  __typename?: 'LpAccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of arbitrumRefundAddress across the matching connection */
  arbitrumRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assethubRefundAddress across the matching connection */
  assethubRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bitcoinRefundAddress across the matching connection */
  bitcoinRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bscRefundAddress across the matching connection */
  bscRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ethereumRefundAddress across the matching connection */
  ethereumRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openOrders across the matching connection */
  openOrders?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of solanaRefundAddress across the matching connection */
  solanaRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tronRefundAddress across the matching connection */
  tronRefundAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpAccount` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountFilter = {
  /** Filter by the object’s `accountByIdSs58` relation. */
  accountByIdSs58?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpAccountFilter>>;
  /** Filter by the object’s `arbitrumRefundAddress` field. */
  arbitrumRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assethubRefundAddress` field. */
  assethubRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bitcoinRefundAddress` field. */
  bitcoinRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `boostBalancesByLpIdSs58` relation. */
  boostBalancesByLpIdSs58?: InputMaybe<LpAccountToManyBoostBalanceFilter>;
  /** Some related `boostBalancesByLpIdSs58` exist. */
  boostBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `bscRefundAddress` field. */
  bscRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `depositBalancesByLpIdSs58` relation. */
  depositBalancesByLpIdSs58?: InputMaybe<LpAccountToManyDepositBalanceFilter>;
  /** Some related `depositBalancesByLpIdSs58` exist. */
  depositBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `earnedFeesValueUsd` field. */
  earnedFeesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ethereumRefundAddress` field. */
  ethereumRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpLendingBalancesByLpIdSs58` relation. */
  lpLendingBalancesByLpIdSs58?: InputMaybe<LpAccountToManyLpLendingBalanceFilter>;
  /** Some related `lpLendingBalancesByLpIdSs58` exist. */
  lpLendingBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpLoanAccountByLpIdSs58` relation. */
  lpLoanAccountByLpIdSs58?: InputMaybe<LpLoanAccountFilter>;
  /** A related `lpLoanAccountByLpIdSs58` exists. */
  lpLoanAccountByLpIdSs58Exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `openOrders` field. */
  openOrders?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpAccountFilter>>;
  /** Filter by the object’s `solanaRefundAddress` field. */
  solanaRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tradingStrategiesByOwnerAccountIdSs58` relation. */
  tradingStrategiesByOwnerAccountIdSs58?: InputMaybe<LpAccountToManyTradingStrategyFilter>;
  /** Some related `tradingStrategiesByOwnerAccountIdSs58` exist. */
  tradingStrategiesByOwnerAccountIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tronRefundAddress` field. */
  tronRefundAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `LpAccount` for usage during aggregation. */
export type LpAccountGroupBy =
  | 'ALIAS'
  | 'ARBITRUM_REFUND_ADDRESS'
  | 'ASSETHUB_REFUND_ADDRESS'
  | 'BITCOIN_REFUND_ADDRESS'
  | 'BSC_REFUND_ADDRESS'
  | 'EARNED_FEES_VALUE_USD'
  | 'ETHEREUM_REFUND_ADDRESS'
  | 'FLIP_BALANCE'
  | 'OPEN_ORDERS'
  | 'SOLANA_REFUND_ADDRESS'
  | 'TRON_REFUND_ADDRESS';

export type LpAccountHavingAverageInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingDistinctCountInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpAccount` aggregates. */
export type LpAccountHavingInput = {
  AND?: InputMaybe<Array<LpAccountHavingInput>>;
  OR?: InputMaybe<Array<LpAccountHavingInput>>;
  average?: InputMaybe<LpAccountHavingAverageInput>;
  distinctCount?: InputMaybe<LpAccountHavingDistinctCountInput>;
  max?: InputMaybe<LpAccountHavingMaxInput>;
  min?: InputMaybe<LpAccountHavingMinInput>;
  stddevPopulation?: InputMaybe<LpAccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpAccountHavingStddevSampleInput>;
  sum?: InputMaybe<LpAccountHavingSumInput>;
  variancePopulation?: InputMaybe<LpAccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpAccountHavingVarianceSampleInput>;
};

export type LpAccountHavingMaxInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingMinInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingStddevPopulationInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingStddevSampleInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingSumInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingVariancePopulationInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingVarianceSampleInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountMaxAggregates = {
  __typename?: 'LpAccountMaxAggregates';
  /** Maximum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountMinAggregates = {
  __typename?: 'LpAccountMinAggregates';
  /** Minimum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountStddevPopulationAggregates = {
  __typename?: 'LpAccountStddevPopulationAggregates';
  /** Population standard deviation of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountStddevSampleAggregates = {
  __typename?: 'LpAccountStddevSampleAggregates';
  /** Sample standard deviation of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountSumAggregates = {
  __typename?: 'LpAccountSumAggregates';
  /** Sum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of flipBalance across the matching connection */
  flipBalance: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyBoostBalanceFilter = {
  /** Aggregates across related `BoostBalance` match the filter criteria. */
  aggregates?: InputMaybe<BoostBalanceAggregatesFilter>;
  /** Every related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostBalanceFilter>;
  /** No related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostBalanceFilter>;
  /** Some related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostBalanceFilter>;
};

/** A filter to be used against many `DepositBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyDepositBalanceFilter = {
  /** Aggregates across related `DepositBalance` match the filter criteria. */
  aggregates?: InputMaybe<DepositBalanceAggregatesFilter>;
  /** Every related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepositBalanceFilter>;
  /** No related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepositBalanceFilter>;
  /** Some related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepositBalanceFilter>;
};

/** A filter to be used against many `LpLendingBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyLpLendingBalanceFilter = {
  /** Aggregates across related `LpLendingBalance` match the filter criteria. */
  aggregates?: InputMaybe<LpLendingBalanceAggregatesFilter>;
  /** Every related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpLendingBalanceFilter>;
  /** No related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpLendingBalanceFilter>;
  /** Some related `LpLendingBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpLendingBalanceFilter>;
};

/** A filter to be used against many `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyTradingStrategyFilter = {
  /** Aggregates across related `TradingStrategy` match the filter criteria. */
  aggregates?: InputMaybe<TradingStrategyAggregatesFilter>;
  /** Every related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingStrategyFilter>;
  /** No related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingStrategyFilter>;
  /** Some related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingStrategyFilter>;
};

export type LpAccountVariancePopulationAggregates = {
  __typename?: 'LpAccountVariancePopulationAggregates';
  /** Population variance of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountVarianceSampleAggregates = {
  __typename?: 'LpAccountVarianceSampleAggregates';
  /** Sample variance of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpAccount` values. */
export type LpAccountsConnection = {
  __typename?: 'LpAccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpAccountAggregates>;
  /** A list of edges which contains the `LpAccount` and cursor to aid in pagination. */
  edges: Array<LpAccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpAccountAggregates>>;
  /** A list of `LpAccount` objects. */
  nodes: Array<LpAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpAccount` values. */
export type LpAccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpAccountGroupBy>;
  having?: InputMaybe<LpAccountHavingInput>;
};

/** A `LpAccount` edge in the connection. */
export type LpAccountsEdge = {
  __typename?: 'LpAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpAccount` at the end of the edge. */
  node: LpAccount;
};

/** Methods to use when ordering `LpAccount`. */
export type LpAccountsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'ARBITRUM_REFUND_ADDRESS_ASC'
  | 'ARBITRUM_REFUND_ADDRESS_DESC'
  | 'ASSETHUB_REFUND_ADDRESS_ASC'
  | 'ASSETHUB_REFUND_ADDRESS_DESC'
  | 'BITCOIN_REFUND_ADDRESS_ASC'
  | 'BITCOIN_REFUND_ADDRESS_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BSC_REFUND_ADDRESS_ASC'
  | 'BSC_REFUND_ADDRESS_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_BOOST_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_BOOST_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_BOOST_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_BOOST_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LENDING_SUPPLY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LENDING_SUPPLY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LENDING_SUPPLY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LENDING_SUPPLY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ORDERS_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ORDERS_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ORDERS_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ORDERS_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_STRATEGY_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_STRATEGY_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_STRATEGY_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_STRATEGY_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'EARNED_FEES_VALUE_USD_ASC'
  | 'EARNED_FEES_VALUE_USD_DESC'
  | 'ETHEREUM_REFUND_ADDRESS_ASC'
  | 'ETHEREUM_REFUND_ADDRESS_DESC'
  | 'FLIP_BALANCE_ASC'
  | 'FLIP_BALANCE_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MAX_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_MIN_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_SUM_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_PERCENT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_PERCENT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LP_LENDING_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'NATURAL'
  | 'OPEN_ORDERS_ASC'
  | 'OPEN_ORDERS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SOLANA_REFUND_ADDRESS_ASC'
  | 'SOLANA_REFUND_ADDRESS_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_AVERAGE_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_COUNT_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_COUNT_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_KEY_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_KEY_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_OWNER_ACCOUNT_ID_SS58_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_OWNER_ACCOUNT_ID_SS58_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_SS58_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_SS58_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MAX_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_MIN_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_POPULATION_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_SUM_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BASE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BASE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BASE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BASE_ASSET_BALANCE_USD_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_QUOTE_ASSET_BALANCE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_QUOTE_ASSET_BALANCE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_QUOTE_ASSET_BALANCE_USD_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_QUOTE_ASSET_BALANCE_USD_DESC'
  | 'TRON_REFUND_ADDRESS_ASC'
  | 'TRON_REFUND_ADDRESS_DESC';

export type LpCollateralBalance = {
  __typename?: 'LpCollateralBalance';
  amount: Scalars['BigFloat']['output'];
  amountUsd: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  loanAccountLpIdSs58: Scalars['String']['output'];
  /** Reads a single `LpLoanAccount` that is related to this `LpCollateralBalance`. */
  lpLoanAccountByLoanAccountLpIdSs58: LpLoanAccount;
};

export type LpCollateralBalanceAggregates = {
  __typename?: 'LpCollateralBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpCollateralBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpCollateralBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpCollateralBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpCollateralBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpCollateralBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpCollateralBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpCollateralBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpCollateralBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpCollateralBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpCollateralBalance` object types. */
export type LpCollateralBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `LpCollateralBalance` objects. */
  average?: InputMaybe<LpCollateralBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpCollateralBalance` objects. */
  distinctCount?: InputMaybe<LpCollateralBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpCollateralBalance` object to be included within the aggregate. */
  filter?: InputMaybe<LpCollateralBalanceFilter>;
  /** Maximum aggregate over matching `LpCollateralBalance` objects. */
  max?: InputMaybe<LpCollateralBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpCollateralBalance` objects. */
  min?: InputMaybe<LpCollateralBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpCollateralBalance` objects. */
  stddevPopulation?: InputMaybe<LpCollateralBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpCollateralBalance` objects. */
  stddevSample?: InputMaybe<LpCollateralBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpCollateralBalance` objects. */
  sum?: InputMaybe<LpCollateralBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `LpCollateralBalance` objects. */
  variancePopulation?: InputMaybe<LpCollateralBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpCollateralBalance` objects. */
  varianceSample?: InputMaybe<LpCollateralBalanceVarianceSampleAggregateFilter>;
};

export type LpCollateralBalanceAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceAverageAggregates = {
  __typename?: 'LpCollateralBalanceAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpCollateralBalance` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LpCollateralBalanceCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `loanAccountLpIdSs58` field. */
  loanAccountLpIdSs58?: InputMaybe<Scalars['String']['input']>;
};

export type LpCollateralBalanceDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  loanAccountLpIdSs58?: InputMaybe<BigIntFilter>;
};

export type LpCollateralBalanceDistinctCountAggregates = {
  __typename?: 'LpCollateralBalanceDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanAccountLpIdSs58 across the matching connection */
  loanAccountLpIdSs58?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpCollateralBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpCollateralBalanceFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpCollateralBalanceFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `loanAccountLpIdSs58` field. */
  loanAccountLpIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpLoanAccountByLoanAccountLpIdSs58` relation. */
  lpLoanAccountByLoanAccountLpIdSs58?: InputMaybe<LpLoanAccountFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpCollateralBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpCollateralBalanceFilter>>;
};

/** Grouping methods for `LpCollateralBalance` for usage during aggregation. */
export type LpCollateralBalanceGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'ASSET'
  | 'LOAN_ACCOUNT_LP_ID_SS58';

export type LpCollateralBalanceHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpCollateralBalance` aggregates. */
export type LpCollateralBalanceHavingInput = {
  AND?: InputMaybe<Array<LpCollateralBalanceHavingInput>>;
  OR?: InputMaybe<Array<LpCollateralBalanceHavingInput>>;
  average?: InputMaybe<LpCollateralBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<LpCollateralBalanceHavingDistinctCountInput>;
  max?: InputMaybe<LpCollateralBalanceHavingMaxInput>;
  min?: InputMaybe<LpCollateralBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<LpCollateralBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpCollateralBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<LpCollateralBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<LpCollateralBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpCollateralBalanceHavingVarianceSampleInput>;
};

export type LpCollateralBalanceHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpCollateralBalanceMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceMaxAggregates = {
  __typename?: 'LpCollateralBalanceMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceMinAggregates = {
  __typename?: 'LpCollateralBalanceMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceStddevPopulationAggregates = {
  __typename?: 'LpCollateralBalanceStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceStddevSampleAggregates = {
  __typename?: 'LpCollateralBalanceStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceSumAggregates = {
  __typename?: 'LpCollateralBalanceSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
};

export type LpCollateralBalanceVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceVariancePopulationAggregates = {
  __typename?: 'LpCollateralBalanceVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceVarianceSampleAggregates = {
  __typename?: 'LpCollateralBalanceVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpCollateralBalance` values. */
export type LpCollateralBalancesConnection = {
  __typename?: 'LpCollateralBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpCollateralBalanceAggregates>;
  /** A list of edges which contains the `LpCollateralBalance` and cursor to aid in pagination. */
  edges: Array<LpCollateralBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpCollateralBalanceAggregates>>;
  /** A list of `LpCollateralBalance` objects. */
  nodes: Array<LpCollateralBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpCollateralBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpCollateralBalance` values. */
export type LpCollateralBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpCollateralBalanceGroupBy>;
  having?: InputMaybe<LpCollateralBalanceHavingInput>;
};

/** A `LpCollateralBalance` edge in the connection. */
export type LpCollateralBalancesEdge = {
  __typename?: 'LpCollateralBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpCollateralBalance` at the end of the edge. */
  node: LpCollateralBalance;
};

/** Methods to use when ordering `LpCollateralBalance`. */
export type LpCollateralBalancesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'LOAN_ACCOUNT_LP_ID_SS58_ASC'
  | 'LOAN_ACCOUNT_LP_ID_SS58_DESC'
  | 'NATURAL';

export type LpLendingBalance = {
  __typename?: 'LpLendingBalance';
  asset: ChainflipAsset;
  /** Reads a single `LendingPool` that is related to this `LpLendingBalance`. */
  lendingPoolByAsset: LendingPool;
  /** Reads a single `LpAccount` that is related to this `LpLendingBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  poolSharePercent: Scalars['Float']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  totalAmountUsd: Scalars['BigFloat']['output'];
  totalAvailableAmount: Scalars['BigFloat']['output'];
  totalAvailableAmountUsd: Scalars['BigFloat']['output'];
};

export type LpLendingBalanceAggregates = {
  __typename?: 'LpLendingBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpLendingBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpLendingBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpLendingBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpLendingBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpLendingBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpLendingBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpLendingBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpLendingBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpLendingBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpLendingBalance` object types. */
export type LpLendingBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `LpLendingBalance` objects. */
  average?: InputMaybe<LpLendingBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpLendingBalance` objects. */
  distinctCount?: InputMaybe<LpLendingBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpLendingBalance` object to be included within the aggregate. */
  filter?: InputMaybe<LpLendingBalanceFilter>;
  /** Maximum aggregate over matching `LpLendingBalance` objects. */
  max?: InputMaybe<LpLendingBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpLendingBalance` objects. */
  min?: InputMaybe<LpLendingBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpLendingBalance` objects. */
  stddevPopulation?: InputMaybe<LpLendingBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpLendingBalance` objects. */
  stddevSample?: InputMaybe<LpLendingBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpLendingBalance` objects. */
  sum?: InputMaybe<LpLendingBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `LpLendingBalance` objects. */
  variancePopulation?: InputMaybe<LpLendingBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpLendingBalance` objects. */
  varianceSample?: InputMaybe<LpLendingBalanceVarianceSampleAggregateFilter>;
};

export type LpLendingBalanceAverageAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceAverageAggregates = {
  __typename?: 'LpLendingBalanceAverageAggregates';
  /** Mean average of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpLendingBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LpLendingBalanceCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  lpAccountByLpIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `poolSharePercent` field. */
  poolSharePercent?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAmountUsd` field. */
  totalAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAvailableAmount` field. */
  totalAvailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAvailableAmountUsd` field. */
  totalAvailableAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LpLendingBalanceDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  poolSharePercent?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  totalAmountUsd?: InputMaybe<BigIntFilter>;
  totalAvailableAmount?: InputMaybe<BigIntFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigIntFilter>;
};

export type LpLendingBalanceDistinctCountAggregates = {
  __typename?: 'LpLendingBalanceDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpLendingBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpLendingBalanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpLendingBalanceFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `lendingPoolByAsset` relation. */
  lendingPoolByAsset?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpLendingBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpLendingBalanceFilter>>;
  /** Filter by the object’s `poolSharePercent` field. */
  poolSharePercent?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAmountUsd` field. */
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAvailableAmount` field. */
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAvailableAmountUsd` field. */
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LpLendingBalance` for usage during aggregation. */
export type LpLendingBalanceGroupBy =
  | 'ASSET'
  | 'LP_ID_SS58'
  | 'POOL_SHARE_PERCENT'
  | 'TOTAL_AMOUNT'
  | 'TOTAL_AMOUNT_USD'
  | 'TOTAL_AVAILABLE_AMOUNT'
  | 'TOTAL_AVAILABLE_AMOUNT_USD';

export type LpLendingBalanceHavingAverageInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingDistinctCountInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpLendingBalance` aggregates. */
export type LpLendingBalanceHavingInput = {
  AND?: InputMaybe<Array<LpLendingBalanceHavingInput>>;
  OR?: InputMaybe<Array<LpLendingBalanceHavingInput>>;
  average?: InputMaybe<LpLendingBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<LpLendingBalanceHavingDistinctCountInput>;
  max?: InputMaybe<LpLendingBalanceHavingMaxInput>;
  min?: InputMaybe<LpLendingBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<LpLendingBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpLendingBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<LpLendingBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<LpLendingBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpLendingBalanceHavingVarianceSampleInput>;
};

export type LpLendingBalanceHavingMaxInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingMinInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingStddevPopulationInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingStddevSampleInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingSumInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingVariancePopulationInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceHavingVarianceSampleInput = {
  poolSharePercent?: InputMaybe<HavingFloatFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLendingBalanceMaxAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceMaxAggregates = {
  __typename?: 'LpLendingBalanceMaxAggregates';
  /** Maximum of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingBalanceMinAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceMinAggregates = {
  __typename?: 'LpLendingBalanceMinAggregates';
  /** Minimum of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingBalanceStddevPopulationAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceStddevPopulationAggregates = {
  __typename?: 'LpLendingBalanceStddevPopulationAggregates';
  /** Population standard deviation of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingBalanceStddevSampleAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceStddevSampleAggregates = {
  __typename?: 'LpLendingBalanceStddevSampleAggregates';
  /** Sample standard deviation of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingBalanceSumAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceSumAggregates = {
  __typename?: 'LpLendingBalanceSumAggregates';
  /** Sum of poolSharePercent across the matching connection */
  poolSharePercent: Scalars['Float']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAmountUsd across the matching connection */
  totalAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of totalAvailableAmount across the matching connection */
  totalAvailableAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd: Scalars['BigFloat']['output'];
};

export type LpLendingBalanceVariancePopulationAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceVariancePopulationAggregates = {
  __typename?: 'LpLendingBalanceVariancePopulationAggregates';
  /** Population variance of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingBalanceVarianceSampleAggregateFilter = {
  poolSharePercent?: InputMaybe<FloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountUsd?: InputMaybe<BigFloatFilter>;
  totalAvailableAmount?: InputMaybe<BigFloatFilter>;
  totalAvailableAmountUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingBalanceVarianceSampleAggregates = {
  __typename?: 'LpLendingBalanceVarianceSampleAggregates';
  /** Sample variance of poolSharePercent across the matching connection */
  poolSharePercent?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmountUsd across the matching connection */
  totalAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAvailableAmount across the matching connection */
  totalAvailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAvailableAmountUsd across the matching connection */
  totalAvailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpLendingBalance` values. */
export type LpLendingBalancesConnection = {
  __typename?: 'LpLendingBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpLendingBalanceAggregates>;
  /** A list of edges which contains the `LpLendingBalance` and cursor to aid in pagination. */
  edges: Array<LpLendingBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpLendingBalanceAggregates>>;
  /** A list of `LpLendingBalance` objects. */
  nodes: Array<LpLendingBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpLendingBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpLendingBalance` values. */
export type LpLendingBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpLendingBalanceGroupBy>;
  having?: InputMaybe<LpLendingBalanceHavingInput>;
};

/** A `LpLendingBalance` edge in the connection. */
export type LpLendingBalancesEdge = {
  __typename?: 'LpLendingBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpLendingBalance` at the end of the edge. */
  node: LpLendingBalance;
};

/** Methods to use when ordering `LpLendingBalance`. */
export type LpLendingBalancesOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'POOL_SHARE_PERCENT_ASC'
  | 'POOL_SHARE_PERCENT_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'TOTAL_AMOUNT_USD_ASC'
  | 'TOTAL_AMOUNT_USD_DESC'
  | 'TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'TOTAL_AVAILABLE_AMOUNT_USD_DESC';

export type LpLoanAccount = {
  __typename?: 'LpLoanAccount';
  borrowPowerUsedBps: Scalars['Int']['output'];
  loanToValueBps: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Loan`. */
  loansByLoanAccountLpIdSs58: LoansConnection;
  /** Reads a single `LpAccount` that is related to this `LpLoanAccount`. */
  lpAccountByLpIdSs58: LpAccount;
  /** Reads and enables pagination through a set of `LpCollateralBalance`. */
  lpCollateralBalancesByLoanAccountLpIdSs58: LpCollateralBalancesConnection;
  lpIdSs58: Scalars['String']['output'];
  totalBorrowAmountUsd: Scalars['BigFloat']['output'];
  totalCollateralBalanceUsd: Scalars['BigFloat']['output'];
};


export type LpLoanAccountLoansByLoanAccountLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type LpLoanAccountLpCollateralBalancesByLoanAccountLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpCollateralBalanceCondition>;
  filter?: InputMaybe<LpCollateralBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpCollateralBalancesOrderBy>>;
};

export type LpLoanAccountAggregates = {
  __typename?: 'LpLoanAccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpLoanAccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpLoanAccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpLoanAccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpLoanAccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpLoanAccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpLoanAccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpLoanAccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpLoanAccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpLoanAccountVarianceSampleAggregates>;
};

export type LpLoanAccountAverageAggregates = {
  __typename?: 'LpLoanAccountAverageAggregates';
  /** Mean average of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpLoanAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LpLoanAccountCondition = {
  /** Checks for equality with the object’s `borrowPowerUsedBps` field. */
  borrowPowerUsedBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loanToValueBps` field. */
  loanToValueBps?: InputMaybe<Scalars['Int']['input']>;
  lpAccountByLpIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `totalBorrowAmountUsd` field. */
  totalBorrowAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalCollateralBalanceUsd` field. */
  totalCollateralBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LpLoanAccountDistinctCountAggregates = {
  __typename?: 'LpLoanAccountDistinctCountAggregates';
  /** Distinct count of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpLoanAccount` object types. All fields are combined with a logical ‘and.’ */
export type LpLoanAccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpLoanAccountFilter>>;
  /** Filter by the object’s `borrowPowerUsedBps` field. */
  borrowPowerUsedBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loanToValueBps` field. */
  loanToValueBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loansByLoanAccountLpIdSs58` relation. */
  loansByLoanAccountLpIdSs58?: InputMaybe<LpLoanAccountToManyLoanFilter>;
  /** Some related `loansByLoanAccountLpIdSs58` exist. */
  loansByLoanAccountLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpCollateralBalancesByLoanAccountLpIdSs58` relation. */
  lpCollateralBalancesByLoanAccountLpIdSs58?: InputMaybe<LpLoanAccountToManyLpCollateralBalanceFilter>;
  /** Some related `lpCollateralBalancesByLoanAccountLpIdSs58` exist. */
  lpCollateralBalancesByLoanAccountLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpLoanAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpLoanAccountFilter>>;
  /** Filter by the object’s `totalBorrowAmountUsd` field. */
  totalBorrowAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalCollateralBalanceUsd` field. */
  totalCollateralBalanceUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LpLoanAccount` for usage during aggregation. */
export type LpLoanAccountGroupBy =
  | 'BORROW_POWER_USED_BPS'
  | 'LOAN_TO_VALUE_BPS'
  | 'TOTAL_BORROW_AMOUNT_USD'
  | 'TOTAL_COLLATERAL_BALANCE_USD';

export type LpLoanAccountHavingAverageInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingDistinctCountInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpLoanAccount` aggregates. */
export type LpLoanAccountHavingInput = {
  AND?: InputMaybe<Array<LpLoanAccountHavingInput>>;
  OR?: InputMaybe<Array<LpLoanAccountHavingInput>>;
  average?: InputMaybe<LpLoanAccountHavingAverageInput>;
  distinctCount?: InputMaybe<LpLoanAccountHavingDistinctCountInput>;
  max?: InputMaybe<LpLoanAccountHavingMaxInput>;
  min?: InputMaybe<LpLoanAccountHavingMinInput>;
  stddevPopulation?: InputMaybe<LpLoanAccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpLoanAccountHavingStddevSampleInput>;
  sum?: InputMaybe<LpLoanAccountHavingSumInput>;
  variancePopulation?: InputMaybe<LpLoanAccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpLoanAccountHavingVarianceSampleInput>;
};

export type LpLoanAccountHavingMaxInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingMinInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingStddevPopulationInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingStddevSampleInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingSumInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingVariancePopulationInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountHavingVarianceSampleInput = {
  borrowPowerUsedBps?: InputMaybe<HavingIntFilter>;
  loanToValueBps?: InputMaybe<HavingIntFilter>;
  totalBorrowAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  totalCollateralBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpLoanAccountMaxAggregates = {
  __typename?: 'LpLoanAccountMaxAggregates';
  /** Maximum of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLoanAccountMinAggregates = {
  __typename?: 'LpLoanAccountMinAggregates';
  /** Minimum of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLoanAccountStddevPopulationAggregates = {
  __typename?: 'LpLoanAccountStddevPopulationAggregates';
  /** Population standard deviation of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLoanAccountStddevSampleAggregates = {
  __typename?: 'LpLoanAccountStddevSampleAggregates';
  /** Sample standard deviation of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLoanAccountSumAggregates = {
  __typename?: 'LpLoanAccountSumAggregates';
  /** Sum of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps: Scalars['BigInt']['output'];
  /** Sum of loanToValueBps across the matching connection */
  loanToValueBps: Scalars['BigInt']['output'];
  /** Sum of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type LpLoanAccountToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `LpCollateralBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpLoanAccountToManyLpCollateralBalanceFilter = {
  /** Aggregates across related `LpCollateralBalance` match the filter criteria. */
  aggregates?: InputMaybe<LpCollateralBalanceAggregatesFilter>;
  /** Every related `LpCollateralBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpCollateralBalanceFilter>;
  /** No related `LpCollateralBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpCollateralBalanceFilter>;
  /** Some related `LpCollateralBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpCollateralBalanceFilter>;
};

export type LpLoanAccountVariancePopulationAggregates = {
  __typename?: 'LpLoanAccountVariancePopulationAggregates';
  /** Population variance of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLoanAccountVarianceSampleAggregates = {
  __typename?: 'LpLoanAccountVarianceSampleAggregates';
  /** Sample variance of borrowPowerUsedBps across the matching connection */
  borrowPowerUsedBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanToValueBps across the matching connection */
  loanToValueBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBorrowAmountUsd across the matching connection */
  totalBorrowAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalCollateralBalanceUsd across the matching connection */
  totalCollateralBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpLoanAccount` values. */
export type LpLoanAccountsConnection = {
  __typename?: 'LpLoanAccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpLoanAccountAggregates>;
  /** A list of edges which contains the `LpLoanAccount` and cursor to aid in pagination. */
  edges: Array<LpLoanAccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpLoanAccountAggregates>>;
  /** A list of `LpLoanAccount` objects. */
  nodes: Array<LpLoanAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpLoanAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpLoanAccount` values. */
export type LpLoanAccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpLoanAccountGroupBy>;
  having?: InputMaybe<LpLoanAccountHavingInput>;
};

/** A `LpLoanAccount` edge in the connection. */
export type LpLoanAccountsEdge = {
  __typename?: 'LpLoanAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpLoanAccount` at the end of the edge. */
  node: LpLoanAccount;
};

/** Methods to use when ordering `LpLoanAccount`. */
export type LpLoanAccountsOrderBy =
  | 'BORROW_POWER_USED_BPS_ASC'
  | 'BORROW_POWER_USED_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_COUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_COUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_STATUS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_STATUS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_DESC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_USD_ASC'
  | 'LOANS_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_PRINCIPAL_AMOUNT_USD_DESC'
  | 'LOAN_TO_VALUE_BPS_ASC'
  | 'LOAN_TO_VALUE_BPS_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_AVERAGE_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_COUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_COUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_DISTINCT_COUNT_LOAN_ACCOUNT_LP_ID_SS58_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MAX_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_MIN_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_SUM_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LP_COLLATERAL_BALANCES_BY_LOAN_ACCOUNT_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'TOTAL_BORROW_AMOUNT_USD_ASC'
  | 'TOTAL_BORROW_AMOUNT_USD_DESC'
  | 'TOTAL_COLLATERAL_BALANCE_USD_ASC'
  | 'TOTAL_COLLATERAL_BALANCE_USD_DESC';

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type Operator = Node & {
  __typename?: 'Operator';
  /** Reads a single `Account` that is related to this `Operator`. */
  accountByIdSs58: Account;
  activeDelegationFeeBps: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Delegation`. */
  delegationsByOperatorIdSs58: DelegationsConnection;
  exceptionList: Scalars['JSON']['output'];
  idSs58: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openDelegationEnabled: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `OperatorValidator`. */
  operatorValidatorsByOperatorIdSs58: OperatorValidatorsConnection;
  upcomingDelegationFeeBps: Scalars['Int']['output'];
};


export type OperatorDelegationsByOperatorIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationCondition>;
  filter?: InputMaybe<DelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationsOrderBy>>;
};


export type OperatorOperatorValidatorsByOperatorIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorCondition>;
  filter?: InputMaybe<OperatorValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorsOrderBy>>;
};

export type OperatorAggregates = {
  __typename?: 'OperatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorVarianceSampleAggregates>;
};

export type OperatorAverageAggregates = {
  __typename?: 'OperatorAverageAggregates';
  /** Mean average of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Operator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OperatorCondition = {
  accountByIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `activeDelegationFeeBps` field. */
  activeDelegationFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `exceptionList` field. */
  exceptionList?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `openDelegationEnabled` field. */
  openDelegationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `upcomingDelegationFeeBps` field. */
  upcomingDelegationFeeBps?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorDistinctCountAggregates = {
  __typename?: 'OperatorDistinctCountAggregates';
  /** Distinct count of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of exceptionList across the matching connection */
  exceptionList?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openDelegationEnabled across the matching connection */
  openDelegationEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Operator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorFilter = {
  /** Filter by the object’s `accountByIdSs58` relation. */
  accountByIdSs58?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `activeDelegationFeeBps` field. */
  activeDelegationFeeBps?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorFilter>>;
  /** Filter by the object’s `delegationsByOperatorIdSs58` relation. */
  delegationsByOperatorIdSs58?: InputMaybe<OperatorToManyDelegationFilter>;
  /** Some related `delegationsByOperatorIdSs58` exist. */
  delegationsByOperatorIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `exceptionList` field. */
  exceptionList?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `openDelegationEnabled` field. */
  openDelegationEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `operatorValidatorsByOperatorIdSs58` relation. */
  operatorValidatorsByOperatorIdSs58?: InputMaybe<OperatorToManyOperatorValidatorFilter>;
  /** Some related `operatorValidatorsByOperatorIdSs58` exist. */
  operatorValidatorsByOperatorIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorFilter>>;
  /** Filter by the object’s `upcomingDelegationFeeBps` field. */
  upcomingDelegationFeeBps?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Operator` for usage during aggregation. */
export type OperatorGroupBy =
  | 'ACTIVE_DELEGATION_FEE_BPS'
  | 'EXCEPTION_LIST'
  | 'OPEN_DELEGATION_ENABLED'
  | 'UPCOMING_DELEGATION_FEE_BPS';

export type OperatorHavingAverageInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingDistinctCountInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Operator` aggregates. */
export type OperatorHavingInput = {
  AND?: InputMaybe<Array<OperatorHavingInput>>;
  OR?: InputMaybe<Array<OperatorHavingInput>>;
  average?: InputMaybe<OperatorHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorHavingDistinctCountInput>;
  max?: InputMaybe<OperatorHavingMaxInput>;
  min?: InputMaybe<OperatorHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorHavingVarianceSampleInput>;
};

export type OperatorHavingMaxInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingMinInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingStddevPopulationInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingStddevSampleInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingSumInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingVariancePopulationInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorHavingVarianceSampleInput = {
  activeDelegationFeeBps?: InputMaybe<HavingIntFilter>;
  upcomingDelegationFeeBps?: InputMaybe<HavingIntFilter>;
};

export type OperatorMaxAggregates = {
  __typename?: 'OperatorMaxAggregates';
  /** Maximum of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['Int']['output']>;
};

export type OperatorMinAggregates = {
  __typename?: 'OperatorMinAggregates';
  /** Minimum of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['Int']['output']>;
};

export type OperatorStddevPopulationAggregates = {
  __typename?: 'OperatorStddevPopulationAggregates';
  /** Population standard deviation of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorStddevSampleAggregates = {
  __typename?: 'OperatorStddevSampleAggregates';
  /** Sample standard deviation of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorSumAggregates = {
  __typename?: 'OperatorSumAggregates';
  /** Sum of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps: Scalars['BigInt']['output'];
  /** Sum of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Delegation` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyDelegationFilter = {
  /** Aggregates across related `Delegation` match the filter criteria. */
  aggregates?: InputMaybe<DelegationAggregatesFilter>;
  /** Every related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DelegationFilter>;
  /** No related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DelegationFilter>;
  /** Some related `Delegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DelegationFilter>;
};

/** A filter to be used against many `OperatorValidator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyOperatorValidatorFilter = {
  /** Aggregates across related `OperatorValidator` match the filter criteria. */
  aggregates?: InputMaybe<OperatorValidatorAggregatesFilter>;
  /** Every related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorValidatorFilter>;
  /** No related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorValidatorFilter>;
  /** Some related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorValidatorFilter>;
};

export type OperatorValidator = Node & {
  __typename?: 'OperatorValidator';
  activeAmount: Scalars['BigFloat']['output'];
  bond: Scalars['BigFloat']['output'];
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `OperatorValidator`. */
  operatorByOperatorIdSs58: Operator;
  operatorIdSs58: Scalars['String']['output'];
  totalBalance: Scalars['BigFloat']['output'];
  upcomingAmount: Scalars['BigFloat']['output'];
  /** Reads a single `Validator` that is related to this `OperatorValidator`. */
  validatorByValidatorIdSs58: Validator;
  validatorIdSs58: Scalars['String']['output'];
};

export type OperatorValidatorAggregates = {
  __typename?: 'OperatorValidatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorValidatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorValidatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorValidatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorValidatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorValidatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorValidatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorValidatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorValidatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorValidatorVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorValidator` object types. */
export type OperatorValidatorAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorValidator` objects. */
  average?: InputMaybe<OperatorValidatorAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorValidator` objects. */
  distinctCount?: InputMaybe<OperatorValidatorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorValidator` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorValidatorFilter>;
  /** Maximum aggregate over matching `OperatorValidator` objects. */
  max?: InputMaybe<OperatorValidatorMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorValidator` objects. */
  min?: InputMaybe<OperatorValidatorMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorValidator` objects. */
  stddevPopulation?: InputMaybe<OperatorValidatorStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorValidator` objects. */
  stddevSample?: InputMaybe<OperatorValidatorStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorValidator` objects. */
  sum?: InputMaybe<OperatorValidatorSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorValidator` objects. */
  variancePopulation?: InputMaybe<OperatorValidatorVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorValidator` objects. */
  varianceSample?: InputMaybe<OperatorValidatorVarianceSampleAggregateFilter>;
};

export type OperatorValidatorAverageAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorAverageAggregates = {
  __typename?: 'OperatorValidatorAverageAggregates';
  /** Mean average of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorValidator` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OperatorValidatorCondition = {
  /** Checks for equality with the object’s `activeAmount` field. */
  activeAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bond` field. */
  bond?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  operatorByOperatorIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorIdSs58` field. */
  operatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `upcomingAmount` field. */
  upcomingAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  validatorByValidatorIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorIdSs58` field. */
  validatorIdSs58?: InputMaybe<Scalars['String']['input']>;
};

export type OperatorValidatorDistinctCountAggregateFilter = {
  activeAmount?: InputMaybe<BigIntFilter>;
  bond?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorIdSs58?: InputMaybe<BigIntFilter>;
  totalBalance?: InputMaybe<BigIntFilter>;
  upcomingAmount?: InputMaybe<BigIntFilter>;
  validatorIdSs58?: InputMaybe<BigIntFilter>;
};

export type OperatorValidatorDistinctCountAggregates = {
  __typename?: 'OperatorValidatorDistinctCountAggregates';
  /** Distinct count of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bond across the matching connection */
  bond?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorIdSs58 across the matching connection */
  operatorIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorIdSs58 across the matching connection */
  validatorIdSs58?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorValidator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorValidatorFilter = {
  /** Filter by the object’s `activeAmount` field. */
  activeAmount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorValidatorFilter>>;
  /** Filter by the object’s `bond` field. */
  bond?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorValidatorFilter>;
  /** Filter by the object’s `operatorByOperatorIdSs58` relation. */
  operatorByOperatorIdSs58?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorIdSs58` field. */
  operatorIdSs58?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorValidatorFilter>>;
  /** Filter by the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `upcomingAmount` field. */
  upcomingAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `validatorByValidatorIdSs58` relation. */
  validatorByValidatorIdSs58?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorIdSs58` field. */
  validatorIdSs58?: InputMaybe<StringFilter>;
};

/** Grouping methods for `OperatorValidator` for usage during aggregation. */
export type OperatorValidatorGroupBy =
  | 'ACTIVE_AMOUNT'
  | 'BOND'
  | 'OPERATOR_ID_SS58'
  | 'TOTAL_BALANCE'
  | 'UPCOMING_AMOUNT'
  | 'VALIDATOR_ID_SS58';

export type OperatorValidatorHavingAverageInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingDistinctCountInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `OperatorValidator` aggregates. */
export type OperatorValidatorHavingInput = {
  AND?: InputMaybe<Array<OperatorValidatorHavingInput>>;
  OR?: InputMaybe<Array<OperatorValidatorHavingInput>>;
  average?: InputMaybe<OperatorValidatorHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorValidatorHavingDistinctCountInput>;
  max?: InputMaybe<OperatorValidatorHavingMaxInput>;
  min?: InputMaybe<OperatorValidatorHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorValidatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorValidatorHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorValidatorHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorValidatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorValidatorHavingVarianceSampleInput>;
};

export type OperatorValidatorHavingMaxInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingMinInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingStddevPopulationInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingStddevSampleInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingSumInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingVariancePopulationInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorHavingVarianceSampleInput = {
  activeAmount?: InputMaybe<HavingBigfloatFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  upcomingAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorValidatorMaxAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorMaxAggregates = {
  __typename?: 'OperatorValidatorMaxAggregates';
  /** Maximum of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorMinAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorMinAggregates = {
  __typename?: 'OperatorValidatorMinAggregates';
  /** Minimum of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorStddevPopulationAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorStddevPopulationAggregates = {
  __typename?: 'OperatorValidatorStddevPopulationAggregates';
  /** Population standard deviation of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorStddevSampleAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorStddevSampleAggregates = {
  __typename?: 'OperatorValidatorStddevSampleAggregates';
  /** Sample standard deviation of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorSumAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorSumAggregates = {
  __typename?: 'OperatorValidatorSumAggregates';
  /** Sum of activeAmount across the matching connection */
  activeAmount: Scalars['BigFloat']['output'];
  /** Sum of bond across the matching connection */
  bond: Scalars['BigFloat']['output'];
  /** Sum of totalBalance across the matching connection */
  totalBalance: Scalars['BigFloat']['output'];
  /** Sum of upcomingAmount across the matching connection */
  upcomingAmount: Scalars['BigFloat']['output'];
};

export type OperatorValidatorVariancePopulationAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorVariancePopulationAggregates = {
  __typename?: 'OperatorValidatorVariancePopulationAggregates';
  /** Population variance of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorVarianceSampleAggregateFilter = {
  activeAmount?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  totalBalance?: InputMaybe<BigFloatFilter>;
  upcomingAmount?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorVarianceSampleAggregates = {
  __typename?: 'OperatorValidatorVarianceSampleAggregates';
  /** Sample variance of activeAmount across the matching connection */
  activeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of upcomingAmount across the matching connection */
  upcomingAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorValidator` values. */
export type OperatorValidatorsConnection = {
  __typename?: 'OperatorValidatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorValidatorAggregates>;
  /** A list of edges which contains the `OperatorValidator` and cursor to aid in pagination. */
  edges: Array<OperatorValidatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorValidatorAggregates>>;
  /** A list of `OperatorValidator` objects. */
  nodes: Array<OperatorValidator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorValidator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorValidator` values. */
export type OperatorValidatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorValidatorGroupBy>;
  having?: InputMaybe<OperatorValidatorHavingInput>;
};

/** A `OperatorValidator` edge in the connection. */
export type OperatorValidatorsEdge = {
  __typename?: 'OperatorValidatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorValidator` at the end of the edge. */
  node: OperatorValidator;
};

/** Methods to use when ordering `OperatorValidator`. */
export type OperatorValidatorsOrderBy =
  | 'ACTIVE_AMOUNT_ASC'
  | 'ACTIVE_AMOUNT_DESC'
  | 'BOND_ASC'
  | 'BOND_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_SS58_ASC'
  | 'OPERATOR_ID_SS58_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TOTAL_BALANCE_ASC'
  | 'TOTAL_BALANCE_DESC'
  | 'UPCOMING_AMOUNT_ASC'
  | 'UPCOMING_AMOUNT_DESC'
  | 'VALIDATOR_ID_SS58_ASC'
  | 'VALIDATOR_ID_SS58_DESC';

export type OperatorVariancePopulationAggregates = {
  __typename?: 'OperatorVariancePopulationAggregates';
  /** Population variance of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorVarianceSampleAggregates = {
  __typename?: 'OperatorVarianceSampleAggregates';
  /** Sample variance of activeDelegationFeeBps across the matching connection */
  activeDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of upcomingDelegationFeeBps across the matching connection */
  upcomingDelegationFeeBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Operator` values. */
export type OperatorsConnection = {
  __typename?: 'OperatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorAggregates>;
  /** A list of edges which contains the `Operator` and cursor to aid in pagination. */
  edges: Array<OperatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorAggregates>>;
  /** A list of `Operator` objects. */
  nodes: Array<Operator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Operator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Operator` values. */
export type OperatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorGroupBy>;
  having?: InputMaybe<OperatorHavingInput>;
};

/** A `Operator` edge in the connection. */
export type OperatorsEdge = {
  __typename?: 'OperatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Operator` at the end of the edge. */
  node: Operator;
};

/** Methods to use when ordering `Operator`. */
export type OperatorsOrderBy =
  | 'ACTIVE_DELEGATION_FEE_BPS_ASC'
  | 'ACTIVE_DELEGATION_FEE_BPS_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_COUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_COUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_DELEGATOR_ID_SS58_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_DELEGATOR_ID_SS58_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MAX_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MAX_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MAX_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MAX_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MIN_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MIN_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MIN_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_MIN_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_SUM_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_SUM_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_SUM_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_SUM_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'DELEGATIONS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'EXCEPTION_LIST_ASC'
  | 'EXCEPTION_LIST_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL'
  | 'OPEN_DELEGATION_ENABLED_ASC'
  | 'OPEN_DELEGATION_ENABLED_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_COUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_COUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_VALIDATOR_ID_SS58_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_DISTINCT_COUNT_VALIDATOR_ID_SS58_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MAX_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_MIN_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_SUM_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_OPERATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPCOMING_DELEGATION_FEE_BPS_ASC'
  | 'UPCOMING_DELEGATION_FEE_BPS_DESC';

export type OraclePrice = Node & {
  __typename?: 'OraclePrice';
  baseAsset: PriceAsset;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LendingPool`. */
  lendingPoolsByOraclePriceId: LendingPoolsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quoteAsset: PriceAsset;
  status: OraclePriceStatus;
  updatedAtOracleTimestamp: Scalars['Datetime']['output'];
  updatedAtStatechainBlock: Scalars['Int']['output'];
};


export type OraclePriceLendingPoolsByOraclePriceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolCondition>;
  filter?: InputMaybe<LendingPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolsOrderBy>>;
};

export type OraclePriceAggregates = {
  __typename?: 'OraclePriceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OraclePriceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OraclePriceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OraclePriceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OraclePriceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OraclePriceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OraclePriceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OraclePriceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OraclePriceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OraclePriceVarianceSampleAggregates>;
};

export type OraclePriceAverageAggregates = {
  __typename?: 'OraclePriceAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Mean average of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OraclePrice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OraclePriceCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<OraclePriceStatus>;
  /** Checks for equality with the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAtStatechainBlock` field. */
  updatedAtStatechainBlock?: InputMaybe<Scalars['Int']['input']>;
};

export type OraclePriceDistinctCountAggregates = {
  __typename?: 'OraclePriceDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OraclePrice` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OraclePriceFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolsByOraclePriceId` relation. */
  lendingPoolsByOraclePriceId?: InputMaybe<OraclePriceToManyLendingPoolFilter>;
  /** Some related `lendingPoolsByOraclePriceId` exist. */
  lendingPoolsByOraclePriceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<OraclePriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OraclePriceFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<OraclePriceStatusFilter>;
  /** Filter by the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAtStatechainBlock` field. */
  updatedAtStatechainBlock?: InputMaybe<IntFilter>;
};

/** Grouping methods for `OraclePrice` for usage during aggregation. */
export type OraclePriceGroupBy =
  | 'BASE_ASSET'
  | 'PRICE'
  | 'QUOTE_ASSET'
  | 'STATUS'
  | 'UPDATED_AT_ORACLE_TIMESTAMP'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'UPDATED_AT_STATECHAIN_BLOCK';

export type OraclePriceHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OraclePrice` aggregates. */
export type OraclePriceHavingInput = {
  AND?: InputMaybe<Array<OraclePriceHavingInput>>;
  OR?: InputMaybe<Array<OraclePriceHavingInput>>;
  average?: InputMaybe<OraclePriceHavingAverageInput>;
  distinctCount?: InputMaybe<OraclePriceHavingDistinctCountInput>;
  max?: InputMaybe<OraclePriceHavingMaxInput>;
  min?: InputMaybe<OraclePriceHavingMinInput>;
  stddevPopulation?: InputMaybe<OraclePriceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OraclePriceHavingStddevSampleInput>;
  sum?: InputMaybe<OraclePriceHavingSumInput>;
  variancePopulation?: InputMaybe<OraclePriceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OraclePriceHavingVarianceSampleInput>;
};

export type OraclePriceHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
  updatedAtStatechainBlock?: InputMaybe<HavingIntFilter>;
};

export type OraclePriceMaxAggregates = {
  __typename?: 'OraclePriceMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Maximum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['Int']['output']>;
};

export type OraclePriceMinAggregates = {
  __typename?: 'OraclePriceMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['Int']['output']>;
};

export type OraclePriceStatus =
  | 'MaybeStale'
  | 'Stale'
  | 'UpToDate';

/** A filter to be used against OraclePriceStatus fields. All fields are combined with a logical ‘and.’ */
export type OraclePriceStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OraclePriceStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OraclePriceStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OraclePriceStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OraclePriceStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OraclePriceStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OraclePriceStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OraclePriceStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OraclePriceStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OraclePriceStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OraclePriceStatus>>;
};

export type OraclePriceStddevPopulationAggregates = {
  __typename?: 'OraclePriceStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceStddevSampleAggregates = {
  __typename?: 'OraclePriceStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceSumAggregates = {
  __typename?: 'OraclePriceSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['Float']['output'];
  /** Sum of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock: Scalars['BigInt']['output'];
};

/** A filter to be used against many `LendingPool` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceToManyLendingPoolFilter = {
  /** Aggregates across related `LendingPool` match the filter criteria. */
  aggregates?: InputMaybe<LendingPoolAggregatesFilter>;
  /** Every related `LendingPool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingPoolFilter>;
  /** No related `LendingPool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingPoolFilter>;
  /** Some related `LendingPool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingPoolFilter>;
};

export type OraclePriceVariancePopulationAggregates = {
  __typename?: 'OraclePriceVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population variance of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceVarianceSampleAggregates = {
  __typename?: 'OraclePriceVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of updatedAtStatechainBlock across the matching connection */
  updatedAtStatechainBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OraclePrice` values. */
export type OraclePricesConnection = {
  __typename?: 'OraclePricesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OraclePriceAggregates>;
  /** A list of edges which contains the `OraclePrice` and cursor to aid in pagination. */
  edges: Array<OraclePricesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OraclePriceAggregates>>;
  /** A list of `OraclePrice` objects. */
  nodes: Array<OraclePrice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OraclePrice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OraclePrice` values. */
export type OraclePricesConnectionGroupedAggregatesArgs = {
  groupBy: Array<OraclePriceGroupBy>;
  having?: InputMaybe<OraclePriceHavingInput>;
};

/** A `OraclePrice` edge in the connection. */
export type OraclePricesEdge = {
  __typename?: 'OraclePricesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OraclePrice` at the end of the edge. */
  node: OraclePrice;
};

/** Methods to use when ordering `OraclePrice`. */
export type OraclePricesOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_AVERAGE_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_COUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_COUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ADDING_LENDER_FUNDS_ENABLED_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ADDING_LENDER_FUNDS_ENABLED_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BORROWING_ENABLED_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BORROWING_ENABLED_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_WITHDRAWING_LENDER_FUNDS_ENABLED_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_WITHDRAWING_LENDER_FUNDS_ENABLED_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MAX_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_MIN_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_SUM_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_JUNCTION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_JUNCTION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_MAX_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_MAX_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_ZERO_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_AT_ZERO_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_JUNCTION_UTILISATION_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_JUNCTION_UTILISATION_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LIQUIDATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LIQUIDATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORIGINATION_FEE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORIGINATION_FEE_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_BORROWED_AMOUNT_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_BORROWED_AMOUNT_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_BORROWED_AMOUNT_USD_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_BORROWED_AMOUNT_USD_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_UTILISATION_CAP_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_UTILISATION_CAP_BPS_DESC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOLS_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_UTILISATION_RATE_BPS_DESC'
  | 'NATURAL'
  | 'PRICE_ASC'
  | 'PRICE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'STATUS_ASC'
  | 'STATUS_DESC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'UPDATED_AT_STATECHAIN_BLOCK_ASC'
  | 'UPDATED_AT_STATECHAIN_BLOCK_DESC';

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PendingDeposit = {
  __typename?: 'PendingDeposit';
  amount: Scalars['String']['output'];
  confirmations: Scalars['Int']['output'];
  txRef?: Maybe<Scalars['String']['output']>;
};

export type PendingDepositsInput = {
  address: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  chain: Scalars['String']['input'];
};

export type Pool = Node & {
  __typename?: 'Pool';
  baseAsset: ChainflipAsset;
  baseLiquidityAmount: Scalars['BigFloat']['output'];
  buyPrice: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  liquidityFeeHundredthPips: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openOrders?: Maybe<Scalars['JSON']['output']>;
  price: Scalars['Float']['output'];
  quoteAsset: ChainflipAsset;
  quoteLiquidityAmount: Scalars['BigFloat']['output'];
  rangeOrderPrice: Scalars['Float']['output'];
  sellPrice: Scalars['Float']['output'];
};

export type PoolAggregates = {
  __typename?: 'PoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolVarianceSampleAggregates>;
};

export type PoolAverageAggregates = {
  __typename?: 'PoolAverageAggregates';
  /** Mean average of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Mean average of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Mean average of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

/** A condition to be used against `Pool` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PoolCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseLiquidityAmount` field. */
  baseLiquidityAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `buyPrice` field. */
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openOrders` field. */
  openOrders?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `quoteLiquidityAmount` field. */
  quoteLiquidityAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rangeOrderPrice` field. */
  rangeOrderPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `sellPrice` field. */
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PoolDistinctCountAggregates = {
  __typename?: 'PoolDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openOrders across the matching connection */
  openOrders?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Pool` object types. All fields are combined with a logical ‘and.’ */
export type PoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseLiquidityAmount` field. */
  baseLiquidityAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `buyPrice` field. */
  buyPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolFilter>;
  /** Filter by the object’s `openOrders` field. */
  openOrders?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `quoteLiquidityAmount` field. */
  quoteLiquidityAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rangeOrderPrice` field. */
  rangeOrderPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `sellPrice` field. */
  sellPrice?: InputMaybe<FloatFilter>;
};

/** Grouping methods for `Pool` for usage during aggregation. */
export type PoolGroupBy =
  | 'BASE_ASSET'
  | 'BASE_LIQUIDITY_AMOUNT'
  | 'BUY_PRICE'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS'
  | 'OPEN_ORDERS'
  | 'PRICE'
  | 'QUOTE_ASSET'
  | 'QUOTE_LIQUIDITY_AMOUNT'
  | 'RANGE_ORDER_PRICE'
  | 'SELL_PRICE';

export type PoolHavingAverageInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingDistinctCountInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `Pool` aggregates. */
export type PoolHavingInput = {
  AND?: InputMaybe<Array<PoolHavingInput>>;
  OR?: InputMaybe<Array<PoolHavingInput>>;
  average?: InputMaybe<PoolHavingAverageInput>;
  distinctCount?: InputMaybe<PoolHavingDistinctCountInput>;
  max?: InputMaybe<PoolHavingMaxInput>;
  min?: InputMaybe<PoolHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolHavingStddevSampleInput>;
  sum?: InputMaybe<PoolHavingSumInput>;
  variancePopulation?: InputMaybe<PoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolHavingVarianceSampleInput>;
};

export type PoolHavingMaxInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingMinInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingStddevPopulationInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingStddevSampleInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingSumInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingVariancePopulationInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingVarianceSampleInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolMaxAggregates = {
  __typename?: 'PoolMaxAggregates';
  /** Maximum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Maximum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Maximum of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolMinAggregates = {
  __typename?: 'PoolMinAggregates';
  /** Minimum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Minimum of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolStddevPopulationAggregates = {
  __typename?: 'PoolStddevPopulationAggregates';
  /** Population standard deviation of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolStddevSampleAggregates = {
  __typename?: 'PoolStddevSampleAggregates';
  /** Sample standard deviation of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolSumAggregates = {
  __typename?: 'PoolSumAggregates';
  /** Sum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount: Scalars['BigFloat']['output'];
  /** Sum of buyPrice across the matching connection */
  buyPrice: Scalars['Float']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['Float']['output'];
  /** Sum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount: Scalars['BigFloat']['output'];
  /** Sum of rangeOrderPrice across the matching connection */
  rangeOrderPrice: Scalars['Float']['output'];
  /** Sum of sellPrice across the matching connection */
  sellPrice: Scalars['Float']['output'];
};

export type PoolVariancePopulationAggregates = {
  __typename?: 'PoolVariancePopulationAggregates';
  /** Population variance of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population variance of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Population variance of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolVarianceSampleAggregates = {
  __typename?: 'PoolVarianceSampleAggregates';
  /** Sample variance of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of `Pool` values. */
export type PoolsConnection = {
  __typename?: 'PoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolAggregates>;
  /** A list of edges which contains the `Pool` and cursor to aid in pagination. */
  edges: Array<PoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolAggregates>>;
  /** A list of `Pool` objects. */
  nodes: Array<Pool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Pool` values. */
export type PoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolGroupBy>;
  having?: InputMaybe<PoolHavingInput>;
};

/** A `Pool` edge in the connection. */
export type PoolsEdge = {
  __typename?: 'PoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Pool` at the end of the edge. */
  node: Pool;
};

/** Methods to use when ordering `Pool`. */
export type PoolsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_LIQUIDITY_AMOUNT_ASC'
  | 'BASE_LIQUIDITY_AMOUNT_DESC'
  | 'BUY_PRICE_ASC'
  | 'BUY_PRICE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_ASC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_DESC'
  | 'NATURAL'
  | 'OPEN_ORDERS_ASC'
  | 'OPEN_ORDERS_DESC'
  | 'PRICE_ASC'
  | 'PRICE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'QUOTE_LIQUIDITY_AMOUNT_ASC'
  | 'QUOTE_LIQUIDITY_AMOUNT_DESC'
  | 'RANGE_ORDER_PRICE_ASC'
  | 'RANGE_ORDER_PRICE_DESC'
  | 'SELL_PRICE_ASC'
  | 'SELL_PRICE_DESC';

export type PriceAsset =
  | 'Btc'
  | 'Eth'
  | 'Fine'
  | 'Sol'
  | 'Usd'
  | 'Usdc'
  | 'Usdt';

/** A filter to be used against PriceAsset fields. All fields are combined with a logical ‘and.’ */
export type PriceAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PriceAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PriceAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PriceAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PriceAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PriceAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PriceAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PriceAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PriceAsset>>;
};

export type PriceQueryInput = {
  address: Scalars['String']['input'];
  chainId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `_PrismaMigration` using its globally unique `ID`. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** Get a single `_PrismaMigration`. */
  _prismaMigrationById?: Maybe<_PrismaMigration>;
  /** Reads a single `Account` using its globally unique `ID`. */
  account?: Maybe<Account>;
  /** Get a single `Account`. */
  accountByIdHex?: Maybe<Account>;
  /** Get a single `Account`. */
  accountByIdSs58?: Maybe<Account>;
  /** Reads a single `AccountLink` using its globally unique `ID`. */
  accountLink?: Maybe<AccountLink>;
  /** Get a single `AccountLink`. */
  accountLinkByAccountIdSs58AndEthereumAddress?: Maybe<AccountLink>;
  /** Get a single `AccountLink`. */
  accountLinkById?: Maybe<AccountLink>;
  /** Reads and enables pagination through a set of `AccountLink`. */
  allAccountLinks?: Maybe<AccountLinksConnection>;
  /** Reads and enables pagination through a set of `Account`. */
  allAccounts?: Maybe<AccountsConnection>;
  /** Reads and enables pagination through a set of `Auction`. */
  allAuctions?: Maybe<AuctionsConnection>;
  /** Reads and enables pagination through a set of `Banner`. */
  allBanners?: Maybe<BannersConnection>;
  /** Reads and enables pagination through a set of `BoostBalance`. */
  allBoostBalances?: Maybe<BoostBalancesConnection>;
  /** Reads and enables pagination through a set of `BoostDelayChainflipBlock`. */
  allBoostDelayChainflipBlocks?: Maybe<BoostDelayChainflipBlocksConnection>;
  /** Reads and enables pagination through a set of `BoostPool`. */
  allBoostPools?: Maybe<BoostPoolsConnection>;
  /** Reads and enables pagination through a set of `BoostSafeMode`. */
  allBoostSafeModes?: Maybe<BoostSafeModesConnection>;
  /** Reads and enables pagination through a set of `BrokerAccount`. */
  allBrokerAccounts?: Maybe<BrokerAccountsConnection>;
  /** Reads and enables pagination through a set of `Circulation`. */
  allCirculations?: Maybe<CirculationsConnection>;
  /** Reads and enables pagination through a set of `Delegation`. */
  allDelegations?: Maybe<DelegationsConnection>;
  /** Reads and enables pagination through a set of `DepositBalance`. */
  allDepositBalances?: Maybe<DepositBalancesConnection>;
  /** Reads and enables pagination through a set of `EnvironmentAddress`. */
  allEnvironmentAddresses?: Maybe<EnvironmentAddressesConnection>;
  /** Reads and enables pagination through a set of `FlipSupply`. */
  allFlipSupplies?: Maybe<FlipSuppliesConnection>;
  /** Reads and enables pagination through a set of `LendingGlobalConfig`. */
  allLendingGlobalConfigs?: Maybe<LendingGlobalConfigsConnection>;
  /** Reads and enables pagination through a set of `LendingPool`. */
  allLendingPools?: Maybe<LendingPoolsConnection>;
  /** Reads and enables pagination through a set of `Loan`. */
  allLoans?: Maybe<LoansConnection>;
  /** Reads and enables pagination through a set of `LpAccount`. */
  allLpAccounts?: Maybe<LpAccountsConnection>;
  /** Reads and enables pagination through a set of `LpCollateralBalance`. */
  allLpCollateralBalances?: Maybe<LpCollateralBalancesConnection>;
  /** Reads and enables pagination through a set of `LpLendingBalance`. */
  allLpLendingBalances?: Maybe<LpLendingBalancesConnection>;
  /** Reads and enables pagination through a set of `LpLoanAccount`. */
  allLpLoanAccounts?: Maybe<LpLoanAccountsConnection>;
  /** Reads and enables pagination through a set of `OperatorValidator`. */
  allOperatorValidators?: Maybe<OperatorValidatorsConnection>;
  /** Reads and enables pagination through a set of `Operator`. */
  allOperators?: Maybe<OperatorsConnection>;
  /** Reads and enables pagination through a set of `OraclePrice`. */
  allOraclePrices?: Maybe<OraclePricesConnection>;
  /** Reads and enables pagination through a set of `Pool`. */
  allPools?: Maybe<PoolsConnection>;
  /** Reads and enables pagination through a set of `_PrismaMigration`. */
  allPrismaMigrations?: Maybe<_PrismaMigrationsConnection>;
  /** Reads and enables pagination through a set of `SupportedAsset`. */
  allSupportedAssets?: Maybe<SupportedAssetsConnection>;
  /** Reads and enables pagination through a set of `TokenPrice`. */
  allTokenPrices?: Maybe<TokenPricesConnection>;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  allTradingStrategies?: Maybe<TradingStrategiesConnection>;
  /** Reads and enables pagination through a set of `TradingStrategyLimit`. */
  allTradingStrategyLimits?: Maybe<TradingStrategyLimitsConnection>;
  /** Reads and enables pagination through a set of `Unregistered`. */
  allUnregistereds?: Maybe<UnregisteredsConnection>;
  /** Reads and enables pagination through a set of `Validator`. */
  allValidators?: Maybe<ValidatorsConnection>;
  /** Reads a single `Auction` using its globally unique `ID`. */
  auction?: Maybe<Auction>;
  /** Get a single `Auction`. */
  auctionById?: Maybe<Auction>;
  /** Reads a single `Banner` using its globally unique `ID`. */
  banner?: Maybe<Banner>;
  /** Get a single `Banner`. */
  bannerByApp?: Maybe<Banner>;
  /** Get a single `BoostBalance`. */
  boostBalanceByPoolIdAndLpIdSs58?: Maybe<BoostBalance>;
  /** Reads a single `BoostDelayChainflipBlock` using its globally unique `ID`. */
  boostDelayChainflipBlock?: Maybe<BoostDelayChainflipBlock>;
  /** Get a single `BoostDelayChainflipBlock`. */
  boostDelayChainflipBlockByChain?: Maybe<BoostDelayChainflipBlock>;
  /** Get a single `BoostDelayChainflipBlock`. */
  boostDelayChainflipBlockById?: Maybe<BoostDelayChainflipBlock>;
  /** Reads a single `BoostPool` using its globally unique `ID`. */
  boostPool?: Maybe<BoostPool>;
  /** Get a single `BoostPool`. */
  boostPoolByAssetAndFeeTierPips?: Maybe<BoostPool>;
  /** Get a single `BoostPool`. */
  boostPoolById?: Maybe<BoostPool>;
  /** Reads a single `BoostSafeMode` using its globally unique `ID`. */
  boostSafeMode?: Maybe<BoostSafeMode>;
  /** Get a single `BoostSafeMode`. */
  boostSafeModeByChain?: Maybe<BoostSafeMode>;
  /** Get a single `BoostSafeMode`. */
  boostSafeModeById?: Maybe<BoostSafeMode>;
  /** Reads a single `BrokerAccount` using its globally unique `ID`. */
  brokerAccount?: Maybe<BrokerAccount>;
  /** Get a single `BrokerAccount`. */
  brokerAccountByIdSs58?: Maybe<BrokerAccount>;
  /** Reads a single `Circulation` using its globally unique `ID`. */
  circulation?: Maybe<Circulation>;
  /** Get a single `Circulation`. */
  circulationById?: Maybe<Circulation>;
  /** Get a single `Delegation`. */
  delegationByDelegatorIdSs58AndOperatorIdSs58?: Maybe<Delegation>;
  /** Get a single `DepositBalance`. */
  depositBalanceByChainAndAssetAndLpIdSs58?: Maybe<DepositBalance>;
  /** Reads a single `EnvironmentAddress` using its globally unique `ID`. */
  environmentAddress?: Maybe<EnvironmentAddress>;
  /** Get a single `EnvironmentAddress`. */
  environmentAddressById?: Maybe<EnvironmentAddress>;
  /** Reads a single `FlipSupply` using its globally unique `ID`. */
  flipSupply?: Maybe<FlipSupply>;
  /** Get a single `FlipSupply`. */
  flipSupplyById?: Maybe<FlipSupply>;
  getTokenPrices: Array<TokenPrice>;
  /** Reads a single `LendingGlobalConfig` using its globally unique `ID`. */
  lendingGlobalConfig?: Maybe<LendingGlobalConfig>;
  /** Get a single `LendingGlobalConfig`. */
  lendingGlobalConfigById?: Maybe<LendingGlobalConfig>;
  /** Get a single `LendingPool`. */
  lendingPoolByAsset?: Maybe<LendingPool>;
  /** Reads a single `Loan` using its globally unique `ID`. */
  loan?: Maybe<Loan>;
  /** Get a single `Loan`. */
  loanById?: Maybe<Loan>;
  /** Reads a single `LpAccount` using its globally unique `ID`. */
  lpAccount?: Maybe<LpAccount>;
  /** Get a single `LpAccount`. */
  lpAccountByIdSs58?: Maybe<LpAccount>;
  /** Get a single `LpCollateralBalance`. */
  lpCollateralBalanceByLoanAccountLpIdSs58AndAsset?: Maybe<LpCollateralBalance>;
  /** Get a single `LpLendingBalance`. */
  lpLendingBalanceByAssetAndLpIdSs58?: Maybe<LpLendingBalance>;
  /** Get a single `LpLoanAccount`. */
  lpLoanAccountByLpIdSs58?: Maybe<LpLoanAccount>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` using its globally unique `ID`. */
  operator?: Maybe<Operator>;
  /** Get a single `Operator`. */
  operatorByIdSs58?: Maybe<Operator>;
  /** Reads a single `OperatorValidator` using its globally unique `ID`. */
  operatorValidator?: Maybe<OperatorValidator>;
  /** Get a single `OperatorValidator`. */
  operatorValidatorById?: Maybe<OperatorValidator>;
  /** Reads a single `OraclePrice` using its globally unique `ID`. */
  oraclePrice?: Maybe<OraclePrice>;
  /** Get a single `OraclePrice`. */
  oraclePriceByBaseAssetAndQuoteAsset?: Maybe<OraclePrice>;
  /** Get a single `OraclePrice`. */
  oraclePriceById?: Maybe<OraclePrice>;
  pendingDeposits: Array<Maybe<PendingDeposit>>;
  /** Reads a single `Pool` using its globally unique `ID`. */
  pool?: Maybe<Pool>;
  /** Get a single `Pool`. */
  poolById?: Maybe<Pool>;
  /** Get a single `Pool`. */
  poolByQuoteAssetAndBaseAsset?: Maybe<Pool>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Get a single `SupportedAsset`. */
  supportedAssetById?: Maybe<SupportedAsset>;
  /** Reads a single `TokenPrice` using its globally unique `ID`. */
  tokenPrice?: Maybe<TokenPrice>;
  /** Get a single `TokenPrice`. */
  tokenPriceByChainIdAndAddress?: Maybe<TokenPrice>;
  /** Get a single `TradingStrategy`. */
  tradingStrategyByStrategyAccountIdSs58?: Maybe<TradingStrategy>;
  /** Reads a single `TradingStrategyLimit` using its globally unique `ID`. */
  tradingStrategyLimit?: Maybe<TradingStrategyLimit>;
  /** Get a single `TradingStrategyLimit`. */
  tradingStrategyLimitByAsset?: Maybe<TradingStrategyLimit>;
  /** Get a single `TradingStrategyLimit`. */
  tradingStrategyLimitById?: Maybe<TradingStrategyLimit>;
  /** Reads a single `Unregistered` using its globally unique `ID`. */
  unregistered?: Maybe<Unregistered>;
  /** Get a single `Unregistered`. */
  unregisteredByIdSs58?: Maybe<Unregistered>;
  /** Reads a single `Validator` using its globally unique `ID`. */
  validator?: Maybe<Validator>;
  /** Get a single `Validator`. */
  validatorByIdSs58?: Maybe<Validator>;
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdHexArgs = {
  idHex: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountLinkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountLinkByAccountIdSs58AndEthereumAddressArgs = {
  accountIdSs58: Scalars['String']['input'];
  ethereumAddress: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountLinkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountLinkCondition>;
  filter?: InputMaybe<AccountLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAuctionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionCondition>;
  filter?: InputMaybe<AuctionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBannersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BannerCondition>;
  filter?: InputMaybe<BannerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BannersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostDelayChainflipBlocksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostDelayChainflipBlockCondition>;
  filter?: InputMaybe<BoostDelayChainflipBlockFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostDelayChainflipBlocksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolCondition>;
  filter?: InputMaybe<BoostPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostSafeModesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostSafeModeCondition>;
  filter?: InputMaybe<BoostSafeModeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSafeModesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountCondition>;
  filter?: InputMaybe<BrokerAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCirculationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CirculationCondition>;
  filter?: InputMaybe<CirculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CirculationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDelegationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationCondition>;
  filter?: InputMaybe<DelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDepositBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositBalanceCondition>;
  filter?: InputMaybe<DepositBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEnvironmentAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentAddressCondition>;
  filter?: InputMaybe<EnvironmentAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFlipSuppliesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlipSupplyCondition>;
  filter?: InputMaybe<FlipSupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlipSuppliesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingGlobalConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingGlobalConfigCondition>;
  filter?: InputMaybe<LendingGlobalConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingGlobalConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolCondition>;
  filter?: InputMaybe<LendingPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLoansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpAccountCondition>;
  filter?: InputMaybe<LpAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpCollateralBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpCollateralBalanceCondition>;
  filter?: InputMaybe<LpCollateralBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpCollateralBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpLendingBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingBalanceCondition>;
  filter?: InputMaybe<LpLendingBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpLoanAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLoanAccountCondition>;
  filter?: InputMaybe<LpLoanAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLoanAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorValidatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorCondition>;
  filter?: InputMaybe<OperatorValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorCondition>;
  filter?: InputMaybe<OperatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOraclePricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OraclePriceCondition>;
  filter?: InputMaybe<OraclePriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OraclePricesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolCondition>;
  filter?: InputMaybe<PoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrismaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<_PrismaMigrationCondition>;
  filter?: InputMaybe<_PrismaMigrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSupportedAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupportedAssetCondition>;
  filter?: InputMaybe<SupportedAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportedAssetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTokenPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenPriceCondition>;
  filter?: InputMaybe<TokenPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategyLimitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyLimitCondition>;
  filter?: InputMaybe<TradingStrategyLimitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategyLimitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUnregisteredsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnregisteredCondition>;
  filter?: InputMaybe<UnregisteredFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnregisteredsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllValidatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerByAppArgs = {
  app: App;
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostBalanceByPoolIdAndLpIdSs58Args = {
  lpIdSs58: Scalars['String']['input'];
  poolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostDelayChainflipBlockArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostDelayChainflipBlockByChainArgs = {
  chain: ChainflipChain;
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostDelayChainflipBlockByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolByAssetAndFeeTierPipsArgs = {
  asset: ChainflipAsset;
  feeTierPips: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostSafeModeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostSafeModeByChainArgs = {
  chain: ChainflipChain;
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostSafeModeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCirculationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCirculationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDelegationByDelegatorIdSs58AndOperatorIdSs58Args = {
  delegatorIdSs58: Scalars['String']['input'];
  operatorIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepositBalanceByChainAndAssetAndLpIdSs58Args = {
  asset: ChainflipAsset;
  chain: ChainflipChain;
  lpIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentAddressArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentAddressByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlipSupplyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlipSupplyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTokenPricesArgs = {
  input: Array<PriceQueryInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingGlobalConfigArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingGlobalConfigByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolByAssetArgs = {
  asset: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpCollateralBalanceByLoanAccountLpIdSs58AndAssetArgs = {
  asset: ChainflipAsset;
  loanAccountLpIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpLendingBalanceByAssetAndLpIdSs58Args = {
  asset: ChainflipAsset;
  lpIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpLoanAccountByLpIdSs58Args = {
  lpIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorValidatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorValidatorByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceByBaseAssetAndQuoteAssetArgs = {
  baseAsset: PriceAsset;
  quoteAsset: PriceAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPendingDepositsArgs = {
  input: PendingDepositsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolByQuoteAssetAndBaseAssetArgs = {
  baseAsset: ChainflipAsset;
  quoteAsset: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QuerySupportedAssetByIdArgs = {
  id: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPriceByChainIdAndAddressArgs = {
  address: Scalars['String']['input'];
  chainId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyByStrategyAccountIdSs58Args = {
  strategyAccountIdSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyLimitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyLimitByAssetArgs = {
  asset: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyLimitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUnregisteredArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUnregisteredByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type SupportedAsset = {
  __typename?: 'SupportedAsset';
  id: ChainflipAsset;
};

export type SupportedAssetAggregates = {
  __typename?: 'SupportedAssetAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SupportedAssetDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `SupportedAsset` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupportedAssetCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<ChainflipAsset>;
};

export type SupportedAssetDistinctCountAggregates = {
  __typename?: 'SupportedAssetDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SupportedAsset` object types. All fields are combined with a logical ‘and.’ */
export type SupportedAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SupportedAssetFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<ChainflipAssetFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SupportedAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SupportedAssetFilter>>;
};

/** A connection to a list of `SupportedAsset` values. */
export type SupportedAssetsConnection = {
  __typename?: 'SupportedAssetsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SupportedAssetAggregates>;
  /** A list of edges which contains the `SupportedAsset` and cursor to aid in pagination. */
  edges: Array<SupportedAssetsEdge>;
  /** A list of `SupportedAsset` objects. */
  nodes: Array<SupportedAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SupportedAsset` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SupportedAsset` edge in the connection. */
export type SupportedAssetsEdge = {
  __typename?: 'SupportedAssetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SupportedAsset` at the end of the edge. */
  node: SupportedAsset;
};

/** Methods to use when ordering `SupportedAsset`. */
export type SupportedAssetsOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL';

export type TokenPrice = Node & {
  __typename?: 'TokenPrice';
  address: Scalars['String']['output'];
  chainId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  usdPrice: Scalars['Float']['output'];
};

export type TokenPriceAggregates = {
  __typename?: 'TokenPriceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TokenPriceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TokenPriceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TokenPriceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TokenPriceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TokenPriceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TokenPriceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TokenPriceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TokenPriceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TokenPriceVarianceSampleAggregates>;
};

export type TokenPriceAverageAggregates = {
  __typename?: 'TokenPriceAverageAggregates';
  /** Mean average of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * A condition to be used against `TokenPrice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TokenPriceCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chainId` field. */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usdPrice` field. */
  usdPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type TokenPriceDistinctCountAggregates = {
  __typename?: 'TokenPriceDistinctCountAggregates';
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chainId across the matching connection */
  chainId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TokenPrice` object types. All fields are combined with a logical ‘and.’ */
export type TokenPriceFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `chainId` field. */
  chainId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenPriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usdPrice` field. */
  usdPrice?: InputMaybe<FloatFilter>;
};

/** Grouping methods for `TokenPrice` for usage during aggregation. */
export type TokenPriceGroupBy =
  | 'ADDRESS'
  | 'CHAIN_ID'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'CREATED_AT_TRUNCATED_TO_MONTH'
  | 'CREATED_AT_TRUNCATED_TO_WEEK'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT_TRUNCATED_TO_MONTH'
  | 'UPDATED_AT_TRUNCATED_TO_WEEK'
  | 'USD_PRICE';

export type TokenPriceHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `TokenPrice` aggregates. */
export type TokenPriceHavingInput = {
  AND?: InputMaybe<Array<TokenPriceHavingInput>>;
  OR?: InputMaybe<Array<TokenPriceHavingInput>>;
  average?: InputMaybe<TokenPriceHavingAverageInput>;
  distinctCount?: InputMaybe<TokenPriceHavingDistinctCountInput>;
  max?: InputMaybe<TokenPriceHavingMaxInput>;
  min?: InputMaybe<TokenPriceHavingMinInput>;
  stddevPopulation?: InputMaybe<TokenPriceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TokenPriceHavingStddevSampleInput>;
  sum?: InputMaybe<TokenPriceHavingSumInput>;
  variancePopulation?: InputMaybe<TokenPriceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TokenPriceHavingVarianceSampleInput>;
};

export type TokenPriceHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceMaxAggregates = {
  __typename?: 'TokenPriceMaxAggregates';
  /** Maximum of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceMinAggregates = {
  __typename?: 'TokenPriceMinAggregates';
  /** Minimum of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceStddevPopulationAggregates = {
  __typename?: 'TokenPriceStddevPopulationAggregates';
  /** Population standard deviation of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceStddevSampleAggregates = {
  __typename?: 'TokenPriceStddevSampleAggregates';
  /** Sample standard deviation of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceSumAggregates = {
  __typename?: 'TokenPriceSumAggregates';
  /** Sum of usdPrice across the matching connection */
  usdPrice: Scalars['Float']['output'];
};

export type TokenPriceVariancePopulationAggregates = {
  __typename?: 'TokenPriceVariancePopulationAggregates';
  /** Population variance of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceVarianceSampleAggregates = {
  __typename?: 'TokenPriceVarianceSampleAggregates';
  /** Sample variance of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of `TokenPrice` values. */
export type TokenPricesConnection = {
  __typename?: 'TokenPricesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TokenPriceAggregates>;
  /** A list of edges which contains the `TokenPrice` and cursor to aid in pagination. */
  edges: Array<TokenPricesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TokenPriceAggregates>>;
  /** A list of `TokenPrice` objects. */
  nodes: Array<TokenPrice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenPrice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TokenPrice` values. */
export type TokenPricesConnectionGroupedAggregatesArgs = {
  groupBy: Array<TokenPriceGroupBy>;
  having?: InputMaybe<TokenPriceHavingInput>;
};

/** A `TokenPrice` edge in the connection. */
export type TokenPricesEdge = {
  __typename?: 'TokenPricesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenPrice` at the end of the edge. */
  node: TokenPrice;
};

/** Methods to use when ordering `TokenPrice`. */
export type TokenPricesOrderBy =
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'CHAIN_ID_ASC'
  | 'CHAIN_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USD_PRICE_ASC'
  | 'USD_PRICE_DESC';

/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnection = {
  __typename?: 'TradingStrategiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyAggregates>;
  /** A list of edges which contains the `TradingStrategy` and cursor to aid in pagination. */
  edges: Array<TradingStrategiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyAggregates>>;
  /** A list of `TradingStrategy` objects. */
  nodes: Array<TradingStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyGroupBy>;
  having?: InputMaybe<TradingStrategyHavingInput>;
};

/** A `TradingStrategy` edge in the connection. */
export type TradingStrategiesEdge = {
  __typename?: 'TradingStrategiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategy` at the end of the edge. */
  node: TradingStrategy;
};

/** Methods to use when ordering `TradingStrategy`. */
export type TradingStrategiesOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_BALANCE_ASC'
  | 'BASE_ASSET_BALANCE_DESC'
  | 'BASE_ASSET_BALANCE_USD_ASC'
  | 'BASE_ASSET_BALANCE_USD_DESC'
  | 'BASE_ASSET_DESC'
  | 'KEY_ASC'
  | 'KEY_DESC'
  | 'NATURAL'
  | 'OWNER_ACCOUNT_ID_SS58_ASC'
  | 'OWNER_ACCOUNT_ID_SS58_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_BALANCE_ASC'
  | 'QUOTE_ASSET_BALANCE_DESC'
  | 'QUOTE_ASSET_BALANCE_USD_ASC'
  | 'QUOTE_ASSET_BALANCE_USD_DESC'
  | 'QUOTE_ASSET_DESC'
  | 'STRATEGY_ACCOUNT_ID_SS58_ASC'
  | 'STRATEGY_ACCOUNT_ID_SS58_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type TradingStrategy = {
  __typename?: 'TradingStrategy';
  baseAsset: ChainflipAsset;
  baseAssetBalance: Scalars['BigFloat']['output'];
  baseAssetBalanceUsd: Scalars['BigFloat']['output'];
  key: Scalars['String']['output'];
  /** Reads a single `LpAccount` that is related to this `TradingStrategy`. */
  lpAccountByOwnerAccountIdSs58: LpAccount;
  ownerAccountIdSs58: Scalars['String']['output'];
  quoteAsset: ChainflipAsset;
  quoteAssetBalance: Scalars['BigFloat']['output'];
  quoteAssetBalanceUsd: Scalars['BigFloat']['output'];
  strategyAccountIdSs58: Scalars['String']['output'];
  type: TradingStrategyType;
};

export type TradingStrategyAggregates = {
  __typename?: 'TradingStrategyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TradingStrategy` object types. */
export type TradingStrategyAggregatesFilter = {
  /** Mean average aggregate over matching `TradingStrategy` objects. */
  average?: InputMaybe<TradingStrategyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TradingStrategy` objects. */
  distinctCount?: InputMaybe<TradingStrategyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TradingStrategy` object to be included within the aggregate. */
  filter?: InputMaybe<TradingStrategyFilter>;
  /** Maximum aggregate over matching `TradingStrategy` objects. */
  max?: InputMaybe<TradingStrategyMaxAggregateFilter>;
  /** Minimum aggregate over matching `TradingStrategy` objects. */
  min?: InputMaybe<TradingStrategyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TradingStrategy` objects. */
  stddevPopulation?: InputMaybe<TradingStrategyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TradingStrategy` objects. */
  stddevSample?: InputMaybe<TradingStrategyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TradingStrategy` objects. */
  sum?: InputMaybe<TradingStrategySumAggregateFilter>;
  /** Population variance aggregate over matching `TradingStrategy` objects. */
  variancePopulation?: InputMaybe<TradingStrategyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TradingStrategy` objects. */
  varianceSample?: InputMaybe<TradingStrategyVarianceSampleAggregateFilter>;
};

export type TradingStrategyAverageAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyAverageAggregates = {
  __typename?: 'TradingStrategyAverageAggregates';
  /** Mean average of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TradingStrategy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseAssetBalance` field. */
  baseAssetBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseAssetBalanceUsd` field. */
  baseAssetBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  lpAccountByOwnerAccountIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `ownerAccountIdSs58` field. */
  ownerAccountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `quoteAssetBalance` field. */
  quoteAssetBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteAssetBalanceUsd` field. */
  quoteAssetBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `strategyAccountIdSs58` field. */
  strategyAccountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<TradingStrategyType>;
};

export type TradingStrategyDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  baseAssetBalance?: InputMaybe<BigIntFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigIntFilter>;
  key?: InputMaybe<BigIntFilter>;
  ownerAccountIdSs58?: InputMaybe<BigIntFilter>;
  quoteAsset?: InputMaybe<BigIntFilter>;
  quoteAssetBalance?: InputMaybe<BigIntFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigIntFilter>;
  strategyAccountIdSs58?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type TradingStrategyDistinctCountAggregates = {
  __typename?: 'TradingStrategyDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of key across the matching connection */
  key?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ownerAccountIdSs58 across the matching connection */
  ownerAccountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyAccountIdSs58 across the matching connection */
  strategyAccountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseAssetBalance` field. */
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseAssetBalanceUsd` field. */
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpAccountByOwnerAccountIdSs58` relation. */
  lpAccountByOwnerAccountIdSs58?: InputMaybe<LpAccountFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `ownerAccountIdSs58` field. */
  ownerAccountIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `quoteAssetBalance` field. */
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteAssetBalanceUsd` field. */
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `strategyAccountIdSs58` field. */
  strategyAccountIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<TradingStrategyTypeFilter>;
};

/** Grouping methods for `TradingStrategy` for usage during aggregation. */
export type TradingStrategyGroupBy =
  | 'BASE_ASSET'
  | 'BASE_ASSET_BALANCE'
  | 'BASE_ASSET_BALANCE_USD'
  | 'KEY'
  | 'OWNER_ACCOUNT_ID_SS58'
  | 'QUOTE_ASSET'
  | 'QUOTE_ASSET_BALANCE'
  | 'QUOTE_ASSET_BALANCE_USD'
  | 'TYPE';

export type TradingStrategyHavingAverageInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingDistinctCountInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `TradingStrategy` aggregates. */
export type TradingStrategyHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyHavingInput>>;
  average?: InputMaybe<TradingStrategyHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyHavingMaxInput>;
  min?: InputMaybe<TradingStrategyHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyHavingVarianceSampleInput>;
};

export type TradingStrategyHavingMaxInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingMinInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingStddevPopulationInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingStddevSampleInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingSumInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingVariancePopulationInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyHavingVarianceSampleInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimit = Node & {
  __typename?: 'TradingStrategyLimit';
  asset: ChainflipAsset;
  id: Scalars['Int']['output'];
  minimumAddedFundsAmount: Scalars['BigFloat']['output'];
  minimumDeploymentAmount: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type TradingStrategyLimitAggregates = {
  __typename?: 'TradingStrategyLimitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyLimitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyLimitDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyLimitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyLimitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyLimitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyLimitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategyLimitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyLimitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyLimitVarianceSampleAggregates>;
};

export type TradingStrategyLimitAverageAggregates = {
  __typename?: 'TradingStrategyLimitAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TradingStrategyLimit` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyLimitCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minimumAddedFundsAmount` field. */
  minimumAddedFundsAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minimumDeploymentAmount` field. */
  minimumDeploymentAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type TradingStrategyLimitDistinctCountAggregates = {
  __typename?: 'TradingStrategyLimitDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategyLimit` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyLimitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyLimitFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minimumAddedFundsAmount` field. */
  minimumAddedFundsAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minimumDeploymentAmount` field. */
  minimumDeploymentAmount?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyLimitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyLimitFilter>>;
};

/** Grouping methods for `TradingStrategyLimit` for usage during aggregation. */
export type TradingStrategyLimitGroupBy =
  | 'MINIMUM_ADDED_FUNDS_AMOUNT'
  | 'MINIMUM_DEPLOYMENT_AMOUNT';

export type TradingStrategyLimitHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `TradingStrategyLimit` aggregates. */
export type TradingStrategyLimitHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyLimitHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyLimitHavingInput>>;
  average?: InputMaybe<TradingStrategyLimitHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyLimitHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyLimitHavingMaxInput>;
  min?: InputMaybe<TradingStrategyLimitHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyLimitHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyLimitHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyLimitHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyLimitHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyLimitHavingVarianceSampleInput>;
};

export type TradingStrategyLimitHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitMaxAggregates = {
  __typename?: 'TradingStrategyLimitMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitMinAggregates = {
  __typename?: 'TradingStrategyLimitMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitStddevPopulationAggregates = {
  __typename?: 'TradingStrategyLimitStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitStddevSampleAggregates = {
  __typename?: 'TradingStrategyLimitStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitSumAggregates = {
  __typename?: 'TradingStrategyLimitSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount: Scalars['BigFloat']['output'];
  /** Sum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount: Scalars['BigFloat']['output'];
};

export type TradingStrategyLimitVariancePopulationAggregates = {
  __typename?: 'TradingStrategyLimitVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitVarianceSampleAggregates = {
  __typename?: 'TradingStrategyLimitVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `TradingStrategyLimit` values. */
export type TradingStrategyLimitsConnection = {
  __typename?: 'TradingStrategyLimitsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyLimitAggregates>;
  /** A list of edges which contains the `TradingStrategyLimit` and cursor to aid in pagination. */
  edges: Array<TradingStrategyLimitsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyLimitAggregates>>;
  /** A list of `TradingStrategyLimit` objects. */
  nodes: Array<TradingStrategyLimit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategyLimit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategyLimit` values. */
export type TradingStrategyLimitsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyLimitGroupBy>;
  having?: InputMaybe<TradingStrategyLimitHavingInput>;
};

/** A `TradingStrategyLimit` edge in the connection. */
export type TradingStrategyLimitsEdge = {
  __typename?: 'TradingStrategyLimitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategyLimit` at the end of the edge. */
  node: TradingStrategyLimit;
};

/** Methods to use when ordering `TradingStrategyLimit`. */
export type TradingStrategyLimitsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MINIMUM_ADDED_FUNDS_AMOUNT_ASC'
  | 'MINIMUM_ADDED_FUNDS_AMOUNT_DESC'
  | 'MINIMUM_DEPLOYMENT_AMOUNT_ASC'
  | 'MINIMUM_DEPLOYMENT_AMOUNT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type TradingStrategyMaxAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyMaxAggregates = {
  __typename?: 'TradingStrategyMaxAggregates';
  /** Maximum of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyMinAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyMinAggregates = {
  __typename?: 'TradingStrategyMinAggregates';
  /** Minimum of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyStddevPopulationAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyStddevPopulationAggregates = {
  __typename?: 'TradingStrategyStddevPopulationAggregates';
  /** Population standard deviation of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyStddevSampleAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyStddevSampleAggregates = {
  __typename?: 'TradingStrategyStddevSampleAggregates';
  /** Sample standard deviation of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategySumAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategySumAggregates = {
  __typename?: 'TradingStrategySumAggregates';
  /** Sum of baseAssetBalance across the matching connection */
  baseAssetBalance: Scalars['BigFloat']['output'];
  /** Sum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd: Scalars['BigFloat']['output'];
  /** Sum of quoteAssetBalance across the matching connection */
  quoteAssetBalance: Scalars['BigFloat']['output'];
  /** Sum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd: Scalars['BigFloat']['output'];
};

export type TradingStrategyType =
  | 'InventoryBased'
  | 'OracleTracking'
  | 'SimpleBuySell'
  | 'TickZeroCentered';

/** A filter to be used against TradingStrategyType fields. All fields are combined with a logical ‘and.’ */
export type TradingStrategyTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TradingStrategyType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TradingStrategyType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TradingStrategyType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TradingStrategyType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TradingStrategyType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TradingStrategyType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TradingStrategyType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TradingStrategyType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TradingStrategyType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TradingStrategyType>>;
};

export type TradingStrategyVariancePopulationAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyVariancePopulationAggregates = {
  __typename?: 'TradingStrategyVariancePopulationAggregates';
  /** Population variance of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyVarianceSampleAggregateFilter = {
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyVarianceSampleAggregates = {
  __typename?: 'TradingStrategyVarianceSampleAggregates';
  /** Sample variance of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type Unregistered = Node & {
  __typename?: 'Unregistered';
  /** Reads a single `Account` that is related to this `Unregistered`. */
  accountByIdSs58: Account;
  idSs58: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type UnregisteredAggregates = {
  __typename?: 'UnregisteredAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UnregisteredDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `Unregistered` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnregisteredCondition = {
  accountByIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
};

export type UnregisteredDistinctCountAggregates = {
  __typename?: 'UnregisteredDistinctCountAggregates';
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Unregistered` object types. All fields are combined with a logical ‘and.’ */
export type UnregisteredFilter = {
  /** Filter by the object’s `accountByIdSs58` relation. */
  accountByIdSs58?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnregisteredFilter>>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnregisteredFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnregisteredFilter>>;
};

/** A connection to a list of `Unregistered` values. */
export type UnregisteredsConnection = {
  __typename?: 'UnregisteredsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UnregisteredAggregates>;
  /** A list of edges which contains the `Unregistered` and cursor to aid in pagination. */
  edges: Array<UnregisteredsEdge>;
  /** A list of `Unregistered` objects. */
  nodes: Array<Unregistered>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Unregistered` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Unregistered` edge in the connection. */
export type UnregisteredsEdge = {
  __typename?: 'UnregisteredsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Unregistered` at the end of the edge. */
  node: Unregistered;
};

/** Methods to use when ordering `Unregistered`. */
export type UnregisteredsOrderBy =
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type Validator = Node & {
  __typename?: 'Validator';
  accountBid: Scalars['BigFloat']['output'];
  accountBidValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Account` that is related to this `Validator`. */
  accountByIdSs58: Account;
  alias?: Maybe<Scalars['String']['output']>;
  apyBp?: Maybe<Scalars['Int']['output']>;
  bid: Scalars['BigFloat']['output'];
  bidValueUsd: Scalars['BigFloat']['output'];
  boundRedeemAddress?: Maybe<Scalars['String']['output']>;
  idHex: Scalars['String']['output'];
  idSs58: Scalars['String']['output'];
  isBidding: Scalars['Boolean']['output'];
  isCurrentAuthority: Scalars['Boolean']['output'];
  isCurrentBackup: Scalars['Boolean']['output'];
  isKeyholder: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isQualified: Scalars['Boolean']['output'];
  lockedBalance: Scalars['BigFloat']['output'];
  lockedBalanceValueUsd: Scalars['BigFloat']['output'];
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OperatorValidator`. */
  operatorValidatorsByValidatorIdSs58: OperatorValidatorsConnection;
  reputationPoints: Scalars['Int']['output'];
  role: AccountRole;
  totalBalance: Scalars['BigFloat']['output'];
  totalBalanceValueUsd: Scalars['BigFloat']['output'];
  totalBid: Scalars['BigFloat']['output'];
  totalBidValueUsd: Scalars['BigFloat']['output'];
  unlockedBalance: Scalars['BigFloat']['output'];
  unlockedBalanceValueUsd: Scalars['BigFloat']['output'];
  upcomingApyBp?: Maybe<Scalars['Int']['output']>;
};


export type ValidatorOperatorValidatorsByValidatorIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorCondition>;
  filter?: InputMaybe<OperatorValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorsOrderBy>>;
};

export type ValidatorAggregates = {
  __typename?: 'ValidatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ValidatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ValidatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ValidatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ValidatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ValidatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ValidatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ValidatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ValidatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ValidatorVarianceSampleAggregates>;
};

export type ValidatorAverageAggregates = {
  __typename?: 'ValidatorAverageAggregates';
  /** Mean average of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Validator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ValidatorCondition = {
  /** Checks for equality with the object’s `accountBid` field. */
  accountBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `accountBidValueUsd` field. */
  accountBidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  accountByIdSs58?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `apyBp` field. */
  apyBp?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `bid` field. */
  bid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bidValueUsd` field. */
  bidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idHex` field. */
  idHex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isBidding` field. */
  isBidding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isCurrentAuthority` field. */
  isCurrentAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isCurrentBackup` field. */
  isCurrentBackup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isKeyholder` field. */
  isKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isOnline` field. */
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isQualified` field. */
  isQualified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lockedBalance` field. */
  lockedBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lockedBalanceValueUsd` field. */
  lockedBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxBid` field. */
  maxBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxBidValueUsd` field. */
  maxBidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `reputationPoints` field. */
  reputationPoints?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<AccountRole>;
  /** Checks for equality with the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBalanceValueUsd` field. */
  totalBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBid` field. */
  totalBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalBidValueUsd` field. */
  totalBidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unlockedBalance` field. */
  unlockedBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unlockedBalanceValueUsd` field. */
  unlockedBalanceValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `upcomingApyBp` field. */
  upcomingApyBp?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidatorDistinctCountAggregates = {
  __typename?: 'ValidatorDistinctCountAggregates';
  /** Distinct count of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bid across the matching connection */
  bid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boundRedeemAddress across the matching connection */
  boundRedeemAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idHex across the matching connection */
  idHex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isBidding across the matching connection */
  isBidding?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isCurrentAuthority across the matching connection */
  isCurrentAuthority?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isCurrentBackup across the matching connection */
  isCurrentBackup?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isKeyholder across the matching connection */
  isKeyholder?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isOnline across the matching connection */
  isOnline?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isQualified across the matching connection */
  isQualified?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Validator` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorFilter = {
  /** Filter by the object’s `accountBid` field. */
  accountBid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `accountBidValueUsd` field. */
  accountBidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `accountByIdSs58` relation. */
  accountByIdSs58?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `apyBp` field. */
  apyBp?: InputMaybe<IntFilter>;
  /** Filter by the object’s `bid` field. */
  bid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bidValueUsd` field. */
  bidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idHex` field. */
  idHex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isBidding` field. */
  isBidding?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrentAuthority` field. */
  isCurrentAuthority?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrentBackup` field. */
  isCurrentBackup?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isKeyholder` field. */
  isKeyholder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isOnline` field. */
  isOnline?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isQualified` field. */
  isQualified?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lockedBalance` field. */
  lockedBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lockedBalanceValueUsd` field. */
  lockedBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxBid` field. */
  maxBid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxBidValueUsd` field. */
  maxBidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `operatorValidatorsByValidatorIdSs58` relation. */
  operatorValidatorsByValidatorIdSs58?: InputMaybe<ValidatorToManyOperatorValidatorFilter>;
  /** Some related `operatorValidatorsByValidatorIdSs58` exist. */
  operatorValidatorsByValidatorIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `reputationPoints` field. */
  reputationPoints?: InputMaybe<IntFilter>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<AccountRoleFilter>;
  /** Filter by the object’s `totalBalance` field. */
  totalBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBalanceValueUsd` field. */
  totalBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBid` field. */
  totalBid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalBidValueUsd` field. */
  totalBidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unlockedBalance` field. */
  unlockedBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unlockedBalanceValueUsd` field. */
  unlockedBalanceValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `upcomingApyBp` field. */
  upcomingApyBp?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Validator` for usage during aggregation. */
export type ValidatorGroupBy =
  | 'ACCOUNT_BID'
  | 'ACCOUNT_BID_VALUE_USD'
  | 'ALIAS'
  | 'APY_BP'
  | 'BID'
  | 'BID_VALUE_USD'
  | 'BOUND_REDEEM_ADDRESS'
  | 'ID_HEX'
  | 'IS_BIDDING'
  | 'IS_CURRENT_AUTHORITY'
  | 'IS_CURRENT_BACKUP'
  | 'IS_KEYHOLDER'
  | 'IS_ONLINE'
  | 'IS_QUALIFIED'
  | 'LOCKED_BALANCE'
  | 'LOCKED_BALANCE_VALUE_USD'
  | 'MAX_BID'
  | 'MAX_BID_VALUE_USD'
  | 'REPUTATION_POINTS'
  | 'ROLE'
  | 'TOTAL_BALANCE'
  | 'TOTAL_BALANCE_VALUE_USD'
  | 'TOTAL_BID'
  | 'TOTAL_BID_VALUE_USD'
  | 'UNLOCKED_BALANCE'
  | 'UNLOCKED_BALANCE_VALUE_USD'
  | 'UPCOMING_APY_BP';

export type ValidatorHavingAverageInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingDistinctCountInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Validator` aggregates. */
export type ValidatorHavingInput = {
  AND?: InputMaybe<Array<ValidatorHavingInput>>;
  OR?: InputMaybe<Array<ValidatorHavingInput>>;
  average?: InputMaybe<ValidatorHavingAverageInput>;
  distinctCount?: InputMaybe<ValidatorHavingDistinctCountInput>;
  max?: InputMaybe<ValidatorHavingMaxInput>;
  min?: InputMaybe<ValidatorHavingMinInput>;
  stddevPopulation?: InputMaybe<ValidatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ValidatorHavingStddevSampleInput>;
  sum?: InputMaybe<ValidatorHavingSumInput>;
  variancePopulation?: InputMaybe<ValidatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ValidatorHavingVarianceSampleInput>;
};

export type ValidatorHavingMaxInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingMinInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingStddevPopulationInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingStddevSampleInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingSumInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingVariancePopulationInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingVarianceSampleInput = {
  accountBid?: InputMaybe<HavingBigfloatFilter>;
  accountBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  apyBp?: InputMaybe<HavingIntFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  bidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  lockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxBid?: InputMaybe<HavingBigfloatFilter>;
  maxBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  totalBalance?: InputMaybe<HavingBigfloatFilter>;
  totalBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  totalBid?: InputMaybe<HavingBigfloatFilter>;
  totalBidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
  unlockedBalanceValueUsd?: InputMaybe<HavingBigfloatFilter>;
  upcomingApyBp?: InputMaybe<HavingIntFilter>;
};

export type ValidatorMaxAggregates = {
  __typename?: 'ValidatorMaxAggregates';
  /** Maximum of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Maximum of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['Int']['output']>;
};

export type ValidatorMinAggregates = {
  __typename?: 'ValidatorMinAggregates';
  /** Minimum of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Minimum of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['Int']['output']>;
};

export type ValidatorStddevPopulationAggregates = {
  __typename?: 'ValidatorStddevPopulationAggregates';
  /** Population standard deviation of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorStddevSampleAggregates = {
  __typename?: 'ValidatorStddevSampleAggregates';
  /** Sample standard deviation of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorSumAggregates = {
  __typename?: 'ValidatorSumAggregates';
  /** Sum of accountBid across the matching connection */
  accountBid: Scalars['BigFloat']['output'];
  /** Sum of accountBidValueUsd across the matching connection */
  accountBidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of apyBp across the matching connection */
  apyBp: Scalars['BigInt']['output'];
  /** Sum of bid across the matching connection */
  bid: Scalars['BigFloat']['output'];
  /** Sum of bidValueUsd across the matching connection */
  bidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of lockedBalance across the matching connection */
  lockedBalance: Scalars['BigFloat']['output'];
  /** Sum of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of maxBid across the matching connection */
  maxBid: Scalars['BigFloat']['output'];
  /** Sum of maxBidValueUsd across the matching connection */
  maxBidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of reputationPoints across the matching connection */
  reputationPoints: Scalars['BigInt']['output'];
  /** Sum of totalBalance across the matching connection */
  totalBalance: Scalars['BigFloat']['output'];
  /** Sum of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of totalBid across the matching connection */
  totalBid: Scalars['BigFloat']['output'];
  /** Sum of totalBidValueUsd across the matching connection */
  totalBidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of unlockedBalance across the matching connection */
  unlockedBalance: Scalars['BigFloat']['output'];
  /** Sum of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd: Scalars['BigFloat']['output'];
  /** Sum of upcomingApyBp across the matching connection */
  upcomingApyBp: Scalars['BigInt']['output'];
};

/** A filter to be used against many `OperatorValidator` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyOperatorValidatorFilter = {
  /** Aggregates across related `OperatorValidator` match the filter criteria. */
  aggregates?: InputMaybe<OperatorValidatorAggregatesFilter>;
  /** Every related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorValidatorFilter>;
  /** No related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorValidatorFilter>;
  /** Some related `OperatorValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorValidatorFilter>;
};

export type ValidatorVariancePopulationAggregates = {
  __typename?: 'ValidatorVariancePopulationAggregates';
  /** Population variance of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorVarianceSampleAggregates = {
  __typename?: 'ValidatorVarianceSampleAggregates';
  /** Sample variance of accountBid across the matching connection */
  accountBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of accountBidValueUsd across the matching connection */
  accountBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of bidValueUsd across the matching connection */
  bidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lockedBalanceValueUsd across the matching connection */
  lockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBid across the matching connection */
  maxBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBidValueUsd across the matching connection */
  maxBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalance across the matching connection */
  totalBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalanceValueUsd across the matching connection */
  totalBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBid across the matching connection */
  totalBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBidValueUsd across the matching connection */
  totalBidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unlockedBalanceValueUsd across the matching connection */
  unlockedBalanceValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of upcomingApyBp across the matching connection */
  upcomingApyBp?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Validator` values. */
export type ValidatorsConnection = {
  __typename?: 'ValidatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ValidatorAggregates>;
  /** A list of edges which contains the `Validator` and cursor to aid in pagination. */
  edges: Array<ValidatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ValidatorAggregates>>;
  /** A list of `Validator` objects. */
  nodes: Array<Validator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Validator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Validator` values. */
export type ValidatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ValidatorGroupBy>;
  having?: InputMaybe<ValidatorHavingInput>;
};

/** A `Validator` edge in the connection. */
export type ValidatorsEdge = {
  __typename?: 'ValidatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Validator` at the end of the edge. */
  node: Validator;
};

/** Methods to use when ordering `Validator`. */
export type ValidatorsOrderBy =
  | 'ACCOUNT_BID_ASC'
  | 'ACCOUNT_BID_DESC'
  | 'ACCOUNT_BID_VALUE_USD_ASC'
  | 'ACCOUNT_BID_VALUE_USD_DESC'
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'APY_BP_ASC'
  | 'APY_BP_DESC'
  | 'BID_ASC'
  | 'BID_DESC'
  | 'BID_VALUE_USD_ASC'
  | 'BID_VALUE_USD_DESC'
  | 'BOUND_REDEEM_ADDRESS_ASC'
  | 'BOUND_REDEEM_ADDRESS_DESC'
  | 'ID_HEX_ASC'
  | 'ID_HEX_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'IS_BIDDING_ASC'
  | 'IS_BIDDING_DESC'
  | 'IS_CURRENT_AUTHORITY_ASC'
  | 'IS_CURRENT_AUTHORITY_DESC'
  | 'IS_CURRENT_BACKUP_ASC'
  | 'IS_CURRENT_BACKUP_DESC'
  | 'IS_KEYHOLDER_ASC'
  | 'IS_KEYHOLDER_DESC'
  | 'IS_ONLINE_ASC'
  | 'IS_ONLINE_DESC'
  | 'IS_QUALIFIED_ASC'
  | 'IS_QUALIFIED_DESC'
  | 'LOCKED_BALANCE_ASC'
  | 'LOCKED_BALANCE_DESC'
  | 'LOCKED_BALANCE_VALUE_USD_ASC'
  | 'LOCKED_BALANCE_VALUE_USD_DESC'
  | 'MAX_BID_ASC'
  | 'MAX_BID_DESC'
  | 'MAX_BID_VALUE_USD_ASC'
  | 'MAX_BID_VALUE_USD_DESC'
  | 'NATURAL'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_AVERAGE_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_COUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_COUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_OPERATOR_ID_SS58_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_VALIDATOR_ID_SS58_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_DISTINCT_COUNT_VALIDATOR_ID_SS58_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MAX_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_MIN_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_STDDEV_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_SUM_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_POPULATION_UPCOMING_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_ACTIVE_AMOUNT_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_BOND_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_BOND_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_TOTAL_BALANCE_DESC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_ASC'
  | 'OPERATOR_VALIDATORS_BY_VALIDATOR_ID_SS58_VARIANCE_SAMPLE_UPCOMING_AMOUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REPUTATION_POINTS_ASC'
  | 'REPUTATION_POINTS_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'TOTAL_BALANCE_ASC'
  | 'TOTAL_BALANCE_DESC'
  | 'TOTAL_BALANCE_VALUE_USD_ASC'
  | 'TOTAL_BALANCE_VALUE_USD_DESC'
  | 'TOTAL_BID_ASC'
  | 'TOTAL_BID_DESC'
  | 'TOTAL_BID_VALUE_USD_ASC'
  | 'TOTAL_BID_VALUE_USD_DESC'
  | 'UNLOCKED_BALANCE_ASC'
  | 'UNLOCKED_BALANCE_DESC'
  | 'UNLOCKED_BALANCE_VALUE_USD_ASC'
  | 'UNLOCKED_BALANCE_VALUE_USD_DESC'
  | 'UPCOMING_APY_BP_ASC'
  | 'UPCOMING_APY_BP_DESC';

export type _PrismaMigration = Node & {
  __typename?: '_PrismaMigration';
  appliedStepsCount: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  migrationName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt: Scalars['Datetime']['output'];
};

export type _PrismaMigrationAggregates = {
  __typename?: '_PrismaMigrationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<_PrismaMigrationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<_PrismaMigrationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<_PrismaMigrationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<_PrismaMigrationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<_PrismaMigrationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<_PrismaMigrationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<_PrismaMigrationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<_PrismaMigrationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<_PrismaMigrationVarianceSampleAggregates>;
};

export type _PrismaMigrationAverageAggregates = {
  __typename?: '_PrismaMigrationAverageAggregates';
  /** Mean average of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `_PrismaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type _PrismaMigrationCondition = {
  /** Checks for equality with the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logs` field. */
  logs?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `migrationName` field. */
  migrationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type _PrismaMigrationDistinctCountAggregates = {
  __typename?: '_PrismaMigrationDistinctCountAggregates';
  /** Distinct count of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of checksum across the matching connection */
  checksum?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of logs across the matching connection */
  logs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of migrationName across the matching connection */
  migrationName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `_PrismaMigration` object types. All fields are combined with a logical ‘and.’ */
export type _PrismaMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logs` field. */
  logs?: InputMaybe<StringFilter>;
  /** Filter by the object’s `migrationName` field. */
  migrationName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<_PrismaMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `_PrismaMigration` for usage during aggregation. */
export type _PrismaMigrationGroupBy =
  | 'APPLIED_STEPS_COUNT'
  | 'CHECKSUM'
  | 'FINISHED_AT'
  | 'FINISHED_AT_TRUNCATED_TO_DAY'
  | 'FINISHED_AT_TRUNCATED_TO_HOUR'
  | 'FINISHED_AT_TRUNCATED_TO_MONTH'
  | 'FINISHED_AT_TRUNCATED_TO_WEEK'
  | 'LOGS'
  | 'MIGRATION_NAME'
  | 'ROLLED_BACK_AT'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_DAY'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_HOUR'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_MONTH'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_WEEK'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT_TRUNCATED_TO_MONTH'
  | 'STARTED_AT_TRUNCATED_TO_WEEK';

export type _PrismaMigrationHavingAverageInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingDistinctCountInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `_PrismaMigration` aggregates. */
export type _PrismaMigrationHavingInput = {
  AND?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  OR?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  average?: InputMaybe<_PrismaMigrationHavingAverageInput>;
  distinctCount?: InputMaybe<_PrismaMigrationHavingDistinctCountInput>;
  max?: InputMaybe<_PrismaMigrationHavingMaxInput>;
  min?: InputMaybe<_PrismaMigrationHavingMinInput>;
  stddevPopulation?: InputMaybe<_PrismaMigrationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<_PrismaMigrationHavingStddevSampleInput>;
  sum?: InputMaybe<_PrismaMigrationHavingSumInput>;
  variancePopulation?: InputMaybe<_PrismaMigrationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<_PrismaMigrationHavingVarianceSampleInput>;
};

export type _PrismaMigrationHavingMaxInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingMinInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevPopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingSumInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVariancePopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVarianceSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationMaxAggregates = {
  __typename?: '_PrismaMigrationMaxAggregates';
  /** Maximum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationMinAggregates = {
  __typename?: '_PrismaMigrationMinAggregates';
  /** Minimum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationStddevPopulationAggregates = {
  __typename?: '_PrismaMigrationStddevPopulationAggregates';
  /** Population standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationStddevSampleAggregates = {
  __typename?: '_PrismaMigrationStddevSampleAggregates';
  /** Sample standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationSumAggregates = {
  __typename?: '_PrismaMigrationSumAggregates';
  /** Sum of appliedStepsCount across the matching connection */
  appliedStepsCount: Scalars['BigInt']['output'];
};

export type _PrismaMigrationVariancePopulationAggregates = {
  __typename?: '_PrismaMigrationVariancePopulationAggregates';
  /** Population variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationVarianceSampleAggregates = {
  __typename?: '_PrismaMigrationVarianceSampleAggregates';
  /** Sample variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnection = {
  __typename?: '_PrismaMigrationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<_PrismaMigrationAggregates>;
  /** A list of edges which contains the `_PrismaMigration` and cursor to aid in pagination. */
  edges: Array<_PrismaMigrationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<_PrismaMigrationAggregates>>;
  /** A list of `_PrismaMigration` objects. */
  nodes: Array<_PrismaMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `_PrismaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<_PrismaMigrationGroupBy>;
  having?: InputMaybe<_PrismaMigrationHavingInput>;
};

/** A `_PrismaMigration` edge in the connection. */
export type _PrismaMigrationsEdge = {
  __typename?: '_PrismaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `_PrismaMigration` at the end of the edge. */
  node: _PrismaMigration;
};

/** Methods to use when ordering `_PrismaMigration`. */
export type _PrismaMigrationsOrderBy =
  | 'APPLIED_STEPS_COUNT_ASC'
  | 'APPLIED_STEPS_COUNT_DESC'
  | 'CHECKSUM_ASC'
  | 'CHECKSUM_DESC'
  | 'FINISHED_AT_ASC'
  | 'FINISHED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGS_ASC'
  | 'LOGS_DESC'
  | 'MIGRATION_NAME_ASC'
  | 'MIGRATION_NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLLED_BACK_AT_ASC'
  | 'ROLLED_BACK_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC';

export type GetBrokerAccountCacheDataQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetBrokerAccountCacheDataQuery = { __typename?: 'Query', broker?: { __typename?: 'BrokerAccount', flipBalance: string, idSs58: string, bondedFlipBalance?: string | null, brokerVaultDepositAddress?: string | null, registrationId?: number | null, withdrawalAddress?: string | null, delegateBrokerId?: string | null, earnedFeesUsdc: string, affiliates: { __typename?: 'BrokerAccountsConnection', nodes: Array<{ __typename?: 'BrokerAccount', registrationId?: number | null, idSs58: string, withdrawalAddress?: string | null }> } } | null };

export type GetBrokersBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokersBalancesQuery = { __typename?: 'Query', brokers?: { __typename?: 'BrokerAccountsConnection', nodes: Array<{ __typename?: 'BrokerAccount', flipBalance: string, idSs58: string, alias?: string | null }> } | null };

export type LpAccountWithBalancesFragment = { __typename?: 'LpAccount', idSs58: string, flipBalance: string, alias?: string | null, openOrders: any, earnedFeesValueUsd: string, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string, valueUsd: string, boostBalance: string, boostBalanceValueUsd: string, lendingSupplyBalance: string, lendingSupplyBalanceValueUsd: string, strategyBalance: string, strategyBalanceValueUsd: string, totalBalance: string, totalBalanceValueUsd: string, ordersValueUsd: string }> }, lpLoanAccountsByLpIdSs58: { __typename?: 'LpLoanAccountsConnection', nodes: Array<{ __typename?: 'LpLoanAccount', totalBorrowAmountUsd: string }> } };

export type GetCacheLiquidityQueryVariables = Exact<{
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCacheLiquidityQuery = { __typename?: 'Query', balances?: { __typename?: 'DepositBalancesConnection', groupedAggregates?: Array<{ __typename?: 'DepositBalanceAggregates', keys?: Array<string> | null, sum?: { __typename?: 'DepositBalanceSumAggregates', amount: string } | null }> | null } | null, boost?: { __typename?: 'BoostPoolsConnection', aggregates?: { __typename?: 'BoostPoolAggregates', sum?: { __typename?: 'BoostPoolSumAggregates', availableAmountValueUsd: string, unavailableAmountValueUsd: string } | null } | null } | null, strategies?: { __typename?: 'TradingStrategiesConnection', aggregates?: { __typename?: 'TradingStrategyAggregates', sum?: { __typename?: 'TradingStrategySumAggregates', quoteAssetBalanceUsd: string, baseAssetBalanceUsd: string } | null } | null } | null };

export type GetCirculatingSupplyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCirculatingSupplyQuery = { __typename?: 'Query', circulation?: { __typename?: 'Circulation', circulatingSupply: string, totalSupply: string } | null };

export type GetEnvironmentAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnvironmentAddressQuery = { __typename?: 'Query', environmentAddress?: { __typename?: 'EnvironmentAddress', keyManagerAddress: string, stateChainGatewayAddress: string } | null };

export type GetActiveCacheValidatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCacheValidatorsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null };

export type ValidatorsQueryVariables = Exact<{
  filter?: InputMaybe<ValidatorFilter>;
}>;


export type ValidatorsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null };

export type BoostChainflipBlocksDelayQueryQueryVariables = Exact<{
  chain?: InputMaybe<ChainflipChain>;
}>;


export type BoostChainflipBlocksDelayQueryQuery = { __typename?: 'Query', allBoostDelayChainflipBlocks?: { __typename?: 'BoostDelayChainflipBlocksConnection', nodes: Array<{ __typename?: 'BoostDelayChainflipBlock', chain: ChainflipChain, numBlocks: number }> } | null };

export type GetAllSupportedAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSupportedAssetsQuery = { __typename?: 'Query', assets?: { __typename?: 'SupportedAssetsConnection', nodes: Array<{ __typename?: 'SupportedAsset', id: ChainflipAsset }> } | null };

export type GetOraclePricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOraclePricesQuery = { __typename?: 'Query', prices?: { __typename?: 'OraclePricesConnection', nodes: Array<{ __typename?: 'OraclePrice', price: number, baseAsset: PriceAsset, status: OraclePriceStatus, updatedAtOracleTimestamp: string }> } | null };

export type GetLatestAuctionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestAuctionQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', minActiveBid?: string | null, startBlockNumber: number, endBlockNumber: number, currentHeight: number, redemptionPeriodAsPercentage: number, targetSetSize: number, authorityRotationEnabled: boolean, minBid: string, blockReward: string } | null, delegations?: { __typename?: 'DelegationsConnection', aggregates?: { __typename?: 'DelegationAggregates', sum?: { __typename?: 'DelegationSumAggregates', upcomingAmount: string } | null } | null } | null };

export type GetAllBoostPoolsCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBoostPoolsCacheQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, feeTierPips: number, asset: ChainflipAsset, availableAmount: string, availableAmountValueUsd: string, unavailableAmount: string, unavailableAmountValueUsd: string, boosters: { __typename?: 'BoostBalancesConnection', totalCount: number } }> } | null };

export type GetBoostPoolCacheQueryVariables = Exact<{
  chainflipAsset?: InputMaybe<ChainflipAsset>;
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBoostPoolCacheQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, asset: ChainflipAsset, availableAmount: string, unavailableAmount: string, availableAmountValueUsd: string, unavailableAmountValueUsd: string, balances: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', lpIdSs58: string, poolShare: number, availableAmount: string, unavailableAmount: string, availableAmountValueUsd: string, unavailableAmountValueUsd: string, boostPool: { __typename?: 'BoostPool', asset: ChainflipAsset } }> } }> } | null };

export type AllBoostBalancesForAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type AllBoostBalancesForAccountQuery = { __typename?: 'Query', balances?: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', availableAmountValueUsd: string, unavailableAmountValueUsd: string, unavailableAmount: string, availableAmount: string, poolShare: number, pool: { __typename?: 'BoostPool', id: number, asset: ChainflipAsset, feeTierPips: number, availableAmount: string, unavailableAmount: string } }> } | null };

export type GetAllBrokerAliasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBrokerAliasesQuery = { __typename?: 'Query', allBrokerAccounts?: { __typename?: 'BrokerAccountsConnection', nodes: Array<{ __typename?: 'BrokerAccount', idSs58: string, alias?: string | null }> } | null };

export type GetPendingDepositsQueryVariables = Exact<{
  address: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  asset: Scalars['String']['input'];
}>;


export type GetPendingDepositsQuery = { __typename?: 'Query', pendingDeposits: Array<{ __typename?: 'PendingDeposit', amount: string, txRef?: string | null } | null> };

export type OperatorInfoQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type OperatorInfoQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', minActiveBid?: string | null } | null, operator?: { __typename?: 'Operator', exceptionList: any, openDelegationEnabled: boolean, activeDelegationFeeBps: number, upcomingDelegationFeeBps: number, account: { __typename?: 'Account', alias?: string | null }, delegators: { __typename?: 'DelegationsConnection', nodes: Array<{ __typename?: 'Delegation', upcomingAmount: string, activeAmount: string, idSs58: string }> }, validators: { __typename?: 'OperatorValidatorsConnection', nodes: Array<{ __typename?: 'OperatorValidator', validator: { __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string } }> } } | null };

export type ValidatorsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidatorsByIdsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null };

export type AllOperatorsQueryVariables = Exact<{
  operators?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AllOperatorsQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', minActiveBid?: string | null, blockReward: string, endBlockNumber: number, currentHeight: number, activeBond: string } | null, upcomingAuthorities?: { __typename?: 'ValidatorsConnection', totalCount: number } | null, currentAuthorities?: { __typename?: 'ValidatorsConnection', totalCount: number } | null, operators?: { __typename?: 'OperatorsConnection', nodes: Array<{ __typename?: 'Operator', idSs58: string, activeDelegationFeeBps: number, upcomingDelegationFeeBps: number, openDelegationEnabled: boolean, exceptionList: any, account: { __typename?: 'Account', alias?: string | null }, currentDelegators: { __typename?: 'DelegationsConnection', nodes: Array<{ __typename?: 'Delegation', delegatorIdSs58: string }> }, upcomingAuthorities: { __typename?: 'OperatorValidatorsConnection', totalCount: number, aggregates?: { __typename?: 'OperatorValidatorAggregates', sum?: { __typename?: 'OperatorValidatorSumAggregates', upcomingAmount: string } | null } | null }, upcomingDelegatingValidators: { __typename?: 'OperatorValidatorsConnection', totalCount: number, aggregates?: { __typename?: 'OperatorValidatorAggregates', sum?: { __typename?: 'OperatorValidatorSumAggregates', upcomingAmount: string } | null } | null }, currentAuthorities: { __typename?: 'OperatorValidatorsConnection', totalCount: number, aggregates?: { __typename?: 'OperatorValidatorAggregates', sum?: { __typename?: 'OperatorValidatorSumAggregates', activeAmount: string } | null } | null }, allValidators: { __typename?: 'OperatorValidatorsConnection', totalCount: number, aggregates?: { __typename?: 'OperatorValidatorAggregates', sum?: { __typename?: 'OperatorValidatorSumAggregates', bond: string, totalBalance: string } | null } | null }, qualifiedValidators: { __typename?: 'OperatorValidatorsConnection', totalCount: number }, onlineValidators: { __typename?: 'OperatorValidatorsConnection', totalCount: number }, delegations: { __typename?: 'DelegationsConnection', nodes: Array<{ __typename?: 'Delegation', delegatorIdSs58: string, upcomingAmount: string, activeAmount: string }>, aggregates?: { __typename?: 'DelegationAggregates', sum?: { __typename?: 'DelegationSumAggregates', upcomingAmount: string, activeAmount: string } | null } | null } }> } | null };

export type GetRuntimeVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRuntimeVersionQuery = { __typename?: 'Query', allEnvironmentAddresses?: { __typename?: 'EnvironmentAddressesConnection', nodes: Array<{ __typename?: 'EnvironmentAddress', runtimeVersion: number }> } | null };

export type GetBitcoinBoostSafeModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBitcoinBoostSafeModeQuery = { __typename?: 'Query', allBoostSafeModes?: { __typename?: 'BoostSafeModesConnection', nodes: Array<{ __typename?: 'BoostSafeMode', boostDepositsEnabled: boolean }> } | null };

export type BannerStatusQueryVariables = Exact<{
  app: App;
}>;


export type BannerStatusQuery = { __typename?: 'Query', banner?: { __typename?: 'BannersConnection', nodes: Array<{ __typename?: 'Banner', message: string, type: BannerType, linkUrl?: string | null, linkText?: string | null }> } | null };

export type CacheValidatorFragment = { __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string };

export type GetAllLpLoanAccountsQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllLpLoanAccountsQuery = { __typename?: 'Query', loanAccounts?: { __typename?: 'LpLoanAccountsConnection', nodes: Array<{ __typename?: 'LpLoanAccount', lpIdSs58: string, borrowPowerUsedBps: number, loanToValueBps: number, totalBorrowAmountUsd: string, totalCollateralBalanceUsd: string, collateralBalances: { __typename?: 'LpCollateralBalancesConnection', nodes: Array<{ __typename?: 'LpCollateralBalance', amountUsd: string, amount: string, asset: ChainflipAsset }> }, loans: { __typename?: 'LoansConnection', nodes: Array<{ __typename?: 'Loan', id: string, asset: ChainflipAsset, principalAmount: string, principalAmountUsd: string, status: LoanStatus, lp?: { __typename?: 'LpLoanAccount', lpIdSs58: string } | null }> } }> } | null };

export type GetLendingGlobalConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLendingGlobalConfigQuery = { __typename?: 'Query', config?: { __typename?: 'LendingGlobalConfig', targetLtvThresholdBps: number, softLiquidationLtvThresholdBps: number, minLoanUpdateAmountUsd: string, minLoanRequestAmountUsd: string, lowLtvPenaltyMaxLtvBps?: number | null, lowLtvPenaltyBpsAtMaxLtv?: number | null, minSupplyAmountUsd: string, interestFeeNetworkShareBps: number } | null };

export type GetAllLpLendingBalancesQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllLpLendingBalancesQuery = { __typename?: 'Query', lpPositions?: { __typename?: 'LpLendingBalancesConnection', nodes: Array<{ __typename?: 'LpLendingBalance', lpIdSs58: string, asset: ChainflipAsset, totalAmount: string, totalAmountUsd: string, totalAvailableAmount: string, totalAvailableAmountUsd: string, poolSharePercent: number }> } | null };

export type GetAllLpCollateralBalancesQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllLpCollateralBalancesQuery = { __typename?: 'Query', collateralBalances?: { __typename?: 'LpCollateralBalancesConnection', agg?: { __typename?: 'LpCollateralBalanceAggregates', sum?: { __typename?: 'LpCollateralBalanceSumAggregates', amountUsd: string } | null } | null } | null };

export type GetAllLendingPoolsQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
}>;


export type GetAllLendingPoolsQuery = { __typename?: 'Query', lendingPools?: { __typename?: 'LendingPoolsConnection', nodes: Array<{ __typename?: 'LendingPool', asset: ChainflipAsset, totalAmount: string, totalAmountUsd: string, totalAvailableAmount: string, totalAvailableAmountUsd: string, totalBorrowedAmount: string, totalBorrowedAmountUsd: string, interestRateBps: number, utilisationRateBps: number, utilisationCapBps: number, originationFeeBps: number, liquidationFeeBps: number, interestAtZeroUtilisationBps: number, junctionUtilisationBps: number, interestAtJunctionBps: number, interestAtMaxUtilisationBps: number }> } | null };

export type GetActiveBoostLoansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveBoostLoansQuery = { __typename?: 'Query', loans?: { __typename?: 'LoansConnection', aggregates?: { __typename?: 'LoanAggregates', sum?: { __typename?: 'LoanSumAggregates', principalAmount: string } | null } | null } | null };

export type LendingPoolInfoFragment = { __typename?: 'LendingPool', asset: ChainflipAsset, totalAmount: string, totalAmountUsd: string, totalAvailableAmount: string, totalAvailableAmountUsd: string, totalBorrowedAmount: string, totalBorrowedAmountUsd: string, interestRateBps: number, utilisationRateBps: number, utilisationCapBps: number, originationFeeBps: number, liquidationFeeBps: number, interestAtZeroUtilisationBps: number, junctionUtilisationBps: number, interestAtJunctionBps: number, interestAtMaxUtilisationBps: number };

export type PoolFragment = { __typename?: 'Pool', id: number, baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, rangeOrderPrice: number };

export type GetFilteredLpAccountsWithBalancesQueryVariables = Exact<{
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredLpAccountsWithBalancesQuery = { __typename?: 'Query', lps?: { __typename?: 'LpAccountsConnection', totalCount: number, nodes: Array<{ __typename?: 'LpAccount', arbitrumRefundAddress?: string | null, assethubRefundAddress?: string | null, bitcoinRefundAddress?: string | null, ethereumRefundAddress?: string | null, solanaRefundAddress?: string | null, tronRefundAddress?: string | null, bscRefundAddress?: string | null, openOrders: any, idSs58: string, flipBalance: string, alias?: string | null, earnedFeesValueUsd: string, strategy: { __typename?: 'TradingStrategiesConnection', aggregates?: { __typename?: 'TradingStrategyAggregates', sum?: { __typename?: 'TradingStrategySumAggregates', quoteAssetBalanceUsd: string, baseAssetBalanceUsd: string } | null } | null }, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string, valueUsd: string, boostBalance: string, boostBalanceValueUsd: string, lendingSupplyBalance: string, lendingSupplyBalanceValueUsd: string, strategyBalance: string, strategyBalanceValueUsd: string, totalBalance: string, totalBalanceValueUsd: string, ordersValueUsd: string }> }, lpLoanAccountsByLpIdSs58: { __typename?: 'LpLoanAccountsConnection', nodes: Array<{ __typename?: 'LpLoanAccount', totalBorrowAmountUsd: string }> } }> } | null, pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', id: number, baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, rangeOrderPrice: number }> } | null };

export type GetLpAccountWithBalancesQueryVariables = Exact<{
  lpIdSs58: Scalars['String']['input'];
}>;


export type GetLpAccountWithBalancesQuery = { __typename?: 'Query', lpAccount?: { __typename?: 'LpAccount', arbitrumRefundAddress?: string | null, assethubRefundAddress?: string | null, bitcoinRefundAddress?: string | null, ethereumRefundAddress?: string | null, solanaRefundAddress?: string | null, tronRefundAddress?: string | null, bscRefundAddress?: string | null, openOrders: any, idSs58: string, flipBalance: string, alias?: string | null, earnedFeesValueUsd: string, strategy: { __typename?: 'TradingStrategiesConnection', aggregates?: { __typename?: 'TradingStrategyAggregates', sum?: { __typename?: 'TradingStrategySumAggregates', quoteAssetBalanceUsd: string, baseAssetBalanceUsd: string } | null } | null }, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string, valueUsd: string, boostBalance: string, boostBalanceValueUsd: string, lendingSupplyBalance: string, lendingSupplyBalanceValueUsd: string, strategyBalance: string, strategyBalanceValueUsd: string, totalBalance: string, totalBalanceValueUsd: string, ordersValueUsd: string }> }, lpLoanAccountsByLpIdSs58: { __typename?: 'LpLoanAccountsConnection', nodes: Array<{ __typename?: 'LpLoanAccount', totalBorrowAmountUsd: string }> } } | null, pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', id: number, baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, rangeOrderPrice: number }> } | null };

export type GetFilteredLpAccountsWithBalancesV2QueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredLpAccountsWithBalancesV2Query = { __typename?: 'Query', lps?: { __typename?: 'LpAccountsConnection', totalCount: number, nodes: Array<{ __typename?: 'LpAccount', idSs58: string, flipBalance: string, alias?: string | null, openOrders: any, earnedFeesValueUsd: string, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string, valueUsd: string, boostBalance: string, boostBalanceValueUsd: string, lendingSupplyBalance: string, lendingSupplyBalanceValueUsd: string, strategyBalance: string, strategyBalanceValueUsd: string, totalBalance: string, totalBalanceValueUsd: string, ordersValueUsd: string }> }, lpLoanAccountsByLpIdSs58: { __typename?: 'LpLoanAccountsConnection', nodes: Array<{ __typename?: 'LpLoanAccount', totalBorrowAmountUsd: string }> } }> } | null };

export type GetCachePoolsQueryVariables = Exact<{
  baseAsset?: InputMaybe<ChainflipAsset>;
}>;


export type GetCachePoolsQuery = { __typename?: 'Query', pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, buyPrice: number, rangeOrderPrice: number, baseLiquidityAmount: string, quoteLiquidityAmount: string, liquidityFeeHundredthPips: number }> } | null };

export type GetCachePoolsWithOrderQueryVariables = Exact<{
  baseAsset?: InputMaybe<ChainflipAsset>;
}>;


export type GetCachePoolsWithOrderQuery = { __typename?: 'Query', pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, buyPrice: number, rangeOrderPrice: number, baseLiquidityAmount: string, quoteLiquidityAmount: string, liquidityFeeHundredthPips: number, openOrders?: any | null }> } | null };

export type GetTradingStrategyLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTradingStrategyLimitsQuery = { __typename?: 'Query', limits?: { __typename?: 'TradingStrategyLimitsConnection', nodes: Array<{ __typename?: 'TradingStrategyLimit', minimumDeploymentAmount: string, minimumAddedFundsAmount: string, asset: ChainflipAsset }> } | null };

export type GetValidatorByIdSs58QueryVariables = Exact<{
  validatorId: Scalars['String']['input'];
}>;


export type GetValidatorByIdSs58Query = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string, operatorLinks: { __typename?: 'OperatorValidatorsConnection', nodes: Array<{ __typename?: 'OperatorValidator', operatorIdSs58: string }> } }> } | null };

export type GetAllEnvironmentAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEnvironmentAddressesQuery = { __typename?: 'Query', allEnvironmentAddresses?: { __typename?: 'EnvironmentAddressesConnection', nodes: Array<{ __typename?: 'EnvironmentAddress', redemptionTax: string }> } | null };

export type GetLatestFlipSupplyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestFlipSupplyQueryQuery = { __typename?: 'Query', flipSupply?: { __typename?: 'FlipSupply', totalIssuance: string, offchainFunds: string, annualSystemCompoundedRewards: string } | null };

export type ValidatorsWithMinActiveBidQueryVariables = Exact<{
  filter?: InputMaybe<ValidatorFilter>;
}>;


export type ValidatorsWithMinActiveBidQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', maxBid?: string | null, idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null, auction?: { __typename?: 'Auction', minActiveBid?: string | null } | null };

export type GetApyValidatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApyValidatorsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null };

export type GetValidatorsByAccountIdsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValidatorsByAccountIdsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string, totalBalance: string, lockedBalanceValueUsd: string, unlockedBalanceValueUsd: string, totalBalanceValueUsd: string, bid: string, bidValueUsd: string, accountBid: string, accountBidValueUsd: string, totalBid: string, totalBidValueUsd: string }> } | null };

export type GetCurrentAuthoritiesOnlineStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentAuthoritiesOnlineStatusQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idSs58: string, isOnline: boolean }> } | null };

export type GetLinkedAccountsQueryVariables = Exact<{
  ethAddress: Scalars['String']['input'];
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetLinkedAccountsQuery = { __typename?: 'Query', links?: { __typename?: 'AccountLinksConnection', nodes: Array<{ __typename?: 'AccountLink', accountIdSs58: string }> } | null, unregistered?: { __typename?: 'UnregisteredsConnection', nodes: Array<{ __typename?: 'Unregistered', idSs58: string }> } | null };

export type GetOnlineAuthorityCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnlineAuthorityCountsQuery = { __typename?: 'Query', authorities?: { __typename?: 'ValidatorsConnection', totalCount: number } | null, online?: { __typename?: 'ValidatorsConnection', totalCount: number } | null };

export const LpAccountWithBalancesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalance"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"ordersValueUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lpLoanAccountsByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBorrowAmountUsd"}}]}}]}}]}}]} as unknown as DocumentNode<LpAccountWithBalancesFragment, unknown>;
export const CacheValidatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<CacheValidatorFragment, unknown>;
export const LendingPoolInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LendingPoolInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LendingPool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBorrowedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalBorrowedAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"interestRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"utilisationRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"utilisationCapBps"}},{"kind":"Field","name":{"kind":"Name","value":"originationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtZeroUtilisationBps"}},{"kind":"Field","name":{"kind":"Name","value":"junctionUtilisationBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtJunctionBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtMaxUtilisationBps"}}]}}]} as unknown as DocumentNode<LendingPoolInfoFragment, unknown>;
export const PoolFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pool"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}}]}}]} as unknown as DocumentNode<PoolFragment, unknown>;
export const GetBrokerAccountCacheDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokerAccountCacheData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerAccountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"bondedFlipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"brokerVaultDepositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"delegateBrokerId"}},{"kind":"Field","alias":{"kind":"Name","value":"affiliates"},"name":{"kind":"Name","value":"brokerAccountsByDelegateBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesUsdc"}}]}}]}}]} as unknown as DocumentNode<GetBrokerAccountCacheDataQuery, GetBrokerAccountCacheDataQueryVariables>;
export const GetBrokersBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokersBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"brokers"},"name":{"kind":"Name","value":"allBrokerAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokersBalancesQuery, GetBrokersBalancesQueryVariables>;
export const GetCacheLiquidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCacheLiquidity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"allDepositBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strategies"},"name":{"kind":"Name","value":"allTradingStrategies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteAssetBalanceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseAssetBalanceUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCacheLiquidityQuery, GetCacheLiquidityQueryVariables>;
export const GetCirculatingSupplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCirculatingSupply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"circulation"},"name":{"kind":"Name","value":"circulationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circulatingSupply"}},{"kind":"Field","name":{"kind":"Name","value":"totalSupply"}}]}}]}}]} as unknown as DocumentNode<GetCirculatingSupplyQuery, GetCirculatingSupplyQueryVariables>;
export const GetEnvironmentAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnvironmentAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"environmentAddress"},"name":{"kind":"Name","value":"environmentAddressById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyManagerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"stateChainGatewayAddress"}}]}}]}}]} as unknown as DocumentNode<GetEnvironmentAddressQuery, GetEnvironmentAddressQueryVariables>;
export const GetActiveCacheValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveCacheValidators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentAuthority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentBackup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<GetActiveCacheValidatorsQuery, GetActiveCacheValidatorsQueryVariables>;
export const ValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Validators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidatorFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<ValidatorsQuery, ValidatorsQueryVariables>;
export const BoostChainflipBlocksDelayQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoostChainflipBlocksDelayQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipChain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBoostDelayChainflipBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"numBlocks"}}]}}]}}]}}]} as unknown as DocumentNode<BoostChainflipBlocksDelayQueryQuery, BoostChainflipBlocksDelayQueryQueryVariables>;
export const GetAllSupportedAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllSupportedAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assets"},"name":{"kind":"Name","value":"allSupportedAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllSupportedAssetsQuery, GetAllSupportedAssetsQueryVariables>;
export const GetOraclePricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOraclePrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"prices"},"name":{"kind":"Name","value":"allOraclePrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtOracleTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetOraclePricesQuery, GetOraclePricesQueryVariables>;
export const GetLatestAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestAuction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"auction"},"name":{"kind":"Name","value":"auctionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minActiveBid"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currentHeight"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionPeriodAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"targetSetSize"}},{"kind":"Field","name":{"kind":"Name","value":"authorityRotationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"minBid"}},{"kind":"Field","name":{"kind":"Name","value":"blockReward"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"allDelegations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestAuctionQuery, GetLatestAuctionQueryVariables>;
export const GetAllBoostPoolsCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllBoostPoolsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"boosters"},"name":{"kind":"Name","value":"boostBalancesByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBoostPoolsCacheQuery, GetAllBoostPoolsCacheQueryVariables>;
export const GetBoostPoolCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostPoolCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chainflipAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chainflipAsset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"boostBalancesByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpIdSs58"}},{"kind":"Field","name":{"kind":"Name","value":"poolShare"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"boostPool"},"name":{"kind":"Name","value":"boostPoolByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostPoolCacheQuery, GetBoostPoolCacheQueryVariables>;
export const AllBoostBalancesForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllBoostBalancesForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"allBoostBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"poolShare"}}]}}]}}]}}]} as unknown as DocumentNode<AllBoostBalancesForAccountQuery, AllBoostBalancesForAccountQueryVariables>;
export const GetAllBrokerAliasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllBrokerAliases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBrokerAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBrokerAliasesQuery, GetAllBrokerAliasesQueryVariables>;
export const GetPendingDepositsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPendingDeposits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"txRef"}}]}}]}}]} as unknown as DocumentNode<GetPendingDepositsQuery, GetPendingDepositsQueryVariables>;
export const OperatorInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OperatorInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"auction"},"name":{"kind":"Name","value":"auctionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minActiveBid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exceptionList"}},{"kind":"Field","name":{"kind":"Name","value":"openDelegationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"activeDelegationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingDelegationFeeBps"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegators"},"name":{"kind":"Name","value":"delegationsByOperatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"activeAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"idSs58"},"name":{"kind":"Name","value":"delegatorIdSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<OperatorInfoQuery, OperatorInfoQueryVariables>;
export const ValidatorsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidatorsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<ValidatorsByIdsQuery, ValidatorsByIdsQueryVariables>;
export const AllOperatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllOperators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"auction"},"name":{"kind":"Name","value":"auctionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minActiveBid"}},{"kind":"Field","name":{"kind":"Name","value":"blockReward"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currentHeight"}},{"kind":"Field","name":{"kind":"Name","value":"activeBond"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingAuthorities"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"upcomingApyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentAuthorities"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"apyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operators"},"name":{"kind":"Name","value":"allOperators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operators"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"activeDelegationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingDelegationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"openDelegationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"exceptionList"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentDelegators"},"name":{"kind":"Name","value":"delegationsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activeAmount"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegatorIdSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingAuthorities"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"upcomingApyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingDelegatingValidators"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"upcomingApyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isQualified"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentAuthorities"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"apyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAmount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allValidators"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"qualifiedValidators"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isQualified"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onlineValidators"},"name":{"kind":"Name","value":"operatorValidatorsByOperatorIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isOnline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"delegationsByOperatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delegatorIdSs58"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"activeAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"activeAmount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllOperatorsQuery, AllOperatorsQueryVariables>;
export const GetRuntimeVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuntimeVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runtimeVersion"}}]}}]}}]}}]} as unknown as DocumentNode<GetRuntimeVersionQuery, GetRuntimeVersionQueryVariables>;
export const GetBitcoinBoostSafeModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBitcoinBoostSafeMode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBoostSafeModes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"Bitcoin"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boostDepositsEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<GetBitcoinBoostSafeModeQuery, GetBitcoinBoostSafeModeQueryVariables>;
export const BannerStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BannerStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"App"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"banner"},"name":{"kind":"Name","value":"allBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"ALL"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}}]}}]}}]}}]} as unknown as DocumentNode<BannerStatusQuery, BannerStatusQueryVariables>;
export const GetAllLpLoanAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLpLoanAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loanAccounts"},"name":{"kind":"Name","value":"allLpLoanAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpIdSs58"}},{"kind":"Field","name":{"kind":"Name","value":"borrowPowerUsedBps"}},{"kind":"Field","name":{"kind":"Name","value":"loanToValueBps"}},{"kind":"Field","name":{"kind":"Name","value":"totalBorrowAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalCollateralBalanceUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"collateralBalances"},"name":{"kind":"Name","value":"lpCollateralBalancesByLoanAccountLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loans"},"name":{"kind":"Name","value":"loansByLoanAccountLpIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"lpLoanAccountByLoanAccountLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpIdSs58"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"principalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"principalAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLpLoanAccountsQuery, GetAllLpLoanAccountsQueryVariables>;
export const GetLendingGlobalConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingGlobalConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"config"},"name":{"kind":"Name","value":"lendingGlobalConfigById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetLtvThresholdBps"}},{"kind":"Field","name":{"kind":"Name","value":"softLiquidationLtvThresholdBps"}},{"kind":"Field","name":{"kind":"Name","value":"minLoanUpdateAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"minLoanRequestAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lowLtvPenaltyMaxLtvBps"}},{"kind":"Field","name":{"kind":"Name","value":"lowLtvPenaltyBpsAtMaxLtv"}},{"kind":"Field","name":{"kind":"Name","value":"minSupplyAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"interestFeeNetworkShareBps"}}]}}]}}]} as unknown as DocumentNode<GetLendingGlobalConfigQuery, GetLendingGlobalConfigQueryVariables>;
export const GetAllLpLendingBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLpLendingBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lpPositions"},"name":{"kind":"Name","value":"allLpLendingBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpIdSs58"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"poolSharePercent"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLpLendingBalancesQuery, GetAllLpLendingBalancesQueryVariables>;
export const GetAllLpCollateralBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLpCollateralBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collateralBalances"},"name":{"kind":"Name","value":"allLpCollateralBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"loanAccountLpIdSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLpCollateralBalancesQuery, GetAllLpCollateralBalancesQueryVariables>;
export const GetAllLendingPoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLendingPools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lendingPools"},"name":{"kind":"Name","value":"allLendingPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LendingPoolInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LendingPoolInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LendingPool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAvailableAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBorrowedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalBorrowedAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"interestRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"utilisationRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"utilisationCapBps"}},{"kind":"Field","name":{"kind":"Name","value":"originationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtZeroUtilisationBps"}},{"kind":"Field","name":{"kind":"Name","value":"junctionUtilisationBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtJunctionBps"}},{"kind":"Field","name":{"kind":"Name","value":"interestAtMaxUtilisationBps"}}]}}]} as unknown as DocumentNode<GetAllLendingPoolsQuery, GetAllLendingPoolsQueryVariables>;
export const GetActiveBoostLoansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveBoostLoans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loans"},"name":{"kind":"Name","value":"allLoans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"borrowerType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"SYSTEM_BOOST"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"Btc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"principalAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveBoostLoansQuery, GetActiveBoostLoansQueryVariables>;
export const GetFilteredLpAccountsWithBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredLpAccountsWithBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lps"},"name":{"kind":"Name","value":"allLpAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LpAccountWithBalances"}},{"kind":"Field","name":{"kind":"Name","value":"arbitrumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"assethubRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bitcoinRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ethereumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"solanaRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tronRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bscRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","alias":{"kind":"Name","value":"strategy"},"name":{"kind":"Name","value":"tradingStrategiesByOwnerAccountIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteAssetBalanceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseAssetBalanceUsd"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pool"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalance"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"ordersValueUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lpLoanAccountsByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBorrowAmountUsd"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pool"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}}]}}]} as unknown as DocumentNode<GetFilteredLpAccountsWithBalancesQuery, GetFilteredLpAccountsWithBalancesQueryVariables>;
export const GetLpAccountWithBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpAccountWithBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"lpAccountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LpAccountWithBalances"}},{"kind":"Field","name":{"kind":"Name","value":"arbitrumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"assethubRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bitcoinRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ethereumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"solanaRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tronRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bscRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","alias":{"kind":"Name","value":"strategy"},"name":{"kind":"Name","value":"tradingStrategiesByOwnerAccountIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteAssetBalanceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseAssetBalanceUsd"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pool"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalance"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"ordersValueUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lpLoanAccountsByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBorrowAmountUsd"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pool"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}}]}}]} as unknown as DocumentNode<GetLpAccountWithBalancesQuery, GetLpAccountWithBalancesQueryVariables>;
export const GetFilteredLpAccountsWithBalancesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredLpAccountsWithBalancesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lps"},"name":{"kind":"Name","value":"allLpAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LpAccountWithBalances"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalance"}},{"kind":"Field","name":{"kind":"Name","value":"boostBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lendingSupplyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalance"}},{"kind":"Field","name":{"kind":"Name","value":"strategyBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"ordersValueUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lpLoanAccountsByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBorrowAmountUsd"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilteredLpAccountsWithBalancesV2Query, GetFilteredLpAccountsWithBalancesV2QueryVariables>;
export const GetCachePoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCachePools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baseLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeHundredthPips"}}]}}]}}]}}]} as unknown as DocumentNode<GetCachePoolsQuery, GetCachePoolsQueryVariables>;
export const GetCachePoolsWithOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCachePoolsWithOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baseLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeHundredthPips"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}}]}}]}}]}}]} as unknown as DocumentNode<GetCachePoolsWithOrderQuery, GetCachePoolsWithOrderQueryVariables>;
export const GetTradingStrategyLimitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTradingStrategyLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limits"},"name":{"kind":"Name","value":"allTradingStrategyLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimumDeploymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAddedFundsAmount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}}]}}]} as unknown as DocumentNode<GetTradingStrategyLimitsQuery, GetTradingStrategyLimitsQueryVariables>;
export const GetValidatorByIdSs58Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorByIdSs58"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}},{"kind":"Field","alias":{"kind":"Name","value":"operatorLinks"},"name":{"kind":"Name","value":"operatorValidatorsByValidatorIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorIdSs58"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<GetValidatorByIdSs58Query, GetValidatorByIdSs58QueryVariables>;
export const GetAllEnvironmentAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redemptionTax"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllEnvironmentAddressesQuery, GetAllEnvironmentAddressesQueryVariables>;
export const GetLatestFlipSupplyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestFlipSupplyQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flipSupply"},"name":{"kind":"Name","value":"flipSupplyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalIssuance"}},{"kind":"Field","name":{"kind":"Name","value":"offchainFunds"}},{"kind":"Field","name":{"kind":"Name","value":"annualSystemCompoundedRewards"}}]}}]}}]} as unknown as DocumentNode<GetLatestFlipSupplyQueryQuery, GetLatestFlipSupplyQueryQueryVariables>;
export const ValidatorsWithMinActiveBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidatorsWithMinActiveBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidatorFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}},{"kind":"Field","name":{"kind":"Name","value":"maxBid"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"auction"},"name":{"kind":"Name","value":"auctionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minActiveBid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<ValidatorsWithMinActiveBidQuery, ValidatorsWithMinActiveBidQueryVariables>;
export const GetApyValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApyValidators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"apyBp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TOTAL_BALANCE_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<GetApyValidatorsQuery, GetApyValidatorsQueryVariables>;
export const GetValidatorsByAccountIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorsByAccountIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalanceValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"accountBid"}},{"kind":"Field","name":{"kind":"Name","value":"accountBidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalBid"}},{"kind":"Field","name":{"kind":"Name","value":"totalBidValueUsd"}}]}}]} as unknown as DocumentNode<GetValidatorsByAccountIdsQuery, GetValidatorsByAccountIdsQueryVariables>;
export const GetCurrentAuthoritiesOnlineStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentAuthoritiesOnlineStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentAuthority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentAuthoritiesOnlineStatusQuery, GetCurrentAuthoritiesOnlineStatusQueryVariables>;
export const GetLinkedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkedAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ethAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"links"},"name":{"kind":"Name","value":"allAccountLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ethereumAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ethAddress"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountIdSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unregistered"},"name":{"kind":"Name","value":"allUnregistereds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>;
export const GetOnlineAuthorityCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnlineAuthorityCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"authorities"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentAuthority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"online"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentAuthority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isOnline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetOnlineAuthorityCountsQuery, GetOnlineAuthorityCountsQueryVariables>;